(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as DS, getPartnerDevApiHeaders as RS, WidgetContextProvider as OS, makeExecuteQuery as PS, makeUseLazyQuery as AS, makeUseQuery as LS, makeUseMutation as VS, validateApiHostName as kb, useTracking as bn, useWidgetContext as mn, hasDownstreamApiForbiddenError as Cm, hasDownstreamApiAuthorizationError as Fm, DisplayErrors as Fn, useCopyWithDelay as er, defaultDateFormat as dt, displayAttributeValue as bb, OAuthSettings as Mi, useData as Im, getWidgetConfigurationByIdQuery as _b, settingsToFormValues as zS, useWidgetSettingsMutations as US, PartnerHookFormSecretText as MS, WidgetSettingsFormFooter as BS, formValuesToSettings as qS, isDownstreamApiNotFoundError as HS, isDownstreamApiAuthorizationError as xb, KlaviyoSubscribeSetting as WS, isDownstreamApiPermissionError as KS, capitalizeFirstCharacter as $s, hasDownstreamApiTooManyRequestsError as GS, hasDownstreamApiPermissionError as Sb, hasDownstreamApiNotFoundError as no, getCountryNameFromCountryCode as YS, IntegrationModal as Nb, useInboundOAuthContext as JS, createWidgetConfigurationMutation as QS, updateWidgetConfigurationMutation as XS, deleteWidgetConfigurationMutation as ZS } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Ne, { useMemo as qn, useState as se, useEffect as qe, useRef as di, useCallback as tt, useReducer as e0, useLayoutEffect as n0, useContext as Em, createContext as jb, isValidElement as t0, createElement as r0, Fragment as i0 } from "react";
import { Text as A, FlexBox as b, Spinner as sn, Icon as ue, Tooltip as Ke, List as We, Badge as Un, Button as Kn, IconButton as Yt, Tag as An, NavigationButton as St, Select as xr, CollapseCard as sr, Box as Qn, Modal as Nt, ModalHead as jt, ModalBody as wt, FormGrid as Et, FormField as Qe, FieldWrapper as Pn, ModalFoot as Tt, InputText as br, Textarea as Ku, TagsInput as Ds, Switch as Gu, FieldLabel as a0, InputSelectionList as Yr, Banner as to, Image as Bi, Divider as Tm, SelectionList as ot, FieldText as lr, FieldTextarea as o0, CopyToClipboardButton as s0, getSelectionListContext as l0, Avatar as $m, Timestamp as c0, Attachment as d0, EmptyState as cs, Table as Xn, Checkbox as Gp, TextWithHighlight as u0, ErrorBoundaryContext as wb, FieldSwitch as Cb } from "@dixa/lib-shared-habla";
import { ApolloLink as Dm, Observable as Fb, ApolloClient as m0, InMemoryCache as p0, createHttpLink as f0, ApolloProvider as h0, useApolloClient as y0, ApolloConsumer as g0, NetworkStatus as Gt, useQuery as Ib, isApolloError as Eb, ApolloError as v0, gql as Rs, useMutation as Yp } from "@apollo/client";
import k0 from "cross-fetch";
import { config as Qa } from "lib-shared-backend-config";
import ut from "classnames";
import Ln from "moment";
import "moment-timezone";
import { __rest as b0, __assign as rl } from "tslib";
import { useLocation as _0 } from "react-router-dom";
function Rm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var go = { exports: {} }, Xi = {};
var Jp;
function x0() {
  if (Jp) return Xi;
  Jp = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Xi.Fragment = r, Xi.jsx = s, Xi.jsxs = s, Xi;
}
var Zi = {};
var Qp;
function S0() {
  return Qp || (Qp = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c, P));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Zi.Fragment = i, Zi.jsx = Rn, Zi.jsxs = Bn;
  })()), Zi;
}
var Xp;
function N0() {
  return Xp || (Xp = 1, process.env.NODE_ENV === "production" ? go.exports = x0() : go.exports = S0()), go.exports;
}
var ze = N0();
function Tb(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: j0 } = Object.prototype, { getPrototypeOf: Os } = Object, { iterator: Ps, toStringTag: $b } = Symbol, As = /* @__PURE__ */ ((e) => (n) => {
  const r = j0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Sr = (e) => (e = e.toLowerCase(), (n) => As(n) === e), Ls = (e) => (n) => typeof n === e, { isArray: qi } = Array, Li = Ls("undefined");
function ro(e) {
  return e !== null && !Li(e) && e.constructor !== null && !Li(e.constructor) && Ht(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Db = Sr("ArrayBuffer");
function w0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Db(e.buffer), n;
}
const C0 = Ls("string"), Ht = Ls("function"), Rb = Ls("number"), io = (e) => e !== null && typeof e == "object", F0 = (e) => e === !0 || e === !1, Ko = (e) => {
  if (As(e) !== "object")
    return !1;
  const n = Os(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !($b in e) && !(Ps in e);
}, I0 = (e) => {
  if (!io(e) || ro(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, E0 = Sr("Date"), T0 = Sr("File"), $0 = (e) => !!(e && typeof e.uri < "u"), D0 = (e) => e && typeof e.getParts < "u", R0 = Sr("Blob"), O0 = Sr("FileList"), P0 = (e) => io(e) && Ht(e.pipe);
function A0() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Zp = A0(), ef = typeof Zp.FormData < "u" ? Zp.FormData : void 0, L0 = (e) => {
  if (!e) return !1;
  if (ef && e instanceof ef) return !0;
  const n = Os(e);
  if (!n || n === Object.prototype || !Ht(e.append)) return !1;
  const r = As(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Ht(e.toString) && e.toString() === "[object FormData]";
}, V0 = Sr("URLSearchParams"), [z0, U0, M0, B0] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Sr), q0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ao(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), qi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (ro(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Ob(e, n) {
  if (ro(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const oi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Pb = (e) => !Li(e) && e !== oi;
function Yu() {
  const { caseless: e, skipUndefined: n } = Pb(this) && this || {}, r = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && Ob(r, o) || o;
    Ko(r[s]) && Ko(a) ? r[s] = Yu(r[s], a) : Ko(a) ? r[s] = Yu({}, a) : qi(a) ? r[s] = a.slice() : (!n || !Li(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && ao(arguments[a], i);
  return r;
}
const H0 = (e, n, r, { allOwnKeys: i } = {}) => (ao(
  n,
  (a, o) => {
    r && Ht(a) ? Object.defineProperty(e, o, {
      value: Tb(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), W0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), K0 = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, G0 = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Os(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, Y0 = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, J0 = (e) => {
  if (!e) return null;
  if (qi(e)) return e;
  let n = e.length;
  if (!Rb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, Q0 = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Os(Uint8Array)), X0 = (e, n) => {
  const i = (e && e[Ps]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, Z0 = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, eN = Sr("HTMLFormElement"), nN = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), nf = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), tN = Sr("RegExp"), Ab = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  ao(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, rN = (e) => {
  Ab(e, (n, r) => {
    if (Ht(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Ht(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, iN = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return qi(e) ? i(e) : i(String(e).split(n)), r;
}, aN = () => {
}, oN = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function sN(e) {
  return !!(e && Ht(e.append) && e[$b] === "FormData" && e[Ps]);
}
const lN = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (io(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (ro(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = qi(i) ? [] : {};
        return ao(i, (s, l) => {
          const d = r(s, a + 1);
          !Li(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, cN = Sr("AsyncFunction"), dN = (e) => e && (io(e) || Ht(e)) && Ht(e.then) && Ht(e.catch), Lb = ((e, n) => e ? setImmediate : n ? ((r, i) => (oi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === oi && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), oi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Ht(oi.postMessage)), uN = typeof queueMicrotask < "u" ? queueMicrotask.bind(oi) : typeof process < "u" && process.nextTick || Lb, mN = (e) => e != null && Ht(e[Ps]), ve = {
  isArray: qi,
  isArrayBuffer: Db,
  isBuffer: ro,
  isFormData: L0,
  isArrayBufferView: w0,
  isString: C0,
  isNumber: Rb,
  isBoolean: F0,
  isObject: io,
  isPlainObject: Ko,
  isEmptyObject: I0,
  isReadableStream: z0,
  isRequest: U0,
  isResponse: M0,
  isHeaders: B0,
  isUndefined: Li,
  isDate: E0,
  isFile: T0,
  isReactNativeBlob: $0,
  isReactNative: D0,
  isBlob: R0,
  isRegExp: tN,
  isFunction: Ht,
  isStream: P0,
  isURLSearchParams: V0,
  isTypedArray: Q0,
  isFileList: O0,
  forEach: ao,
  merge: Yu,
  extend: H0,
  trim: q0,
  stripBOM: W0,
  inherits: K0,
  toFlatObject: G0,
  kindOf: As,
  kindOfTest: Sr,
  endsWith: Y0,
  toArray: J0,
  forEachEntry: X0,
  matchAll: Z0,
  isHTMLForm: eN,
  hasOwnProperty: nf,
  hasOwnProp: nf,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ab,
  freezeMethods: rN,
  toObjectSet: iN,
  toCamelCase: nN,
  noop: aN,
  toFiniteNumber: oN,
  findKey: Ob,
  global: oi,
  isContextDefined: Pb,
  isSpecCompliantForm: sN,
  toJSONObject: lN,
  isAsyncFn: cN,
  isThenable: dN,
  setImmediate: Lb,
  asap: uN,
  isIterable: mN
};
let fn = class Vb extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Vb(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ve.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
fn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
fn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
fn.ECONNABORTED = "ECONNABORTED";
fn.ETIMEDOUT = "ETIMEDOUT";
fn.ERR_NETWORK = "ERR_NETWORK";
fn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
fn.ERR_DEPRECATED = "ERR_DEPRECATED";
fn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
fn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
fn.ERR_CANCELED = "ERR_CANCELED";
fn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
fn.ERR_INVALID_URL = "ERR_INVALID_URL";
fn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const pN = null;
function Ju(e) {
  return ve.isPlainObject(e) || ve.isArray(e);
}
function zb(e) {
  return ve.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function il(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = zb(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function fN(e) {
  return ve.isArray(e) && !e.some(Ju);
}
const hN = ve.toFlatObject(ve, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Vs(e, n, r) {
  if (!ve.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ve.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(N, C) {
      return !ve.isUndefined(C[N]);
    }
  );
  const i = r.metaTokens, a = r.visitor || f, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? 100 : r.maxDepth, m = l && ve.isSpecCompliantForm(n);
  if (!ve.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(S) {
    if (S === null) return "";
    if (ve.isDate(S))
      return S.toISOString();
    if (ve.isBoolean(S))
      return S.toString();
    if (!m && ve.isBlob(S))
      throw new fn("Blob is not supported. Use a Buffer instead.");
    return ve.isArrayBuffer(S) || ve.isTypedArray(S) ? m && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function f(S, N, C) {
    let y = S;
    if (ve.isReactNative(n) && ve.isReactNativeBlob(S))
      return n.append(il(C, N, o), u(S)), !1;
    if (S && !C && typeof S == "object") {
      if (ve.endsWith(N, "{}"))
        N = i ? N : N.slice(0, -2), S = JSON.stringify(S);
      else if (ve.isArray(S) && fN(S) || (ve.isFileList(S) || ve.endsWith(N, "[]")) && (y = ve.toArray(S)))
        return N = zb(N), y.forEach(function(T, E) {
          !(ve.isUndefined(T) || T === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? il([N], E, o) : s === null ? N : N + "[]",
            u(T)
          );
        }), !1;
    }
    return Ju(S) ? !0 : (n.append(il(C, N, o), u(S)), !1);
  }
  const h = [], v = Object.assign(hN, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: Ju
  });
  function F(S, N, C = 0) {
    if (!ve.isUndefined(S)) {
      if (C > d)
        throw new fn(
          "Object is too deeply nested (" + C + " levels). Max depth: " + d,
          fn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      h.push(S), ve.forEach(S, function(H, T) {
        (!(ve.isUndefined(H) || H === null) && a.call(n, H, ve.isString(T) ? T.trim() : T, N, v)) === !0 && F(H, N ? N.concat(T) : [T], C + 1);
      }), h.pop();
    }
  }
  if (!ve.isObject(e))
    throw new TypeError("data must be an object");
  return F(e), n;
}
function tf(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Om(e, n) {
  this._pairs = [], e && Vs(e, this, n);
}
const Ub = Om.prototype;
Ub.append = function(n, r) {
  this._pairs.push([n, r]);
};
Ub.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, tf);
  } : tf;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function yN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Mb(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || yN, a = ve.isFunction(r) ? {
    serialize: r
  } : r, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = ve.isURLSearchParams(n) ? n.toString() : new Om(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class rf {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ve.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Pm = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, gN = typeof URLSearchParams < "u" ? URLSearchParams : Om, vN = typeof FormData < "u" ? FormData : null, kN = typeof Blob < "u" ? Blob : null, bN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: gN,
    FormData: vN,
    Blob: kN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Am = typeof window < "u" && typeof document < "u", Qu = typeof navigator == "object" && navigator || void 0, _N = Am && (!Qu || ["ReactNative", "NativeScript", "NS"].indexOf(Qu.product) < 0), xN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", SN = Am && window.location.href || "http://localhost", NN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Am,
  hasStandardBrowserEnv: _N,
  hasStandardBrowserWebWorkerEnv: xN,
  navigator: Qu,
  origin: SN
}, Symbol.toStringTag, { value: "Module" })), Ct = {
  ...NN,
  ...bN
};
function jN(e, n) {
  return Vs(e, new Ct.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ct.isNode && ve.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function wN(e) {
  return ve.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function CN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Bb(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ve.isArray(a) ? a.length : s, d ? (ve.hasOwnProp(a, s) ? a[s] = ve.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !ve.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ve.isArray(a[s]) && (a[s] = CN(a[s])), !l);
  }
  if (ve.isFormData(e) && ve.isFunction(e.entries)) {
    const r = {};
    return ve.forEachEntry(e, (i, a) => {
      n(wN(i), a, r, 0);
    }), r;
  }
  return null;
}
const _i = (e, n) => e != null && ve.hasOwnProp(e, n) ? e[n] : void 0;
function FN(e, n, r) {
  if (ve.isString(e))
    try {
      return (n || JSON.parse)(e), ve.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const oo = {
  transitional: Pm,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ve.isObject(n);
      if (o && ve.isHTMLForm(n) && (n = new FormData(n)), ve.isFormData(n))
        return a ? JSON.stringify(Bb(n)) : n;
      if (ve.isArrayBuffer(n) || ve.isBuffer(n) || ve.isStream(n) || ve.isFile(n) || ve.isBlob(n) || ve.isReadableStream(n))
        return n;
      if (ve.isArrayBufferView(n))
        return n.buffer;
      if (ve.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = _i(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return jN(n, d).toString();
        if ((l = ve.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = _i(this, "env"), u = m && m.FormData;
          return Vs(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), FN(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = _i(this, "transitional") || oo.transitional, i = r && r.forcedJSONParsing, a = _i(this, "responseType"), o = a === "json";
      if (ve.isResponse(n) || ve.isReadableStream(n))
        return n;
      if (n && ve.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, _i(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? fn.from(d, fn.ERR_BAD_RESPONSE, this, null, _i(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ct.classes.FormData,
    Blob: Ct.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ve.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  oo.headers[e] = {};
});
const IN = ve.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), EN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && IN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, af = Symbol("internals"), TN = /[^\x09\x20-\x7E\x80-\xFF]/g;
function $N(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
function ea(e) {
  return e && String(e).trim().toLowerCase();
}
function DN(e) {
  return $N(e.replace(TN, ""));
}
function Go(e) {
  return e === !1 || e == null ? e : ve.isArray(e) ? e.map(Go) : DN(String(e));
}
function RN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const ON = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function al(e, n, r, i, a) {
  if (ve.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ve.isString(n)) {
    if (ve.isString(i))
      return n.indexOf(i) !== -1;
    if (ve.isRegExp(i))
      return i.test(n);
  }
}
function PN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function AN(e, n) {
  const r = ve.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Wt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = ea(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ve.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Go(l));
    }
    const s = (l, d) => ve.forEach(l, (m, u) => o(m, u, d));
    if (ve.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ve.isString(n) && (n = n.trim()) && !ON(n))
      s(EN(n), r);
    else if (ve.isObject(n) && ve.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ve.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ve.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = ea(n), n) {
      const i = ve.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return RN(a);
        if (ve.isFunction(r))
          return r.call(this, a, i);
        if (ve.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = ea(n), n) {
      const i = ve.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || al(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = ea(s), s) {
        const l = ve.findKey(i, s);
        l && (!r || al(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || al(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ve.forEach(this, (a, o) => {
      const s = ve.findKey(i, o);
      if (s) {
        r[s] = Go(a), delete r[o];
        return;
      }
      const l = n ? PN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Go(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ve.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ve.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[af] = this[af] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = ea(s);
      i[l] || (AN(a, s), i[l] = !0);
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Wt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ve.reduceDescriptors(Wt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ve.freezeMethods(Wt);
function ol(e, n) {
  const r = this || oo, i = n || r, a = Wt.from(i.headers);
  let o = i.data;
  return ve.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function qb(e) {
  return !!(e && e.__CANCEL__);
}
let so = class extends fn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", fn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Hb(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(
    new fn(
      "Request failed with status code " + r.status,
      [fn.ERR_BAD_REQUEST, fn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function LN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function VN(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function zN(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const ds = (e, n, r = 3) => {
  let i = 0;
  const a = VN(50, 250);
  return zN((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, of = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, sf = (e) => (...n) => ve.asap(() => e(...n)), UN = Ct.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ct.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ct.origin),
  Ct.navigator && /(msie|trident)/i.test(Ct.navigator.userAgent)
) : () => !0, MN = Ct.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ve.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ve.isString(i) && l.push(`path=${i}`), ve.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ve.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function BN(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function qN(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Wb(e, n, r) {
  let i = !BN(n);
  return e && (i || r === !1) ? qN(e, n) : n;
}
const lf = (e) => e instanceof Wt ? { ...e } : e;
function hi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(m, u, f, h) {
    return ve.isPlainObject(m) && ve.isPlainObject(u) ? ve.merge.call({ caseless: h }, m, u) : ve.isPlainObject(u) ? ve.merge({}, u) : ve.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ve.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (ve.hasOwnProp(n, f))
      return i(m, u);
    if (ve.hasOwnProp(e, f))
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(lf(m), lf(u), f, !0)
  };
  return ve.forEach(Object.keys({ ...e, ...n }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const f = ve.hasOwnProp(d, u) ? d[u] : a, h = ve.hasOwnProp(e, u) ? e[u] : void 0, v = ve.hasOwnProp(n, u) ? n[u] : void 0, F = f(h, v, u);
    ve.isUndefined(F) && f !== l || (r[u] = F);
  }), r;
}
const Kb = (e) => {
  const n = hi({}, e), r = (h) => ve.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Wt.from(l), n.url = Mb(
    Wb(m, f, u),
    e.params,
    e.paramsSerializer
  ), d && l.set(
    "Authorization",
    "Basic " + btoa(
      (d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : "")
    )
  ), ve.isFormData(i)) {
    if (Ct.hasStandardBrowserEnv || Ct.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (ve.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), v = ["content-type", "content-length"];
      Object.entries(h).forEach(([F, S]) => {
        v.includes(F.toLowerCase()) && l.set(F, S);
      });
    }
  }
  if (Ct.hasStandardBrowserEnv && (ve.isFunction(a) && (a = a(n)), a === !0 || a == null && UN(n.url))) {
    const v = o && s && MN.read(s);
    v && l.set(o, v);
  }
  return n;
}, HN = typeof XMLHttpRequest < "u", WN = HN && function(e) {
  return new Promise(function(r, i) {
    const a = Kb(e);
    let o = a.data;
    const s = Wt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, F;
    function S() {
      v && v(), F && F(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function C() {
      if (!N)
        return;
      const H = Wt.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), E = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: H,
        config: e,
        request: N
      };
      Hb(
        function(U) {
          r(U), S();
        },
        function(U) {
          i(U), S();
        },
        E
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = C : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, N.onabort = function() {
      N && (i(new fn("Request aborted", fn.ECONNABORTED, e, N)), N = null);
    }, N.onerror = function(T) {
      const E = T && T.message ? T.message : "Network Error", D = new fn(E, fn.ERR_NETWORK, e, N);
      D.event = T || null, i(D), N = null;
    }, N.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || Pm;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), i(
        new fn(
          T,
          E.clarifyTimeoutError ? fn.ETIMEDOUT : fn.ECONNABORTED,
          e,
          N
        )
      ), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && ve.forEach(s.toJSON(), function(T, E) {
      N.setRequestHeader(E, T);
    }), ve.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, F] = ds(m, !0), N.addEventListener("progress", h)), d && N.upload && ([f, v] = ds(d), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (H) => {
      N && (i(!H || H.type ? new so(null, e, N) : H), N.abort(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = LN(a.url);
    if (y && Ct.protocols.indexOf(y) === -1) {
      i(
        new fn(
          "Unsupported protocol " + y + ":",
          fn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, KN = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(
          u instanceof fn ? u : new so(u instanceof Error ? u.message : u)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new fn(`timeout of ${n}ms exceeded`, fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ve.asap(l), d;
  }
}, GN = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, YN = async function* (e, n) {
  for await (const r of JN(e))
    yield* GN(r, n);
}, JN = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, cf = (e, n, r, i) => {
  const a = YN(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, df = 64 * 1024, { isFunction: vo } = ve, QN = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ve.global), { ReadableStream: uf, TextEncoder: mf } = ve.global, pf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, XN = (e) => {
  e = ve.merge.call(
    {
      skipUndefined: !0
    },
    QN,
    e
  );
  const { fetch: n, Request: r, Response: i } = e, a = n ? vo(n) : typeof fetch == "function", o = vo(r), s = vo(i);
  if (!a)
    return !1;
  const l = a && vo(uf), d = a && (typeof mf == "function" ? /* @__PURE__ */ ((F) => (S) => F.encode(S))(new mf()) : async (F) => new Uint8Array(await new r(F).arrayBuffer())), m = o && l && pf(() => {
    let F = !1;
    const S = new r(Ct.origin, {
      body: new uf(),
      method: "POST",
      get duplex() {
        return F = !0, "half";
      }
    }), N = S.headers.has("Content-Type");
    return S.body != null && S.body.cancel(), F && !N;
  }), u = s && l && pf(() => ve.isReadableStream(new i("").body)), f = {
    stream: u && ((F) => F.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((F) => {
    !f[F] && (f[F] = (S, N) => {
      let C = S && S[F];
      if (C)
        return C.call(S);
      throw new fn(
        `Response type '${F}' is not supported`,
        fn.ERR_NOT_SUPPORT,
        N
      );
    });
  });
  const h = async (F) => {
    if (F == null)
      return 0;
    if (ve.isBlob(F))
      return F.size;
    if (ve.isSpecCompliantForm(F))
      return (await new r(Ct.origin, {
        method: "POST",
        body: F
      }).arrayBuffer()).byteLength;
    if (ve.isArrayBufferView(F) || ve.isArrayBuffer(F))
      return F.byteLength;
    if (ve.isURLSearchParams(F) && (F = F + ""), ve.isString(F))
      return (await d(F)).byteLength;
  }, v = async (F, S) => {
    const N = ve.toFiniteNumber(F.getContentLength());
    return N ?? h(S);
  };
  return async (F) => {
    let {
      url: S,
      method: N,
      data: C,
      signal: y,
      cancelToken: H,
      timeout: T,
      onDownloadProgress: E,
      onUploadProgress: D,
      responseType: U,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: ie
    } = Kb(F), Y = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let M = KN(
      [y, H && H.toAbortSignal()],
      T
    ), O = null;
    const q = M && M.unsubscribe && (() => {
      M.unsubscribe();
    });
    let ee;
    try {
      if (D && m && N !== "get" && N !== "head" && (ee = await v(Z, C)) !== 0) {
        let be = new r(S, {
          method: "POST",
          body: C,
          duplex: "half"
        }), Fe;
        if (ve.isFormData(C) && (Fe = be.headers.get("content-type")) && Z.setContentType(Fe), be.body) {
          const [K, Be] = of(
            ee,
            ds(sf(D))
          );
          C = cf(be.body, df, K, Be);
        }
      }
      ve.isString(Q) || (Q = Q ? "include" : "omit");
      const ge = o && "credentials" in r.prototype;
      if (ve.isFormData(C)) {
        const be = Z.getContentType();
        be && /^multipart\/form-data/i.test(be) && !/boundary=/i.test(be) && Z.delete("content-type");
      }
      const de = {
        ...ie,
        signal: M,
        method: N.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: C,
        duplex: "half",
        credentials: ge ? Q : void 0
      };
      O = o && new r(S, de);
      let le = await (o ? Y(O, ie) : Y(S, de));
      const pe = u && (U === "stream" || U === "response");
      if (u && (E || pe && q)) {
        const be = {};
        ["status", "statusText", "headers"].forEach((Me) => {
          be[Me] = le[Me];
        });
        const Fe = ve.toFiniteNumber(le.headers.get("content-length")), [K, Be] = E && of(
          Fe,
          ds(sf(E), !0)
        ) || [];
        le = new i(
          cf(le.body, df, K, () => {
            Be && Be(), q && q();
          }),
          be
        );
      }
      U = U || "text";
      let W = await f[ve.findKey(f, U) || "text"](
        le,
        F
      );
      return !pe && q && q(), await new Promise((be, Fe) => {
        Hb(be, Fe, {
          data: W,
          headers: Wt.from(le.headers),
          status: le.status,
          statusText: le.statusText,
          config: F,
          request: O
        });
      });
    } catch (ge) {
      throw q && q(), ge && ge.name === "TypeError" && /Load failed|fetch/i.test(ge.message) ? Object.assign(
        new fn(
          "Network Error",
          fn.ERR_NETWORK,
          F,
          O,
          ge && ge.response
        ),
        {
          cause: ge.cause || ge
        }
      ) : fn.from(ge, ge && ge.code, F, O, ge && ge.response);
    }
  };
}, ZN = /* @__PURE__ */ new Map(), Gb = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = ZN;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : XN(n)), u = m;
  return m;
};
Gb();
const Lm = {
  http: pN,
  xhr: WN,
  fetch: {
    get: Gb
  }
};
ve.forEach(Lm, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const ff = (e) => `- ${e}`, ej = (e) => ve.isFunction(e) || e === null || e === !1;
function nj(e, n) {
  e = ve.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !ej(i) && (a = Lm[(l = String(i)).toLowerCase()], a === void 0))
      throw new fn(`Unknown adapter '${l}'`);
    if (a && (ve.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(ff).join(`
`) : " " + ff(s[0]) : "as no adapter specified";
    throw new fn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Yb = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: nj,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Lm
};
function sl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new so(null, e);
}
function hf(e) {
  return sl(e), e.headers = Wt.from(e.headers), e.data = ol.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Yb.getAdapter(e.adapter || oo.adapter, e)(e).then(
    function(i) {
      return sl(e), i.data = ol.call(e, e.transformResponse, i), i.headers = Wt.from(i.headers), i;
    },
    function(i) {
      return qb(i) || (sl(e), i && i.response && (i.response.data = ol.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = Wt.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const Jb = "1.15.2", zs = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  zs[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const yf = {};
zs.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Jb + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new fn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        fn.ERR_DEPRECATED
      );
    return r && !yf[s] && (yf[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
zs.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function tj(e, n, r) {
  if (typeof e != "object")
    throw new fn("options must be an object", fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new fn(
          "option " + o + " must be " + d,
          fn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new fn("Unknown option " + o, fn.ERR_BAD_OPTION);
  }
}
const Yo = {
  assertOptions: tj,
  validators: zs
}, rr = Yo.validators;
let ui = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new rf(),
      response: new rf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = hi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Yo.assertOptions(
      i,
      {
        silentJSONParsing: rr.transitional(rr.boolean),
        forcedJSONParsing: rr.transitional(rr.boolean),
        clarifyTimeoutError: rr.transitional(rr.boolean),
        legacyInterceptorReqResOrdering: rr.transitional(rr.boolean)
      },
      !1
    ), a != null && (ve.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Yo.assertOptions(
      a,
      {
        encode: rr.function,
        serialize: rr.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Yo.assertOptions(
      r,
      {
        baseUrl: rr.spelling("baseURL"),
        withXsrfToken: rr.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ve.merge(o.common, o[r.method]);
    o && ve.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (F) => {
      delete o[F];
    }), r.headers = Wt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(S) {
      if (typeof S.runWhen == "function" && S.runWhen(r) === !1)
        return;
      d = d && S.synchronous;
      const N = r.transitional || Pm;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(S.fulfilled, S.rejected) : l.push(S.fulfilled, S.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const F = [hf.bind(this), void 0];
      for (F.unshift(...l), F.push(...m), h = F.length, u = Promise.resolve(r); f < h; )
        u = u.then(F[f++], F[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const F = l[f++], S = l[f++];
      try {
        v = F(v);
      } catch (N) {
        S.call(this, N);
        break;
      }
    }
    try {
      u = hf.call(this, v);
    } catch (F) {
      return Promise.reject(F);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = hi(this.defaults, n);
    const r = Wb(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Mb(r, n.params, n.paramsSerializer);
  }
};
ve.forEach(["delete", "get", "head", "options"], function(n) {
  ui.prototype[n] = function(r, i) {
    return this.request(
      hi(i || {}, {
        method: n,
        url: r,
        data: (i || {}).data
      })
    );
  };
});
ve.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        hi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  ui.prototype[n] = r(), ui.prototype[n + "Form"] = r(!0);
});
let rj = class Qb {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new so(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Qb(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function ij(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function aj(e) {
  return ve.isObject(e) && e.isAxiosError === !0;
}
const Xu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Xu).forEach(([e, n]) => {
  Xu[n] = e;
});
function Xb(e) {
  const n = new ui(e), r = Tb(ui.prototype.request, n);
  return ve.extend(r, ui.prototype, n, { allOwnKeys: !0 }), ve.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Xb(hi(e, a));
  }, r;
}
const mt = Xb(oo);
mt.Axios = ui;
mt.CanceledError = so;
mt.CancelToken = rj;
mt.isCancel = qb;
mt.VERSION = Jb;
mt.toFormData = Vs;
mt.AxiosError = fn;
mt.Cancel = mt.CanceledError;
mt.all = function(n) {
  return Promise.all(n);
};
mt.spread = ij;
mt.isAxiosError = aj;
mt.mergeConfig = hi;
mt.AxiosHeaders = Wt;
mt.formToJSON = (e) => Bb(ve.isHTMLForm(e) ? new FormData(e) : e);
mt.getAdapter = Yb.getAdapter;
mt.HttpStatusCode = Xu;
mt.default = mt;
const {
  Axios: A4,
  AxiosError: L4,
  CanceledError: V4,
  isCancel: z4,
  CancelToken: U4,
  VERSION: M4,
  all: B4,
  Cancel: q4,
  isAxiosError: oj,
  spread: H4,
  toFormData: W4,
  AxiosHeaders: K4,
  HttpStatusCode: G4,
  formToJSON: Y4,
  getAdapter: J4,
  mergeConfig: Q4
} = mt;
class sj {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const gf = new sj();
function lj(e, n) {
  return vf(e), vf(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function vf(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const cj = Object.prototype.toString;
function dj(e, n) {
  return cj.call(e) === `[object ${n}]`;
}
function uj(e) {
  return dj(e, "Object");
}
function mj(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Va = "8.36.0", qr = globalThis;
function Vm(e, n, r) {
  const i = r || qr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Va] = a[Va] || {};
  return o[e] || (o[e] = n());
}
const Zb = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, pj = "Sentry Logger ", kf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], bf = {};
function e_(e) {
  if (!("console" in qr))
    return e();
  const n = qr.console, r = {}, i = Object.keys(bf);
  i.forEach((a) => {
    const o = bf[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function fj() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Zb ? kf.forEach((r) => {
    n[r] = (...i) => {
      e && e_(() => {
        qr.console[r](`${pj}[${r}]:`, ...i);
      });
    };
  }) : kf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Jo = Vm("logger", fj);
function hj(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Zb && Jo.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const n_ = 1e3;
function zm() {
  return Date.now() / n_;
}
function yj() {
  const { performance: e } = qr;
  if (!e || !e.now)
    return zm;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / n_;
}
const gj = yj();
(() => {
  const { performance: e } = qr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Di() {
  const e = qr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function _f() {
  return {
    traceId: Di(),
    spanId: Di().substring(16)
  };
}
function Um() {
  return Mm(qr), qr;
}
function Mm(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Va, n[Va] = n[Va] || {};
}
function vj(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || gj(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Di()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Zu = "_sentrySpan";
function xf(e, n) {
  n ? hj(e, Zu, n) : delete e[Zu];
}
function Sf(e) {
  return e[Zu];
}
const kj = 100;
class Bm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = _f();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Bm();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, xf(n, Sf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && vj(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Vi ? [r.getScopeData(), r.getRequestSession()] : uj(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, xf(this, void 0), this._attachments = [], this._propagationContext = _f(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : kj;
    if (i <= 0)
      return this;
    const a = {
      timestamp: zm(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Sf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Di();
    if (!this._client)
      return Jo.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Di();
    if (!this._client)
      return Jo.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Di();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Jo.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Vi = Bm;
function bj() {
  return Vm("defaultCurrentScope", () => new Vi());
}
function _j() {
  return Vm("defaultIsolationScope", () => new Vi());
}
class xj {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Vi();
    let a;
    r ? a = r : a = new Vi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return mj(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function zi() {
  const e = Um(), n = Mm(e);
  return n.stack = n.stack || new xj(bj(), _j());
}
function Sj(e) {
  return zi().withScope(e);
}
function Nj(e, n) {
  const r = zi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Nf(e) {
  return zi().withScope(() => e(zi().getIsolationScope()));
}
function jj() {
  return {
    withIsolationScope: Nf,
    withScope: Sj,
    withSetScope: Nj,
    withSetIsolationScope: (e, n) => Nf(n),
    getCurrentScope: () => zi().getScope(),
    getIsolationScope: () => zi().getIsolationScope()
  };
}
function t_(e) {
  const n = Mm(e);
  return n.acs ? n.acs : jj();
}
function qm() {
  const e = Um();
  return t_(e).getCurrentScope();
}
function r_() {
  const e = Um();
  return t_(e).getIsolationScope();
}
function wj() {
  return qm().getClient();
}
function Cj(e) {
  if (e)
    return Fj(e) ? { captureContext: e } : Ej(e) ? {
      captureContext: e
    } : e;
}
function Fj(e) {
  return e instanceof Vi || typeof e == "function";
}
const Ij = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Ej(e) {
  return Object.keys(e).some((n) => Ij.includes(n));
}
function jf(e, n) {
  return qm().captureException(e, Cj(n));
}
function Tj(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return qm().captureMessage(e, r, i);
}
function $j(e, n) {
  r_().setContext(e, n);
}
const Dj = 100;
function ri(e, n) {
  const r = wj(), i = r_();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = Dj } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: zm(), ...e }, d = a ? e_(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Xa;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Xa || (Xa = {}));
function Ri(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const Rj = Qa.backendDomain ? {
  "backend-domain": Qa.backendDomain
} : void 0;
function Qo() {
  const e = new URLSearchParams({
    noToken: "true",
    ...Rj
  }).toString();
  document.location.href = `${Qa.url.logIn}?${e}`;
}
const ll = "authData", cl = 30, Oj = 600, dl = 5;
class Pj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= dl || this.clientServerTimeDiff <= -dl ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + Oj, a = Ri(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > dl) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(ll, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(ll), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(ll);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - cl;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Ri(n), i = r.exp - cl;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - cl - this.estimatedServerTime()) * 1e3;
  }
}
const vt = new Pj();
async function Aj(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Ri(o).exp : "None", l = await Us.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Ri(m).exp : "None", h = u ? Ri(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", F = typeof f == "number" ? d - f : "Unknown", S = typeof h == "number" ? d - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      $j("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: F,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: S,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    Tj("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Xa.Platform,
        domain: n
      }
    });
  }
}
const ul = /* @__PURE__ */ new Map(), Lj = 3;
function Vj(e) {
  e.interceptors.response.use((n) => (ul.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case em.Unauthorized:
          if (!Us.isRefreshTokenExpired() && n.config) {
            ri({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = ul.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= Lj)
              return ul.set(n.config.url, i + 1), e(n.config);
          }
          Aj(n), console.error("401 unauthorized interceptor"), Qo();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const i_ = mt.create();
Vj(i_);
const Ar = console.log;
async function wf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class zj extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function Uj(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const Mj = 5;
class Bj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      vt.setAuthData(r);
    else {
      const i = vt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new zj("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = vt.getAccessToken();
    if (!n)
      return {};
    const r = Ri(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return vt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = vt.getAuthData();
    return r ? vt.isAccessTokenExpired() ? (ri({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && vt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return vt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return vt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return vt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = vt.getAuthData();
    return n ? vt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!gf.isElectron())
      return !0;
    const n = await gf.getVersion();
    return lj(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = Mj) {
    try {
      return await i_.post(`${Qa.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Ar("AUTH", "Network connection offline - waiting..."), ri({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await wf(5);
    n && (Ar("AUTH", "Network connection restored"), ri({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = Uj(this.retryCount);
    return Ar("AUTH", `Retrying in ${i} seconds`), await wf(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (vt.isRefreshTokenExpired(r))
      return Ar("AUTH", "Refresh token expired"), ri({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), vt.removeAuthData(), Qo(), null;
    if (oj(n)) {
      if (n.message === "timeout exceeded")
        return Ar("AUTH", "Timeout exceeded"), ri({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Ar("AUTH", "Network error"), ri({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Ar("AUTH", "Refresh token invalid (401)"), vt.removeAuthData(), Qo(), null;
      jf(n, {
        level: "error",
        tags: {
          team: Xa.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Ar("AUTH", "Retries exhausted, logging out"), jf(n, {
      level: "error",
      tags: {
        team: Xa.Platform,
        errorSource: "authManager.refresh"
      }
    }), vt.removeAuthData(), Qo(), null) : (Ar("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return vt.accessTokenExpiresInMs();
  }
}
const Us = new Bj();
var em;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(em || (em = {}));
const qj = new Dm((e, n) => new Fb((r) => {
  Us.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), Hj = new Dm(
  (e, n) => new Fb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Us.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...DS(Qa.url.partnerIntegrations) && d?.access_token && RS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), Wj = new AbortController(), a_ = (e) => new m0({
  queryDeduplication: !1,
  cache: new p0(),
  link: Dm.from([
    qj,
    Hj,
    f0({
      uri: `${e}/graphql`,
      fetch: k0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: Wj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), Kj = ({
  configuration: e,
  children: n
}) => {
  const r = qn(
    () => a_(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ ze.jsx(h0, { client: r, children: n });
};
function Gj() {
  try {
    return y0(), !0;
  } catch {
    return !1;
  }
}
const Yj = ({
  configuration: e,
  children: n
}) => Gj() ? n : /* @__PURE__ */ ze.jsx(Kj, { configuration: e, children: n }), Jj = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ ze.jsx(g0, { children: (o) => /* @__PURE__ */ ze.jsx(
  OS,
  {
    value: {
      useMutation: VS(e, n),
      useQuery: LS(e, n),
      useLazyQuery: AS(e, n),
      executeQuery: PS(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), o_ = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ ze.jsx(Yj, { configuration: r, children: s ? /* @__PURE__ */ ze.jsx(
    Jj,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ml = { exports: {} }, na = {}, Cf;
function Qj() {
  if (Cf) return na;
  Cf = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return na.Fragment = r, na.jsx = s, na.jsxs = s, na;
}
var ko = {}, Ff;
function Xj() {
  return Ff || (Ff = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    ko.Fragment = i, ko.jsx = Rn, ko.jsxs = Bn;
  })()), ko;
}
var If;
function Zj() {
  return If || (If = 1, process.env.NODE_ENV === "production" ? ml.exports = Qj() : ml.exports = Xj()), ml.exports;
}
var ae = Zj();
const ew = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, nw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, tw = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": ew,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": nw
};
function s_(e) {
  return tw[e] ?? {};
}
const rw = s_(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), iw = s_(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), aw = "_copyIcon_1wjfs_48", ow = "_list_1wjfs_53", sw = "_listItem_1wjfs_63", lw = "_collapsible_1wjfs_72", cw = "_collapsibleIsOpen_1wjfs_80", dw = "_collapsibleHeader_1wjfs_83", uw = "_collapsibleIconTrue_1wjfs_86", mw = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: aw,
  list: ow,
  listItem: sw,
  collapsible: lw,
  collapsibleIsOpen: cw,
  collapsibleHeader: dw,
  collapsibleIconTrue: uw,
  collapsibleIconFalse: mw
}, pw = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(We, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(d).format(dt) })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(m).format(dt) })
          ] }) })
        ] })
      ]
    }
  );
}, fw = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(pw, { app: r, openByDefault: i === 0 }, i))
  ] });
}, hw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: i }),
          bb(a)
        ] })
      },
      o
    )) })
  ] }) });
}, yw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Ln(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Ln(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, us = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: n ? null : l(), children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(ue, { size: 14, name: o(), color: s() }) }) });
}, gw = "_wrapper_1xucg_1", vw = "_externalLink_1xucg_7", pl = {
  wrapper: gw,
  externalLink: vw
}, kw = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = er(), { isCopied: i, copy: a } = er(), { isCopied: o, copy: s } = er(), { isCopied: l, copy: d } = er(), { isCopied: m, copy: u } = er();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: F,
    home_city: S,
    country: N,
    email: C,
    phone: y,
    dob: H,
    created_at: T,
    email_subscribe: E,
    push_subscribe: D
  } = e, U = 14, Z = `${v || ""} ${F || ""}`.trim() || "A customer has no name", Q = `${S ? `${S} /` : ""} ${N || ""}`.trim(), ie = H ? Ln(H).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { className: pl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: pl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-2", children: Z }),
          ie && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    T && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(dt) })
    ] }),
    Q && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "map-pin" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Q })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy location", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(Q),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "mail" }),
        /* @__PURE__ */ ae.jsx("span", { className: pl.externalLink, children: C })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(C),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "phone" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "user" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy Braze ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "tag" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy External ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    E && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(us, { state: E })
    ] }),
    D && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "bell" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(us, { isPush: !0, state: D })
    ] })
  ] }) });
}, bw = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(We, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ae.jsx(
              ue,
              {
                size: a,
                className: ut({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "For iOS", children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, _w = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(bw, { device: r, openByDefault: i === 0 }, i))
  ] });
}, ta = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, bo = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = bn(), { useMutation: a } = mn(), [o, s] = se(!1), [l] = a(
    iw,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: ta[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: ta[n].tooltipContent, children: /* @__PURE__ */ ae.jsx(
    Kn,
    {
      variant: "secondary",
      color: ta[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(
          us,
          {
            noTooltip: !0,
            state: ta[n].parameter
          }
        ),
        ta[n].label
      ] })
    }
  ) });
}, xw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: 14, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(us, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
        /* @__PURE__ */ ae.jsx(
          bo,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ae.jsx(
          bo,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ae.jsx(
        bo,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ae.jsx(
        bo,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Sw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Ln(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Ln(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Nw = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = bn(), { useMutation: i } = mn(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, F = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, C = n.displayDevices ?? !1, y = n.displayApps ?? !1, H = !h && !v && !F && !S && !N, [T, { error: E }] = i(
    rw,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Z = U?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), D = async () => {
    u || f ? await T({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (qe(() => {
    async function U() {
      m(!0), await D();
    }
    U().finally(() => m(!1));
  }, [u, f]), E) {
    const U = E.graphQLErrors;
    return Cm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Fm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ae.jsx(Fn, { error: E });
  }
  return d ? /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ae.jsx(sn, {}) }) : H ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ae.jsx(kw, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ ae.jsx(
          xw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await D()
          }
        ),
        F && !!a && /* @__PURE__ */ ae.jsx(hw, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ ae.jsx(yw, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ ae.jsx(Sw, { customerDetails: a }),
        C && !!a && /* @__PURE__ */ ae.jsx(_w, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ ae.jsx(fw, { apps: a?.apps })
      ]
    }
  );
}, jw = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => kb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function ww() {
  var e = di(!1), n = tt(function() {
    return e.current;
  }, []);
  return qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Cw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = tt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, Fw = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Ef = function(e) {
  return e0(Fw, e);
}, fl, Tf;
function Iw() {
  return Tf || (Tf = 1, fl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), fl;
}
var hl, $f;
function Ew() {
  if ($f) return hl;
  $f = 1;
  var e = Iw(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var F = document.execCommand("copy");
      if (!F)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return hl = a, hl;
}
var Tw = Ew();
const $w = /* @__PURE__ */ Rm(Tw);
var l_ = function() {
  var e = ww(), n = Cw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = tt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = $w(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function Dw(e, n) {
  n === void 0 && (n = 0);
  var r = di(!1), i = di(), a = di(e), o = tt(function() {
    return r.current;
  }, []), s = tt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = tt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return qe(function() {
    a.current = e;
  }, [e]), qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function yi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = Dw(e, n), a = i[0], o = i[1], s = i[2];
  return qe(s, r), [a, o];
}
var Rw = function(e) {
  qe(e, []);
}, Ow = function(e, n) {
  var r = di(function() {
  });
  qe(function() {
    r.current = e;
  }), qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, Pw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = qn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return rl(rl({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = b0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = rl({ get: tt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, Aw = function(e) {
  var n = di(e);
  n.current = e, Rw(function() {
    return function() {
      return n.current();
    };
  });
}, lo = (e) => e.type === "checkbox", si = (e) => e instanceof Date, At = (e) => e == null;
const c_ = (e) => typeof e == "object";
var st = (e) => !At(e) && !Array.isArray(e) && c_(e) && !si(e), d_ = (e) => st(e) && e.target ? lo(e.target) ? e.target.checked : e.target.value : e, Lw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, u_ = (e, n) => e.has(Lw(n)), Vw = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, Hm = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function bt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Hm && (e instanceof Blob || i)) && (r || st(e)))
    if (n = r ? [] : {}, !r && !Vw(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = bt(e[a]));
  else
    return e;
  return n;
}
var Ms = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Ge = (e, n, r) => {
  if (!n || !st(e))
    return r;
  const i = Ms(n.split(/[,[\].]+?/)).reduce((a, o) => At(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? r : e[n] : i;
}, Qt = (e) => typeof e == "boolean", Wm = (e) => /^\w*$/.test(e), m_ = (e) => Ms(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = Wm(n) ? [n] : m_(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ms = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Lr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, p_ = Ne.createContext(null), Or = () => Ne.useContext(p_), Bs = (e) => {
  const { children: n, ...r } = e;
  return Ne.createElement(p_.Provider, { value: r }, n);
};
var f_ = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== fr.all && (n._proxyFormState[s] = !i || fr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function zw(e) {
  const n = Or(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ne.useState(r._formState), d = Ne.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Ne.useRef(a);
  return m.current = a, Ne.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Ne.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Ne.useMemo(() => f_(s, r, d.current, !1), [s, r]);
}
var Er = (e) => typeof e == "string", h_ = (e, n, r, i, a) => Er(e) ? (i && n.watch.add(e), Ge(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ge(r, o))) : (i && (n.watchAll = !0), r);
function Xo(e) {
  const n = Or(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ne.useRef(i), d = Ne.useRef(a);
  l.current = i, Ne.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(h_(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Ne.useState(r._getWatch(i, a));
  return Ne.useEffect(() => r._removeUnmounted()), m;
}
function Km(e) {
  const n = Or(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = u_(a._names.array, r), l = Xo({
    control: a,
    name: r,
    defaultValue: Ge(a._formValues, r, Ge(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = zw({
    control: a,
    name: r,
    exact: !0
  }), m = Ne.useRef(e), u = Ne.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Qt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ne.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ge(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ge(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ge(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ge(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ge(d.errors, r)
    }
  }), [d, r]), h = Ne.useCallback((N) => u.current.onChange({
    target: {
      value: d_(N),
      name: r
    },
    type: ms.CHANGE
  }), [r]), v = Ne.useCallback(() => u.current.onBlur({
    target: {
      value: Ge(a._formValues, r),
      name: r
    },
    type: ms.BLUR
  }), [r, a._formValues]), F = Ne.useCallback((N) => {
    const C = Ge(a._fields, r);
    C && N && (C._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Ne.useMemo(() => ({
    name: r,
    value: l,
    ...Qt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: F
  }), [r, i, d.disabled, h, v, F, l]);
  return Ne.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Qt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const C = (y, H) => {
      const T = Ge(a._fields, y);
      T && T._f && (T._f.mount = H);
    };
    if (C(r, !0), N) {
      const y = bt(Ge(a._options.defaultValues, r));
      Gn(a._defaultValues, r, y), rt(Ge(a._formValues, r)) && Gn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Ne.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ne.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const zt = (e) => e.render(Km(e));
var Uw = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, za = (e) => Array.isArray(e) ? e : [e], Df = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, nm = (e) => At(e) || !c_(e);
function Jr(e, n) {
  if (nm(e) || nm(n))
    return e === n;
  if (si(e) && si(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (si(o) && si(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !Jr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Rt = (e) => st(e) && !Object.keys(e).length, Gm = (e) => e.type === "file", hr = (e) => typeof e == "function", ps = (e) => {
  if (!Hm)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, y_ = (e) => e.type === "select-multiple", Ym = (e) => e.type === "radio", Mw = (e) => Ym(e) || lo(e), yl = (e) => ps(e) && e.isConnected;
function Bw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function qw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const r = Array.isArray(n) ? n : Wm(n) ? [n] : m_(n), i = r.length === 1 ? e : Bw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (st(i) && Rt(i) || Array.isArray(i) && qw(i)) && ft(e, r.slice(0, -1)), e;
}
var g_ = (e) => {
  for (const n in e)
    if (hr(e[n]))
      return !0;
  return !1;
};
function fs(e, n = {}) {
  const r = Array.isArray(e);
  if (st(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !g_(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, fs(e[i], n[i])) : At(e[i]) || (n[i] = !0);
  return n;
}
function v_(e, n, r) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !g_(e[a]) ? rt(n) || nm(r[a]) ? r[a] = Array.isArray(e[a]) ? fs(e[a], []) : { ...fs(e[a]) } : v_(e[a], At(n) ? {} : n[a], r[a]) : r[a] = !Jr(e[a], n[a]);
  return r;
}
var ra = (e, n) => v_(e, n, fs(n));
const Rf = {
  value: !1,
  isValid: !1
}, Of = { value: !0, isValid: !0 };
var k_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? Of : { value: e[0].value, isValid: !0 } : Of
    ) : Rf;
  }
  return Rf;
}, b_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : r && Er(e) ? new Date(e) : i ? i(e) : e;
const Pf = {
  isValid: !1,
  value: null
};
var __ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Pf) : Pf;
function Af(e) {
  const n = e.ref;
  return Gm(n) ? n.files : Ym(n) ? __(e.refs).value : y_(n) ? [...n.selectedOptions].map(({ value: r }) => r) : lo(n) ? k_(e.refs).value : b_(rt(n.value) ? e.ref.value : n.value, e);
}
var Hw = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ge(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, hs = (e) => e instanceof RegExp, ia = (e) => rt(e) ? e : hs(e) ? e.source : st(e) ? hs(e.value) ? e.value.source : e.value : e, Lf = (e) => ({
  isOnSubmit: !e || e === fr.onSubmit,
  isOnBlur: e === fr.onBlur,
  isOnChange: e === fr.onChange,
  isOnAll: e === fr.all,
  isOnTouch: e === fr.onTouched
});
const Vf = "AsyncFunction";
var Ww = (e) => !!e && !!e.validate && !!(hr(e.validate) && e.validate.constructor.name === Vf || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Vf)), Kw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), zf = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ua = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ge(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ua(l, n))
          break;
      } else if (st(l) && Ua(l, n))
        break;
    }
  }
};
function Uf(e, n, r) {
  const i = Ge(e, r);
  if (i || Wm(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ge(n, o), l = Ge(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Gw = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Rt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || fr.all));
}, Yw = (e, n, r) => !e || !n || e === n || za(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), Jw = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, Qw = (e, n) => !Ms(Ge(e, n)).length && ft(e, n), Xw = (e, n, r) => {
  const i = za(Ge(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, Zo = (e) => Er(e);
function Mf(e, n, r = "validate") {
  if (Zo(e) || Array.isArray(e) && e.every(Zo) || Qt(e) && !e)
    return {
      type: r,
      message: Zo(e) ? e : "",
      ref: n
    };
}
var xi = (e) => st(e) && !hs(e) ? e : {
  value: e,
  message: ""
}, Bf = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: F, name: S, valueAsNumber: N, mount: C } = e._f, y = Ge(r, S);
  if (!C || n.has(S))
    return {};
  const H = l ? l[0] : s, T = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Qt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, D = Ym(s), U = lo(s), Z = D || U, Q = (N || Gm(s)) && rt(s.value) && rt(y) || ps(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = Uw.bind(null, S, i, E), Y = (M, O, q, ee = Lr.maxLength, ge = Lr.minLength) => {
    const de = M ? O : q;
    E[S] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || At(y)) || Qt(y) && !y || U && !k_(l).isValid || D && !__(l).isValid)) {
    const { value: M, message: O } = Zo(d) ? { value: !!d, message: d } : xi(d);
    if (M && (E[S] = {
      type: Lr.required,
      message: O,
      ref: H,
      ...ie(Lr.required, O)
    }, !i))
      return T(O), E;
  }
  if (!Q && (!At(f) || !At(h))) {
    let M, O;
    const q = xi(h), ee = xi(f);
    if (!At(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      At(q.value) || (M = ge > q.value), At(ee.value) || (O = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Er(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), Er(ee.value) && y && (O = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || O) && (Y(!!M, q.message, ee.message, Lr.max, Lr.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !Q && (Er(y) || o && Array.isArray(y))) {
    const M = xi(m), O = xi(u), q = !At(M.value) && y.length > +M.value, ee = !At(O.value) && y.length < +O.value;
    if ((q || ee) && (Y(q, M.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !Q && Er(y)) {
    const { value: M, message: O } = xi(v);
    if (hs(M) && !y.match(M) && (E[S] = {
      type: Lr.pattern,
      message: O,
      ref: s,
      ...ie(Lr.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (F) {
    if (hr(F)) {
      const M = await F(y, r), O = Mf(M, H);
      if (O && (E[S] = {
        ...O,
        ...ie(Lr.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (st(F)) {
      let M = {};
      for (const O in F) {
        if (!Rt(M) && !i)
          break;
        const q = Mf(await F[O](y, r), H, O);
        q && (M = {
          ...q,
          ...ie(O, q.message)
        }, T(q.message), i && (E[S] = M));
      }
      if (!Rt(M) && (E[S] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const Zw = {
  mode: fr.onSubmit,
  reValidateMode: fr.onChange,
  shouldFocusError: !0
};
function eC(e = {}) {
  let n = {
    ...Zw,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: hr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? bt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : bt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Df(),
    state: Df()
  }, v = Lf(n.mode), F = Lf(n.reValidateMode), S = n.criteriaMode === fr.all, N = (_) => ($) => {
    clearTimeout(m), m = setTimeout(_, $);
  }, C = async (_) => {
    if (!n.disabled && (u.isValid || f.isValid || _)) {
      const $ = n.resolver ? Rt((await Q()).errors) : await Y(i, !0);
      $ !== r.isValid && h.state.next({
        isValid: $
      });
    }
  }, y = (_, $) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((G) => {
      G && ($ ? Gn(r.validatingFields, G, $) : ft(r.validatingFields, G));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Rt(r.validatingFields)
    }));
  }, H = (_, $ = [], G, J, R = !0, z = !0) => {
    if (J && G && !n.disabled) {
      if (s.action = !0, z && Array.isArray(Ge(i, _))) {
        const re = G(Ge(i, _), J.argA, J.argB);
        R && Gn(i, _, re);
      }
      if (z && Array.isArray(Ge(r.errors, _))) {
        const re = G(Ge(r.errors, _), J.argA, J.argB);
        R && Gn(r.errors, _, re), Qw(r.errors, _);
      }
      if ((u.touchedFields || f.touchedFields) && z && Array.isArray(Ge(r.touchedFields, _))) {
        const re = G(Ge(r.touchedFields, _), J.argA, J.argB);
        R && Gn(r.touchedFields, _, re);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = ra(a, o)), h.state.next({
        name: _,
        isDirty: O(_, $),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, _, $);
  }, T = (_, $) => {
    Gn(r.errors, _, $), h.state.next({
      errors: r.errors
    });
  }, E = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (_, $, G, J) => {
    const R = Ge(i, _);
    if (R) {
      const z = Ge(o, _, rt(G) ? Ge(a, _) : G);
      rt(z) || J && J.defaultChecked || $ ? Gn(o, _, $ ? z : Af(R._f)) : ge(_, z), s.mount && C();
    }
  }, U = (_, $, G, J, R) => {
    let z = !1, re = !1;
    const fe = {
      name: _
    };
    if (!n.disabled) {
      if (!G || J) {
        (u.isDirty || f.isDirty) && (re = r.isDirty, r.isDirty = fe.isDirty = O(), z = re !== fe.isDirty);
        const _e = Jr(Ge(a, _), $);
        re = !!Ge(r.dirtyFields, _), _e ? ft(r.dirtyFields, _) : Gn(r.dirtyFields, _, !0), fe.dirtyFields = r.dirtyFields, z = z || (u.dirtyFields || f.dirtyFields) && re !== !_e;
      }
      if (G) {
        const _e = Ge(r.touchedFields, _);
        _e || (Gn(r.touchedFields, _, G), fe.touchedFields = r.touchedFields, z = z || (u.touchedFields || f.touchedFields) && _e !== G);
      }
      z && R && h.state.next(fe);
    }
    return z ? fe : {};
  }, Z = (_, $, G, J) => {
    const R = Ge(r.errors, _), z = (u.isValid || f.isValid) && Qt($) && r.isValid !== $;
    if (n.delayError && G ? (d = N(() => T(_, G)), d(n.delayError)) : (clearTimeout(m), d = null, G ? Gn(r.errors, _, G) : ft(r.errors, _)), (G ? !Jr(R, G) : R) || !Rt(J) || z) {
      const re = {
        ...J,
        ...z && Qt($) ? { isValid: $ } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...re
      }, h.state.next(re);
    }
  }, Q = async (_) => {
    y(_, !0);
    const $ = await n.resolver(o, n.context, Hw(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(_), $;
  }, ie = async (_) => {
    const { errors: $ } = await Q(_);
    if (_)
      for (const G of _) {
        const J = Ge($, G);
        J ? Gn(r.errors, G, J) : ft(r.errors, G);
      }
    else
      r.errors = $;
    return $;
  }, Y = async (_, $, G = {
    valid: !0
  }) => {
    for (const J in _) {
      const R = _[J];
      if (R) {
        const { _f: z, ...re } = R;
        if (z) {
          const fe = l.array.has(z.name), _e = R._f && Ww(R._f);
          _e && u.validatingFields && y([J], !0);
          const en = await Bf(R, l.disabled, o, S, n.shouldUseNativeValidation && !$, fe);
          if (_e && u.validatingFields && y([J]), en[z.name] && (G.valid = !1, $))
            break;
          !$ && (Ge(en, z.name) ? fe ? Xw(r.errors, en, z.name) : Gn(r.errors, z.name, en[z.name]) : ft(r.errors, z.name));
        }
        !Rt(re) && await Y(re, $, G);
      }
    }
    return G.valid;
  }, M = () => {
    for (const _ of l.unMount) {
      const $ = Ge(i, _);
      $ && ($._f.refs ? $._f.refs.every((G) => !yl(G)) : !yl($._f.ref)) && Ae(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (_, $) => !n.disabled && (_ && $ && Gn(o, _, $), !Jr(Fe(), a)), q = (_, $, G) => h_(_, l, {
    ...s.mount ? o : rt($) ? a : Er(_) ? { [_]: $ } : $
  }, G, $), ee = (_) => Ms(Ge(s.mount ? o : a, _, n.shouldUnregister ? Ge(a, _, []) : [])), ge = (_, $, G = {}) => {
    const J = Ge(i, _);
    let R = $;
    if (J) {
      const z = J._f;
      z && (!z.disabled && Gn(o, _, b_($, z)), R = ps(z.ref) && At($) ? "" : $, y_(z.ref) ? [...z.ref.options].forEach((re) => re.selected = R.includes(re.value)) : z.refs ? lo(z.ref) ? z.refs.length > 1 ? z.refs.forEach((re) => (!re.defaultChecked || !re.disabled) && (re.checked = Array.isArray(R) ? !!R.find((fe) => fe === re.value) : R === re.value)) : z.refs[0] && (z.refs[0].checked = !!R) : z.refs.forEach((re) => re.checked = re.value === R) : Gm(z.ref) ? z.ref.value = "" : (z.ref.value = R, z.ref.type || h.state.next({
        name: _,
        values: bt(o)
      })));
    }
    (G.shouldDirty || G.shouldTouch) && U(_, R, G.shouldTouch, G.shouldDirty, !0), G.shouldValidate && be(_);
  }, de = (_, $, G) => {
    for (const J in $) {
      const R = $[J], z = `${_}.${J}`, re = Ge(i, z);
      (l.array.has(_) || st(R) || re && !re._f) && !si(R) ? de(z, R, G) : ge(z, R, G);
    }
  }, le = (_, $, G = {}) => {
    const J = Ge(i, _), R = l.array.has(_), z = bt($);
    Gn(o, _, z), R ? (h.array.next({
      name: _,
      values: bt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && G.shouldDirty && h.state.next({
      name: _,
      dirtyFields: ra(a, o),
      isDirty: O(_, z)
    })) : J && !J._f && !At(z) ? de(_, z, G) : ge(_, z, G), zf(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: bt(o)
    });
  }, pe = async (_) => {
    s.mount = !0;
    const $ = _.target;
    let G = $.name, J = !0;
    const R = Ge(i, G), z = (re) => {
      J = Number.isNaN(re) || si(re) && isNaN(re.getTime()) || Jr(re, Ge(o, G, re));
    };
    if (R) {
      let re, fe;
      const _e = $.type ? Af(R._f) : d_(_), en = _.type === ms.BLUR || _.type === ms.FOCUS_OUT, un = !Kw(R._f) && !n.resolver && !Ge(r.errors, G) && !R._f.deps || Jw(en, Ge(r.touchedFields, G), r.isSubmitted, F, v), rn = zf(G, l, en);
      Gn(o, G, _e), en ? (R._f.onBlur && R._f.onBlur(_), d && d(0)) : R._f.onChange && R._f.onChange(_);
      const dn = U(G, _e, en), pn = !Rt(dn) || rn;
      if (!en && h.state.next({
        name: G,
        type: _.type,
        values: bt(o)
      }), un)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? en && C() : en || C()), pn && h.state.next({ name: G, ...rn ? {} : dn });
      if (!en && rn && h.state.next({ ...r }), n.resolver) {
        const { errors: cn } = await Q([G]);
        if (z(_e), J) {
          const kn = Uf(r.errors, i, G), Xe = Uf(cn, i, kn.name || G);
          re = Xe.error, G = Xe.name, fe = Rt(cn);
        }
      } else
        y([G], !0), re = (await Bf(R, l.disabled, o, S, n.shouldUseNativeValidation))[G], y([G]), z(_e), J && (re ? fe = !1 : (u.isValid || f.isValid) && (fe = await Y(i, !0)));
      J && (R._f.deps && be(R._f.deps), Z(G, fe, re, dn));
    }
  }, W = (_, $) => {
    if (Ge(r.errors, $) && _.focus)
      return _.focus(), 1;
  }, be = async (_, $ = {}) => {
    let G, J;
    const R = za(_);
    if (n.resolver) {
      const z = await ie(rt(_) ? _ : R);
      G = Rt(z), J = _ ? !R.some((re) => Ge(z, re)) : G;
    } else _ ? (J = (await Promise.all(R.map(async (z) => {
      const re = Ge(i, z);
      return await Y(re && re._f ? { [z]: re } : re);
    }))).every(Boolean), !(!J && !r.isValid) && C()) : J = G = await Y(i);
    return h.state.next({
      ...!Er(_) || (u.isValid || f.isValid) && G !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: G } : {},
      errors: r.errors
    }), $.shouldFocus && !J && Ua(i, W, _ ? R : l.mount), J;
  }, Fe = (_) => {
    const $ = {
      ...s.mount ? o : a
    };
    return rt(_) ? $ : Er(_) ? Ge($, _) : _.map((G) => Ge($, G));
  }, K = (_, $) => ({
    invalid: !!Ge(($ || r).errors, _),
    isDirty: !!Ge(($ || r).dirtyFields, _),
    error: Ge(($ || r).errors, _),
    isValidating: !!Ge(r.validatingFields, _),
    isTouched: !!Ge(($ || r).touchedFields, _)
  }), Be = (_) => {
    _ && za(_).forEach(($) => ft(r.errors, $)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Me = (_, $, G) => {
    const J = (Ge(i, _, { _f: {} })._f || {}).ref, R = Ge(r.errors, _) || {}, { ref: z, message: re, type: fe, ..._e } = R;
    Gn(r.errors, _, {
      ..._e,
      ...$,
      ref: J
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), G && G.shouldFocus && J && J.focus && J.focus();
  }, Pe = (_, $) => hr(_) ? h.state.subscribe({
    next: (G) => _(q(void 0, $), G)
  }) : q(_, $, !0), Ue = (_) => h.state.subscribe({
    next: ($) => {
      Yw(_.name, $.name, _.exact) && Gw($, _.formState || u, Re, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...$
      });
    }
  }).unsubscribe, we = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Ue({
    ..._,
    formState: f
  })), Ae = (_, $ = {}) => {
    for (const G of _ ? za(_) : l.mount)
      l.mount.delete(G), l.array.delete(G), $.keepValue || (ft(i, G), ft(o, G)), !$.keepError && ft(r.errors, G), !$.keepDirty && ft(r.dirtyFields, G), !$.keepTouched && ft(r.touchedFields, G), !$.keepIsValidating && ft(r.validatingFields, G), !n.shouldUnregister && !$.keepDefaultValue && ft(a, G);
    h.state.next({
      values: bt(o)
    }), h.state.next({
      ...r,
      ...$.keepDirty ? { isDirty: O() } : {}
    }), !$.keepIsValid && C();
  }, $e = ({ disabled: _, name: $ }) => {
    (Qt(_) && s.mount || _ || l.disabled.has($)) && (_ ? l.disabled.add($) : l.disabled.delete($));
  }, tn = (_, $ = {}) => {
    let G = Ge(i, _);
    const J = Qt($.disabled) || Qt(n.disabled);
    return Gn(i, _, {
      ...G || {},
      _f: {
        ...G && G._f ? G._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...$
      }
    }), l.mount.add(_), G ? $e({
      disabled: Qt($.disabled) ? $.disabled : n.disabled,
      name: _
    }) : D(_, !0, $.value), {
      ...J ? { disabled: $.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!$.required,
        min: ia($.min),
        max: ia($.max),
        minLength: ia($.minLength),
        maxLength: ia($.maxLength),
        pattern: ia($.pattern)
      } : {},
      name: _,
      onChange: pe,
      onBlur: pe,
      ref: (R) => {
        if (R) {
          tn(_, $), G = Ge(i, _);
          const z = rt(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, re = Mw(z), fe = G._f.refs || [];
          if (re ? fe.find((_e) => _e === z) : z === G._f.ref)
            return;
          Gn(i, _, {
            _f: {
              ...G._f,
              ...re ? {
                refs: [
                  ...fe.filter(yl),
                  z,
                  ...Array.isArray(Ge(a, _)) ? [{}] : []
                ],
                ref: { type: z.type, name: _ }
              } : { ref: z }
            }
          }), D(_, !1, void 0, z);
        } else
          G = Ge(i, _, {}), G._f && (G._f.mount = !1), (n.shouldUnregister || $.shouldUnregister) && !(u_(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, Ce = () => n.shouldFocusError && Ua(i, W, l.mount), He = (_) => {
    Qt(_) && (h.state.next({ disabled: _ }), Ua(i, ($, G) => {
      const J = Ge(i, G);
      J && ($.disabled = J._f.disabled || _, Array.isArray(J._f.refs) && J._f.refs.forEach((R) => {
        R.disabled = J._f.disabled || _;
      }));
    }, 0, !1));
  }, Ze = (_, $) => async (G) => {
    let J;
    G && (G.preventDefault && G.preventDefault(), G.persist && G.persist());
    let R = bt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: z, values: re } = await Q();
      r.errors = z, R = re;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const z of l.disabled)
        Gn(R, z, void 0);
    if (ft(r.errors, "root"), Rt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(R, G);
      } catch (z) {
        J = z;
      }
    } else
      $ && await $({ ...r.errors }, G), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Rt(r.errors) && !J,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), J)
      throw J;
  }, me = (_, $ = {}) => {
    Ge(i, _) && (rt($.defaultValue) ? le(_, bt(Ge(a, _))) : (le(_, $.defaultValue), Gn(a, _, bt($.defaultValue))), $.keepTouched || ft(r.touchedFields, _), $.keepDirty || (ft(r.dirtyFields, _), r.isDirty = $.defaultValue ? O(_, bt(Ge(a, _))) : O()), $.keepError || (ft(r.errors, _), u.isValid && C()), h.state.next({ ...r }));
  }, he = (_, $ = {}) => {
    const G = _ ? bt(_) : a, J = bt(G), R = Rt(_), z = R ? a : J;
    if ($.keepDefaultValues || (a = G), !$.keepValues) {
      if ($.keepDirtyValues) {
        const re = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(ra(a, o))
        ]);
        for (const fe of Array.from(re))
          Ge(r.dirtyFields, fe) ? Gn(z, fe, Ge(o, fe)) : le(fe, Ge(z, fe));
      } else {
        if (Hm && rt(_))
          for (const re of l.mount) {
            const fe = Ge(i, re);
            if (fe && fe._f) {
              const _e = Array.isArray(fe._f.refs) ? fe._f.refs[0] : fe._f.ref;
              if (ps(_e)) {
                const en = _e.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const re of l.mount)
          le(re, Ge(z, re));
      }
      o = bt(z), h.array.next({
        values: { ...z }
      }), h.state.next({
        values: { ...z }
      });
    }
    l = {
      mount: $.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!$.keepIsValid || !!$.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: $.keepSubmitCount ? r.submitCount : 0,
      isDirty: R ? !1 : $.keepDirty ? r.isDirty : !!($.keepDefaultValues && !Jr(_, a)),
      isSubmitted: $.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: R ? {} : $.keepDirtyValues ? $.keepDefaultValues && o ? ra(a, o) : r.dirtyFields : $.keepDefaultValues && _ ? ra(a, _) : $.keepDirty ? r.dirtyFields : {},
      touchedFields: $.keepTouched ? r.touchedFields : {},
      errors: $.keepErrors ? r.errors : {},
      isSubmitSuccessful: $.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ee = (_, $) => he(hr(_) ? _(o) : _, $), Le = (_, $ = {}) => {
    const G = Ge(i, _), J = G && G._f;
    if (J) {
      const R = J.refs ? J.refs[0] : J.ref;
      R.focus && (R.focus(), $.shouldSelect && hr(R.select) && R.select());
    }
  }, Re = (_) => {
    r = {
      ...r,
      ..._
    };
  }, w = {
    control: {
      register: tn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Me,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: O,
      _setValid: C,
      _setFieldArray: H,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => hr(n.defaultValues) && n.defaultValues().then((_) => {
        Ee(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: He,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: we,
    trigger: be,
    register: tn,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Fe,
    reset: Ee,
    resetField: me,
    clearErrors: Be,
    unregister: Ae,
    setError: Me,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...w,
    formControl: w
  };
}
function tr(e = {}) {
  const n = Ne.useRef(void 0), r = Ne.useRef(void 0), [i, a] = Ne.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: hr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: hr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : eC(e),
    formState: i
  }, e.formControl && e.defaultValues && !hr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ne.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ne.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ne.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ne.useEffect(() => {
    e.values && !Jr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ne.useEffect(() => {
    e.errors && !Rt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ne.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ne.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = f_(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var gl = { exports: {} }, aa = {}, qf;
function nC() {
  if (qf) return aa;
  qf = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return aa.Fragment = r, aa.jsx = s, aa.jsxs = s, aa;
}
var _o = {}, Hf;
function tC() {
  return Hf || (Hf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    _o.Fragment = i, _o.jsx = Rn, _o.jsxs = Bn;
  })()), _o;
}
var Wf;
function rC() {
  return Wf || (Wf = 1, process.env.NODE_ENV === "production" ? gl.exports = nC() : gl.exports = tC()), gl.exports;
}
var xe = rC();
const iC = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, aC = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, oC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, sC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, lC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, cC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, dC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, uC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, mC = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": oC,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": sC,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": lC,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": iC,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": aC,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": cC,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": dC,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": uC
};
function Hi(e) {
  return mC[e] ?? {};
}
const pC = Hi(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), fC = Hi(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), hC = Hi(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Kf = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, ar = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, yC = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Gf = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, tm = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function gC({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: F, executeQuery: S } = mn(), { track: N } = bn(), {
    loading: C,
    data: y,
    error: H,
    store: T
  } = Im(e ?? null), E = y?.github?.issues || [], D = y?.github?.pullRequests || [], [U, Z] = se(!1), [Q, ie] = se();
  qe(
    () => h(H || Q || void 0),
    [H, Q]
  ), qe(
    () => {
      !C && (E?.length || D?.length) ? (a(E), s(D), M(E, D)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const Y = async (pe, W) => {
    await T(pe).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((be) => {
      v({
        title: W.error.title,
        text: `${W.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, M = (pe, W) => {
    if (!pe?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const be = (pe || []).map(
      (Be) => S(fC, {
        owner: Be.owner,
        repositoryName: Be.repository,
        issueNumber: Be.number
      })
    ), Fe = (W || []).map(
      (Be) => S(hC, {
        owner: Be.owner,
        repositoryName: Be.repository,
        prNumber: Be.number
      })
    ), K = [...be, ...Fe];
    Z(!0), Promise.all(K).then((Be) => {
      const Me = [], Pe = [];
      Be.forEach((Ue) => {
        const we = Ue?.data?.GitHub;
        if (!we) {
          d([]), u([]);
          return;
        }
        Object.keys(we).forEach((Ae) => {
          if (Ae.startsWith("repository")) {
            const $e = we[Ae];
            Object.keys($e).forEach((tn) => {
              const Ce = $e[tn], He = {
                number: Ce?.number,
                owner: Ce?.repository?.owner?.login,
                repository: Ce?.repository?.name
              };
              tn.startsWith("issue") && Me.push({
                ...Ce,
                type: "ISSUE",
                key: He
              }), tn.startsWith("pullRequest") && Pe.push({
                ...Ce,
                type: "PR",
                key: He
              });
            });
          }
        });
      }), d(Me), u(Pe);
    }).catch(ie).finally(() => {
      Z(!1);
    });
  }, O = ({ key: pe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = y && (E.length || D.length) ? y : r, Fe = W === "ISSUE" ? "issues" : "pullRequests";
    be.github[Fe] = Array.from(
      new Set(be.github[Fe]).add(pe)
    ), Y(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${ar(
          pe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ar(pe)} failed. Please try again.`
      }
    });
  }, q = async ({ key: pe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = y && (E.length || D.length) ? y : r, Fe = W === "ISSUE" ? "issues" : "pullRequests";
    be.github[Fe] = Array.from(
      new Set(be.github[Fe]).add(pe)
    ), await T(be).catch((K) => {
      v({
        title: "Linking failed",
        text: `Linking ${pe} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: pe, type: W }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = W === "ISSUE" ? "issue" : "pull request";
    F({
      headline: `Unlink ${be} ${ar(pe)}?`,
      text: `You are about to unlink the ${be} ${ar(
        pe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Fe = W === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const K = {
          ...y,
          github: {
            ...y?.github,
            [Fe]: y?.github?.[Fe].filter(
              (Be) => Be.number !== pe.number || Be.owner !== pe.owner || Be.repository !== pe.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), Y(K, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${ar(
              pe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ar(pe)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ge = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), F({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), Y(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, de = E.filter(
    (pe) => !i?.includes(pe)
  ) || [], le = D.filter(
    (pe) => !o?.includes(pe)
  ) || [];
  return {
    linkGithubItem: O,
    linkGithubItemQuietly: q,
    unlinkGithubItem: ee,
    loadGithubItems: M,
    removeDanglingGithubItemLinks: () => {
      const pe = {
        ...y,
        github: {
          ...y?.github,
          issues: E.filter(
            (W) => !de.includes(W)
          ) || [],
          pullRequests: D.filter(
            (W) => !le.includes(W)
          ) || []
        }
      };
      T(pe);
    },
    unlinkAllGithubItems: ge,
    isLoadingGithubItemLinks: C,
    danglingIssueLinks: de,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const vC = "_contentWrapper_1vx3c_1", kC = "_contentWrapperHeadline_1vx3c_4", bC = "_contentWrapperBody_1vx3c_11", _C = "_contentWrapperAssigneeIcon_1vx3c_15", xC = "_contentWrapperStatusTag_1vx3c_20", Vr = {
  contentWrapper: vC,
  contentWrapperHeadline: kC,
  contentWrapperBody: bC,
  contentWrapperAssigneeIcon: _C,
  contentWrapperStatusTag: xC
}, x_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(Qn, { className: Vr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(Qn, { className: Vr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(Qn, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: Vr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(Qn, { className: Vr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      An,
      {
        className: Vr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), SC = "_collapse_1bdjy_1", NC = "_collapseHeader_1bdjy_10", jC = "_collapseHeaderKey_1bdjy_31", wC = "_collapseHeaderKeyIcon_1bdjy_36", CC = "_collapseHeaderKeyLink_1bdjy_41", FC = "_collapseHeaderIcon_1bdjy_44", IC = "_collapseHeaderTitle_1bdjy_49", EC = "_collapseContent_1bdjy_57", TC = "_collapseContentButtonSpacer_1bdjy_60", $C = "_collapseContentButtonLink_1bdjy_63", Nr = {
  collapse: SC,
  collapseHeader: NC,
  collapseHeaderKey: jC,
  collapseHeaderKeyIcon: wC,
  collapseHeaderKeyLink: CC,
  collapseHeaderIcon: FC,
  collapseHeaderTitle: IC,
  collapseContent: EC,
  collapseContentButtonSpacer: TC,
  collapseContentButtonLink: $C
}, DC = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = bn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: F,
      type: S,
      state: N,
      assignees: C,
      labels: y
    } = d, H = a[m];
    return /* @__PURE__ */ xe.jsxs(
      sr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: H,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(sr.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(Qn, { children: /* @__PURE__ */ xe.jsxs(Qn, { as: "span", className: Nr.collapseHeaderKey, children: [
                  tm(
                    S,
                    N,
                    Nr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: Kf(f),
                      className: Nr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (T) => {
                        T.stopPropagation();
                      },
                      children: [
                        ar(f),
                        /* @__PURE__ */ xe.jsx(
                          ue,
                          {
                            className: Nr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(Qn, { className: Nr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(sr.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              x_,
              {
                description: v,
                assignees: C,
                labels: y
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: F?.owner.login,
                    repository: d.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  Gf(S)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              St,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Kf(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Gf(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, RC = "_result_1uaom_1", OC = "_resultName_1uaom_21", PC = "_resultItemIcon_1uaom_29", AC = "_resultDescription_1uaom_34", LC = "_resultLinkIcon_1uaom_46", VC = "_tooltip_1uaom_55", zC = "_tooltipName_1uaom_61", UC = "_tooltipTag_1uaom_71", zr = {
  result: RC,
  resultName: OC,
  resultItemIcon: PC,
  resultDescription: AC,
  resultLinkIcon: LC,
  tooltip: VC,
  tooltipName: zC,
  tooltipTag: UC
}, MC = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ xe.jsx(
    Ke,
    {
      className: zr.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(Qn, { as: "span", className: zr.tooltipName, children: [
                tm(a, o, zr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(An, { className: zr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          x_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: zr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(Qn, { as: "span", className: zr.resultName, children: [
                    tm(a, o, zr.resultItemIcon),
                    ar(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(Qn, { className: zr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              ue,
              {
                className: zr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, BC = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  St,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), ys = "[a-zA-z0-9_.-]+", S_ = "[0-9]+", qC = new RegExp(
  `(${ys})/(${ys})/(?:issues|pull)/(${S_})`,
  "i"
), Yf = new RegExp(`^${qC.source}$`), Jf = new RegExp(
  `https://github.com/(${ys})/(${ys})/(?:issues|pull)/(${S_})`,
  "i"
), HC = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = qn(() => r?.map((D) => D.id) || [], [r]), o = qn(() => i?.map((D) => D.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = mn(), [m, u] = se(), [f, { loading: h, error: v, data: F, networkStatus: S }] = d(pC, {
    notifyOnNetworkStatusChange: !0
  });
  yi(
    () => {
      !h && m && S === Gt.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), qe(() => {
    let D = F?.GitHub?.issues?.nodes || [], U = F?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (D = D.filter((Z) => !a.includes(Z.id))), o.length > 0 && (U = U.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...D.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...U.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [F, a, o]);
  function N(D) {
    const U = D?.trim();
    if (Yf.test(U)) {
      const [Z, Q, ie, Y] = U.match(Yf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(Y)
      };
    }
    if (Jf.test(U)) {
      const [Z, Q, ie, Y] = U.match(Jf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(Y)
      };
    }
  }
  const C = (D) => {
    e({
      key: yC(D),
      type: D.type
    }), u(void 0);
  }, y = (D) => {
    const U = N(D);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${D}`
    );
  }, H = () => {
    u(void 0);
  }, T = ({ className: D, searched: U }) => /* @__PURE__ */ xe.jsx(
    BC,
    {
      className: D,
      searched: U,
      githubOrganization: n
    }
  ), E = ({ item: D, onSelect: U }) => /* @__PURE__ */ xe.jsx(MC, { item: D, onSelect: U });
  return !h && v ? /* @__PURE__ */ xe.jsx(Fn, { error: v }) : /* @__PURE__ */ xe.jsx(
    xr,
    {
      items: s?.map((D) => ({ name: D.title, ...D })),
      loading: h,
      onSearch: y,
      onSelect: C,
      onClear: H,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: T,
      itemComponent: E,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, WC = "_itemButton_3sxfy_1", KC = "_result_3sxfy_6", GC = "_resultName_3sxfy_30", YC = "_resultCheckIcon_3sxfy_38", JC = "_resultAssigneeIcon_3sxfy_41", oa = {
  itemButton: WC,
  result: KC,
  resultName: GC,
  resultCheckIcon: YC,
  resultAssigneeIcon: JC
}, N_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: oa.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: oa.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(Qn, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: oa.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(Qn, { className: oa.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(Qn, { className: oa.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(ue, { name: "done" }) })
        ] })
      }
    )
  }
), QC = Hi(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), XC = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: F }] = a(
    QC,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return yi(
    () => {
      !f && l && l.length >= m && F === Gt.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const S = v?.GitHub?.organization?.teams || { edges: [] }, N = [];
    S?.edges?.forEach((C) => {
      const y = C?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((H) => {
        const T = H?.node;
        T && (T?.id && N.find((E) => E.id === T.id) || N.push(T));
      });
    }), s(
      N.sort((C, y) => {
        const H = C.name?.toLowerCase() || C.login?.toLowerCase(), T = y.name?.toLowerCase() || y.login?.toLowerCase();
        return H.localeCompare(T, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ xe.jsx(Fn, { error: h }) : /* @__PURE__ */ xe.jsx(
    xr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: N, login: C, avatarUrl: y }) => ({
        id: S,
        name: N || C,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (S) => d(S),
      onChange: (S, N) => {
        const C = S.id;
        i ? (N && !n.find(
          (y) => y.id === C
        ) && n.push(S), N || (n = n.filter(
          (y) => y.id !== C
        ))) : n = N ? [S] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: N, checked: C }) => /* @__PURE__ */ xe.jsx(
        N_,
        {
          item: S,
          checked: C,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, ZC = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(br, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        xr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Ds,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(br, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        xr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(br, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Ku, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        XC,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, e1 = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      Pn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: ZC({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), n1 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(ue, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(Pn, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          br,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, t1 = "_modalBody_1hk1o_1", r1 = "_modalBodyFormFields_1hk1o_4", vl = {
  modalBody: t1,
  modalBodyFormFields: r1
}, i1 = Hi(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), a1 = Hi(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), o1 = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], s1 = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = mn(), { track: d } = bn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = tr(), [F, S] = se(""), [N, C] = se([]), [y, H] = se(), [T, E] = se(!1), [D, U] = se(!1), [Z, Q] = l_(), [
    ie,
    {
      loading: Y,
      error: M,
      networkStatus: O
    }
  ] = s(i1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Fe) => {
      C(
        Fe.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), C([]);
    }
  });
  yi(
    () => {
      !Y && F && O === Gt.ready ? ie({
        variables: {
          query: F,
          maxResults: 10
        }
      }) : C([]);
    },
    500,
    [F]
  );
  const [q, { error: ee }] = l(
    a1,
    {
      onError: (Fe) => {
        E(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Fe);
      },
      onCompleted: (Fe) => {
        E(!1);
        const K = Fe.GitHub.createIssue?.issue;
        H(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ge = (Fe) => {
    S(`org:${a} ${Fe}`);
  }, de = (Fe, K) => {
    K(Fe), S("");
  }, le = () => {
    S("");
  }, pe = (Fe) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), E(!0), q({
      variables: {
        input: {
          repositoryId: Fe.repository.id,
          title: Fe.title,
          body: Fe.body,
          assigneeIds: Fe.assignees?.length > 0 ? Fe.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  qe(() => {
    const Fe = D ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Fe);
  }, [D]);
  const W = () => {
    S(""), C([]), H(void 0), E(!1), U(!1);
  }, be = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ xe.jsx(
          jt,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ xe.jsxs(wt, { className: vl.modalBody, children: [
          !Y && M && /* @__PURE__ */ xe.jsx(Fn, { error: M }),
          !T && ee && /* @__PURE__ */ xe.jsx(Fn, { error: ee }),
          y ? /* @__PURE__ */ xe.jsx(
            n1,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: D,
              setIssueLinkCopied: U,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(pe),
              children: /* @__PURE__ */ xe.jsxs(Et, { children: [
                /* @__PURE__ */ xe.jsx(Qe, { children: /* @__PURE__ */ xe.jsx(Pn, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  zt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Fe, value: K } }) => /* @__PURE__ */ xe.jsx(
                      xr,
                      {
                        className: vl.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: Y,
                        onSearch: ge,
                        onSelect: (Be) => de(Be, Fe),
                        onClear: le,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: M ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: Be, onSelect: Me, checked: Pe }) => /* @__PURE__ */ xe.jsx(
                          N_,
                          {
                            item: Be,
                            checked: Pe,
                            onSelectItem: Me
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(Qe, { className: vl.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  e1,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: o1
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          Tt,
          {
            confirmOnClick: y ? be : u(pe),
            confirmProps: {
              isLoading: T,
              loadingIndicator: /* @__PURE__ */ xe.jsx(sn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : be
          }
        )
      ]
    }
  );
}, l1 = "_wrapper_19v8w_1", c1 = "_inputWrapper_19v8w_6", d1 = "_buttonLink_19v8w_19", u1 = "_noItemsFound_19v8w_23", m1 = "_createIssueButton_19v8w_28", Si = {
  wrapper: l1,
  inputWrapper: c1,
  buttonLink: d1,
  noItemsFound: u1,
  createIssueButton: m1
}, p1 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = bn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: F,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: N,
    issues: C,
    pullRequests: y,
    error: H
  } = gC({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), T = (Q) => d({ key: Q, type: "ISSUE" }), E = !(!!C?.length).valueOf() && !(!!y?.length).valueOf() && !(!!F?.length).valueOf() && !(!!S?.length).valueOf(), D = !v && !N && !!F?.length && !!S?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Z = !!C?.length || !!y?.length;
  return !N && H ? /* @__PURE__ */ xe.jsx(Fn, { error: H, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: Si.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: Si.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Si.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: Si.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          HC,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: C,
            linkedPullRequests: y
          }
        )
      ] }),
      N ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(sn, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ xe.jsx(
        DC,
        {
          items: [...C, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx(A.Paragraph, { align: "center", className: Si.noItemsFound, children: "No linked items found." }),
      D && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              F.map((Q) => /* @__PURE__ */ xe.jsx(
                An,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: ar(Q)
                },
                ar(Q)
              )),
              S.map((Q) => /* @__PURE__ */ xe.jsx(
                An,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: ar(Q)
                },
                ar(Q)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ xe.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: E,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        St,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: Si.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      s1,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: T,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, f1 = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
];
var xo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function j_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var kl = { exports: {} }, sa = {}, Qf;
function h1() {
  if (Qf) return sa;
  Qf = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return sa.Fragment = r, sa.jsx = s, sa.jsxs = s, sa;
}
var So = {}, Xf;
function y1() {
  return Xf || (Xf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    So.Fragment = i, So.jsx = Rn, So.jsxs = Bn;
  })()), So;
}
var Zf;
function g1() {
  return Zf || (Zf = 1, process.env.NODE_ENV === "production" ? kl.exports = h1() : kl.exports = y1()), kl.exports;
}
var mi = g1();
function v1(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var bl, eh;
function Zr() {
  if (eh) return bl;
  eh = 1;
  var e = Array.isArray;
  return bl = e, bl;
}
var _l, nh;
function w_() {
  if (nh) return _l;
  nh = 1;
  var e = typeof xo == "object" && xo && xo.Object === Object && xo;
  return _l = e, _l;
}
var xl, th;
function Pr() {
  if (th) return xl;
  th = 1;
  var e = w_(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return xl = r, xl;
}
var Sl, rh;
function co() {
  if (rh) return Sl;
  rh = 1;
  var e = Pr(), n = e.Symbol;
  return Sl = n, Sl;
}
var Nl, ih;
function k1() {
  if (ih) return Nl;
  ih = 1;
  var e = co(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Nl = o, Nl;
}
var jl, ah;
function b1() {
  if (ah) return jl;
  ah = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return jl = r, jl;
}
var wl, oh;
function Wi() {
  if (oh) return wl;
  oh = 1;
  var e = co(), n = k1(), r = b1(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return wl = s, wl;
}
var Cl, sh;
function gi() {
  if (sh) return Cl;
  sh = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Cl = e, Cl;
}
var Fl, lh;
function Jm() {
  if (lh) return Fl;
  lh = 1;
  var e = Wi(), n = gi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Fl = i, Fl;
}
var Il, ch;
function _1() {
  if (ch) return Il;
  ch = 1;
  var e = Zr(), n = Jm(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Il = a, Il;
}
var El, dh;
function Ki() {
  if (dh) return El;
  dh = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return El = e, El;
}
var Tl, uh;
function C_() {
  if (uh) return Tl;
  uh = 1;
  var e = Wi(), n = Ki(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Tl = s, Tl;
}
var $l, mh;
function x1() {
  if (mh) return $l;
  mh = 1;
  var e = Pr(), n = e["__core-js_shared__"];
  return $l = n, $l;
}
var Dl, ph;
function S1() {
  if (ph) return Dl;
  ph = 1;
  var e = x1(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Dl = r, Dl;
}
var Rl, fh;
function F_() {
  if (fh) return Rl;
  fh = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Rl = r, Rl;
}
var Ol, hh;
function N1() {
  if (hh) return Ol;
  hh = 1;
  var e = C_(), n = S1(), r = Ki(), i = F_(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return Ol = f, Ol;
}
var Pl, yh;
function j1() {
  if (yh) return Pl;
  yh = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Pl = e, Pl;
}
var Al, gh;
function vi() {
  if (gh) return Al;
  gh = 1;
  var e = N1(), n = j1();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Al = r, Al;
}
var Ll, vh;
function qs() {
  if (vh) return Ll;
  vh = 1;
  var e = vi(), n = e(Object, "create");
  return Ll = n, Ll;
}
var Vl, kh;
function w1() {
  if (kh) return Vl;
  kh = 1;
  var e = qs();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Vl = n, Vl;
}
var zl, bh;
function C1() {
  if (bh) return zl;
  bh = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return zl = e, zl;
}
var Ul, _h;
function F1() {
  if (_h) return Ul;
  _h = 1;
  var e = qs(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Ul = a, Ul;
}
var Ml, xh;
function I1() {
  if (xh) return Ml;
  xh = 1;
  var e = qs(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Ml = i, Ml;
}
var Bl, Sh;
function E1() {
  if (Sh) return Bl;
  Sh = 1;
  var e = qs(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Bl = r, Bl;
}
var ql, Nh;
function T1() {
  if (Nh) return ql;
  Nh = 1;
  var e = w1(), n = C1(), r = F1(), i = I1(), a = E1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ql = o, ql;
}
var Hl, jh;
function $1() {
  if (jh) return Hl;
  jh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Hl = e, Hl;
}
var Wl, wh;
function I_() {
  if (wh) return Wl;
  wh = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Wl = e, Wl;
}
var Kl, Ch;
function Hs() {
  if (Ch) return Kl;
  Ch = 1;
  var e = I_();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Kl = n, Kl;
}
var Gl, Fh;
function D1() {
  if (Fh) return Gl;
  Fh = 1;
  var e = Hs(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Gl = i, Gl;
}
var Yl, Ih;
function R1() {
  if (Ih) return Yl;
  Ih = 1;
  var e = Hs();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Yl = n, Yl;
}
var Jl, Eh;
function O1() {
  if (Eh) return Jl;
  Eh = 1;
  var e = Hs();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Jl = n, Jl;
}
var Ql, Th;
function P1() {
  if (Th) return Ql;
  Th = 1;
  var e = Hs();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Ql = n, Ql;
}
var Xl, $h;
function Ws() {
  if ($h) return Xl;
  $h = 1;
  var e = $1(), n = D1(), r = R1(), i = O1(), a = P1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Xl = o, Xl;
}
var Zl, Dh;
function Qm() {
  if (Dh) return Zl;
  Dh = 1;
  var e = vi(), n = Pr(), r = e(n, "Map");
  return Zl = r, Zl;
}
var ec, Rh;
function A1() {
  if (Rh) return ec;
  Rh = 1;
  var e = T1(), n = Ws(), r = Qm();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return ec = i, ec;
}
var nc, Oh;
function L1() {
  if (Oh) return nc;
  Oh = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return nc = e, nc;
}
var tc, Ph;
function Ks() {
  if (Ph) return tc;
  Ph = 1;
  var e = L1();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return tc = n, tc;
}
var rc, Ah;
function V1() {
  if (Ah) return rc;
  Ah = 1;
  var e = Ks();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return rc = n, rc;
}
var ic, Lh;
function z1() {
  if (Lh) return ic;
  Lh = 1;
  var e = Ks();
  function n(r) {
    return e(this, r).get(r);
  }
  return ic = n, ic;
}
var ac, Vh;
function U1() {
  if (Vh) return ac;
  Vh = 1;
  var e = Ks();
  function n(r) {
    return e(this, r).has(r);
  }
  return ac = n, ac;
}
var oc, zh;
function M1() {
  if (zh) return oc;
  zh = 1;
  var e = Ks();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return oc = n, oc;
}
var sc, Uh;
function E_() {
  if (Uh) return sc;
  Uh = 1;
  var e = A1(), n = V1(), r = z1(), i = U1(), a = M1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, sc = o, sc;
}
var lc, Mh;
function B1() {
  if (Mh) return lc;
  Mh = 1;
  var e = E_(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, lc = r, lc;
}
var cc, Bh;
function q1() {
  if (Bh) return cc;
  Bh = 1;
  var e = B1(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return cc = r, cc;
}
var dc, qh;
function H1() {
  if (qh) return dc;
  qh = 1;
  var e = q1(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return dc = i, dc;
}
var uc, Hh;
function T_() {
  if (Hh) return uc;
  Hh = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return uc = e, uc;
}
var mc, Wh;
function W1() {
  if (Wh) return mc;
  Wh = 1;
  var e = co(), n = T_(), r = Zr(), i = Jm(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return mc = s, mc;
}
var pc, Kh;
function K1() {
  if (Kh) return pc;
  Kh = 1;
  var e = W1();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return pc = n, pc;
}
var fc, Gh;
function Gi() {
  if (Gh) return fc;
  Gh = 1;
  var e = Zr(), n = _1(), r = H1(), i = K1();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return fc = a, fc;
}
var hc, Yh;
function Gs() {
  if (Yh) return hc;
  Yh = 1;
  var e = Jm();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return hc = n, hc;
}
var yc, Jh;
function $_() {
  if (Jh) return yc;
  Jh = 1;
  var e = Gi(), n = Gs();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return yc = r, yc;
}
var gc, Qh;
function D_() {
  if (Qh) return gc;
  Qh = 1;
  var e = vi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return gc = n, gc;
}
var vc, Xh;
function R_() {
  if (Xh) return vc;
  Xh = 1;
  var e = D_();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return vc = n, vc;
}
var kc, Zh;
function Xm() {
  if (Zh) return kc;
  Zh = 1;
  var e = R_(), n = I_(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return kc = a, kc;
}
var bc, ey;
function Zm() {
  if (ey) return bc;
  ey = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return bc = r, bc;
}
var _c, ny;
function G1() {
  if (ny) return _c;
  ny = 1;
  var e = Xm(), n = Gi(), r = Zm(), i = Ki(), a = Gs();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var F = a(l[u]), S = d;
      if (F === "__proto__" || F === "constructor" || F === "prototype")
        return s;
      if (u != h) {
        var N = v[F];
        S = m ? m(N, F, v) : void 0, S === void 0 && (S = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(v, F, S), v = v[F];
    }
    return s;
  }
  return _c = o, _c;
}
var xc, ty;
function Y1() {
  if (ty) return xc;
  ty = 1;
  var e = $_(), n = G1(), r = Gi();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return xc = i, xc;
}
var Sc, ry;
function J1() {
  if (ry) return Sc;
  ry = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Sc = e, Sc;
}
var Nc, iy;
function Q1() {
  if (iy) return Nc;
  iy = 1;
  var e = Wi(), n = gi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Nc = i, Nc;
}
var jc, ay;
function ep() {
  if (ay) return jc;
  ay = 1;
  var e = Q1(), n = gi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return jc = o, jc;
}
var wc, oy;
function np() {
  if (oy) return wc;
  oy = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return wc = n, wc;
}
var Cc, sy;
function X1() {
  if (sy) return Cc;
  sy = 1;
  var e = Gi(), n = ep(), r = Zr(), i = Zm(), a = np(), o = Gs();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Cc = s, Cc;
}
var Fc, ly;
function Z1() {
  if (ly) return Fc;
  ly = 1;
  var e = J1(), n = X1();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Fc = r, Fc;
}
var Ic, cy;
function eF() {
  if (cy) return Ic;
  cy = 1;
  var e = Y1(), n = Z1();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Ic = r, Ic;
}
var Ec, dy;
function tp() {
  if (dy) return Ec;
  dy = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Ec = e, Ec;
}
var Tc, uy;
function nF() {
  if (uy) return Tc;
  uy = 1;
  var e = co(), n = ep(), r = Zr(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Tc = a, Tc;
}
var $c, my;
function tF() {
  if (my) return $c;
  my = 1;
  var e = tp(), n = nF();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return $c = r, $c;
}
var Dc, py;
function rF() {
  if (py) return Dc;
  py = 1;
  var e = tF();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Dc = n, Dc;
}
var Rc, fy;
function iF() {
  if (fy) return Rc;
  fy = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Rc = e, Rc;
}
var Oc, hy;
function aF() {
  if (hy) return Oc;
  hy = 1;
  var e = iF(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Oc = r, Oc;
}
var Pc, yy;
function oF() {
  if (yy) return Pc;
  yy = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Pc = e, Pc;
}
var Ac, gy;
function O_() {
  if (gy) return Ac;
  gy = 1;
  function e(n) {
    return n;
  }
  return Ac = e, Ac;
}
var Lc, vy;
function sF() {
  if (vy) return Lc;
  vy = 1;
  var e = oF(), n = D_(), r = O_(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Lc = i, Lc;
}
var Vc, ky;
function lF() {
  if (ky) return Vc;
  ky = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Vc = i, Vc;
}
var zc, by;
function cF() {
  if (by) return zc;
  by = 1;
  var e = sF(), n = lF(), r = n(e);
  return zc = r, zc;
}
var Uc, _y;
function P_() {
  if (_y) return Uc;
  _y = 1;
  var e = rF(), n = aF(), r = cF();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Uc = i, Uc;
}
var Mc, xy;
function dF() {
  if (xy) return Mc;
  xy = 1;
  var e = eF(), n = P_(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Mc = r, Mc;
}
var uF = dF();
const A_ = /* @__PURE__ */ j_(uF), mF = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function L_(e) {
  const n = A_(e, mF);
  return {
    controller: Km(n),
    controllerProps: n
  };
}
const pF = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function V_(e) {
  const { controller: n, controllerProps: r } = L_(e), i = {
    ...A_(e, pF),
    required: v1(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Bc, Sy;
function fF() {
  if (Sy) return Bc;
  Sy = 1;
  var e = Ws();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Bc = n, Bc;
}
var qc, Ny;
function hF() {
  if (Ny) return qc;
  Ny = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return qc = e, qc;
}
var Hc, jy;
function yF() {
  if (jy) return Hc;
  jy = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Hc = e, Hc;
}
var Wc, wy;
function gF() {
  if (wy) return Wc;
  wy = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Wc = e, Wc;
}
var Kc, Cy;
function vF() {
  if (Cy) return Kc;
  Cy = 1;
  var e = Ws(), n = Qm(), r = E_(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Kc = a, Kc;
}
var Gc, Fy;
function kF() {
  if (Fy) return Gc;
  Fy = 1;
  var e = Ws(), n = fF(), r = hF(), i = yF(), a = gF(), o = vF();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Gc = s, Gc;
}
var Yc, Iy;
function bF() {
  if (Iy) return Yc;
  Iy = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Yc = e, Yc;
}
var Jc, Ey;
function uo() {
  if (Ey) return Jc;
  Ey = 1;
  var e = Xm(), n = R_();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Jc = r, Jc;
}
var Qc, Ty;
function _F() {
  if (Ty) return Qc;
  Ty = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Qc = e, Qc;
}
var es = { exports: {} }, Xc, $y;
function xF() {
  if ($y) return Xc;
  $y = 1;
  function e() {
    return !1;
  }
  return Xc = e, Xc;
}
es.exports;
var Dy;
function z_() {
  return Dy || (Dy = 1, (function(e, n) {
    var r = Pr(), i = xF(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(es, es.exports)), es.exports;
}
var Zc, Ry;
function SF() {
  if (Ry) return Zc;
  Ry = 1;
  var e = Wi(), n = np(), r = gi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", F = "[object String]", S = "[object WeakMap]", N = "[object ArrayBuffer]", C = "[object DataView]", y = "[object Float32Array]", H = "[object Float64Array]", T = "[object Int8Array]", E = "[object Int16Array]", D = "[object Int32Array]", U = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ie = "[object Uint32Array]", Y = {};
  Y[y] = Y[H] = Y[T] = Y[E] = Y[D] = Y[U] = Y[Z] = Y[Q] = Y[ie] = !0, Y[i] = Y[a] = Y[N] = Y[o] = Y[C] = Y[s] = Y[l] = Y[d] = Y[m] = Y[u] = Y[f] = Y[h] = Y[v] = Y[F] = Y[S] = !1;
  function M(O) {
    return r(O) && n(O.length) && !!Y[e(O)];
  }
  return Zc = M, Zc;
}
var ed, Oy;
function rp() {
  if (Oy) return ed;
  Oy = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return ed = e, ed;
}
var ns = { exports: {} };
ns.exports;
var Py;
function ip() {
  return Py || (Py = 1, (function(e, n) {
    var r = w_(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(ns, ns.exports)), ns.exports;
}
var nd, Ay;
function NF() {
  if (Ay) return nd;
  Ay = 1;
  var e = SF(), n = rp(), r = ip(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return nd = a, nd;
}
var td, Ly;
function U_() {
  if (Ly) return td;
  Ly = 1;
  var e = _F(), n = ep(), r = Zr(), i = z_(), a = Zm(), o = NF(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), F = !f && !h && !v && o(m), S = f || h || v || F, N = S ? e(m.length, String) : [], C = N.length;
    for (var y in m)
      (u || l.call(m, y)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, C))) && N.push(y);
    return N;
  }
  return td = d, td;
}
var rd, Vy;
function ap() {
  if (Vy) return rd;
  Vy = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return rd = n, rd;
}
var id, zy;
function M_() {
  if (zy) return id;
  zy = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return id = e, id;
}
var ad, Uy;
function jF() {
  if (Uy) return ad;
  Uy = 1;
  var e = M_(), n = e(Object.keys, Object);
  return ad = n, ad;
}
var od, My;
function wF() {
  if (My) return od;
  My = 1;
  var e = ap(), n = jF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return od = a, od;
}
var sd, By;
function B_() {
  if (By) return sd;
  By = 1;
  var e = C_(), n = np();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return sd = r, sd;
}
var ld, qy;
function op() {
  if (qy) return ld;
  qy = 1;
  var e = U_(), n = wF(), r = B_();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return ld = i, ld;
}
var cd, Hy;
function CF() {
  if (Hy) return cd;
  Hy = 1;
  var e = uo(), n = op();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return cd = r, cd;
}
var dd, Wy;
function FF() {
  if (Wy) return dd;
  Wy = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return dd = e, dd;
}
var ud, Ky;
function IF() {
  if (Ky) return ud;
  Ky = 1;
  var e = Ki(), n = ap(), r = FF(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return ud = o, ud;
}
var md, Gy;
function sp() {
  if (Gy) return md;
  Gy = 1;
  var e = U_(), n = IF(), r = B_();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return md = i, md;
}
var pd, Yy;
function EF() {
  if (Yy) return pd;
  Yy = 1;
  var e = uo(), n = sp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return pd = r, pd;
}
var ts = { exports: {} };
ts.exports;
var Jy;
function TF() {
  return Jy || (Jy = 1, (function(e, n) {
    var r = Pr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(ts, ts.exports)), ts.exports;
}
var fd, Qy;
function $F() {
  if (Qy) return fd;
  Qy = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return fd = e, fd;
}
var hd, Xy;
function DF() {
  if (Xy) return hd;
  Xy = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return hd = e, hd;
}
var yd, Zy;
function q_() {
  if (Zy) return yd;
  Zy = 1;
  function e() {
    return [];
  }
  return yd = e, yd;
}
var gd, eg;
function lp() {
  if (eg) return gd;
  eg = 1;
  var e = DF(), n = q_(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return gd = o, gd;
}
var vd, ng;
function RF() {
  if (ng) return vd;
  ng = 1;
  var e = uo(), n = lp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return vd = r, vd;
}
var kd, tg;
function cp() {
  if (tg) return kd;
  tg = 1;
  var e = M_(), n = e(Object.getPrototypeOf, Object);
  return kd = n, kd;
}
var bd, rg;
function H_() {
  if (rg) return bd;
  rg = 1;
  var e = tp(), n = cp(), r = lp(), i = q_(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return bd = o, bd;
}
var _d, ig;
function OF() {
  if (ig) return _d;
  ig = 1;
  var e = uo(), n = H_();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return _d = r, _d;
}
var xd, ag;
function W_() {
  if (ag) return xd;
  ag = 1;
  var e = tp(), n = Zr();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return xd = r, xd;
}
var Sd, og;
function PF() {
  if (og) return Sd;
  og = 1;
  var e = W_(), n = lp(), r = op();
  function i(a) {
    return e(a, r, n);
  }
  return Sd = i, Sd;
}
var Nd, sg;
function K_() {
  if (sg) return Nd;
  sg = 1;
  var e = W_(), n = H_(), r = sp();
  function i(a) {
    return e(a, r, n);
  }
  return Nd = i, Nd;
}
var jd, lg;
function AF() {
  if (lg) return jd;
  lg = 1;
  var e = vi(), n = Pr(), r = e(n, "DataView");
  return jd = r, jd;
}
var wd, cg;
function LF() {
  if (cg) return wd;
  cg = 1;
  var e = vi(), n = Pr(), r = e(n, "Promise");
  return wd = r, wd;
}
var Cd, dg;
function VF() {
  if (dg) return Cd;
  dg = 1;
  var e = vi(), n = Pr(), r = e(n, "Set");
  return Cd = r, Cd;
}
var Fd, ug;
function zF() {
  if (ug) return Fd;
  ug = 1;
  var e = vi(), n = Pr(), r = e(n, "WeakMap");
  return Fd = r, Fd;
}
var Id, mg;
function dp() {
  if (mg) return Id;
  mg = 1;
  var e = AF(), n = Qm(), r = LF(), i = VF(), a = zF(), o = Wi(), s = F_(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), F = s(n), S = s(r), N = s(i), C = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(H) {
    var T = o(H), E = T == d ? H.constructor : void 0, D = E ? s(E) : "";
    if (D)
      switch (D) {
        case v:
          return h;
        case F:
          return l;
        case S:
          return m;
        case N:
          return u;
        case C:
          return f;
      }
    return T;
  }), Id = y, Id;
}
var Ed, pg;
function UF() {
  if (pg) return Ed;
  pg = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Ed = r, Ed;
}
var Td, fg;
function MF() {
  if (fg) return Td;
  fg = 1;
  var e = Pr(), n = e.Uint8Array;
  return Td = n, Td;
}
var $d, hg;
function up() {
  if (hg) return $d;
  hg = 1;
  var e = MF();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return $d = n, $d;
}
var Dd, yg;
function BF() {
  if (yg) return Dd;
  yg = 1;
  var e = up();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Dd = n, Dd;
}
var Rd, gg;
function qF() {
  if (gg) return Rd;
  gg = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Rd = n, Rd;
}
var Od, vg;
function HF() {
  if (vg) return Od;
  vg = 1;
  var e = co(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Od = i, Od;
}
var Pd, kg;
function WF() {
  if (kg) return Pd;
  kg = 1;
  var e = up();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Pd = n, Pd;
}
var Ad, bg;
function KF() {
  if (bg) return Ad;
  bg = 1;
  var e = up(), n = BF(), r = qF(), i = HF(), a = WF(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", F = "[object DataView]", S = "[object Float32Array]", N = "[object Float64Array]", C = "[object Int8Array]", y = "[object Int16Array]", H = "[object Int32Array]", T = "[object Uint8Array]", E = "[object Uint8ClampedArray]", D = "[object Uint16Array]", U = "[object Uint32Array]";
  function Z(Q, ie, Y) {
    var M = Q.constructor;
    switch (ie) {
      case v:
        return e(Q);
      case o:
      case s:
        return new M(+Q);
      case F:
        return n(Q, Y);
      case S:
      case N:
      case C:
      case y:
      case H:
      case T:
      case E:
      case D:
      case U:
        return a(Q, Y);
      case l:
        return new M();
      case d:
      case f:
        return new M(Q);
      case m:
        return r(Q);
      case u:
        return new M();
      case h:
        return i(Q);
    }
  }
  return Ad = Z, Ad;
}
var Ld, _g;
function GF() {
  if (_g) return Ld;
  _g = 1;
  var e = Ki(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Ld = r, Ld;
}
var Vd, xg;
function YF() {
  if (xg) return Vd;
  xg = 1;
  var e = GF(), n = cp(), r = ap();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Vd = i, Vd;
}
var zd, Sg;
function JF() {
  if (Sg) return zd;
  Sg = 1;
  var e = dp(), n = gi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return zd = i, zd;
}
var Ud, Ng;
function QF() {
  if (Ng) return Ud;
  Ng = 1;
  var e = JF(), n = rp(), r = ip(), i = r && r.isMap, a = i ? n(i) : e;
  return Ud = a, Ud;
}
var Md, jg;
function XF() {
  if (jg) return Md;
  jg = 1;
  var e = dp(), n = gi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Md = i, Md;
}
var Bd, wg;
function ZF() {
  if (wg) return Bd;
  wg = 1;
  var e = XF(), n = rp(), r = ip(), i = r && r.isSet, a = i ? n(i) : e;
  return Bd = a, Bd;
}
var qd, Cg;
function eI() {
  if (Cg) return qd;
  Cg = 1;
  var e = kF(), n = bF(), r = Xm(), i = CF(), a = EF(), o = TF(), s = $F(), l = RF(), d = OF(), m = PF(), u = K_(), f = dp(), h = UF(), v = KF(), F = YF(), S = Zr(), N = z_(), C = QF(), y = Ki(), H = ZF(), T = op(), E = sp(), D = 1, U = 2, Z = 4, Q = "[object Arguments]", ie = "[object Array]", Y = "[object Boolean]", M = "[object Date]", O = "[object Error]", q = "[object Function]", ee = "[object GeneratorFunction]", ge = "[object Map]", de = "[object Number]", le = "[object Object]", pe = "[object RegExp]", W = "[object Set]", be = "[object String]", Fe = "[object Symbol]", K = "[object WeakMap]", Be = "[object ArrayBuffer]", Me = "[object DataView]", Pe = "[object Float32Array]", Ue = "[object Float64Array]", we = "[object Int8Array]", Ae = "[object Int16Array]", $e = "[object Int32Array]", tn = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", He = "[object Uint16Array]", Ze = "[object Uint32Array]", me = {};
  me[Q] = me[ie] = me[Be] = me[Me] = me[Y] = me[M] = me[Pe] = me[Ue] = me[we] = me[Ae] = me[$e] = me[ge] = me[de] = me[le] = me[pe] = me[W] = me[be] = me[Fe] = me[tn] = me[Ce] = me[He] = me[Ze] = !0, me[O] = me[q] = me[K] = !1;
  function he(Ee, Le, Re, ln, w, _) {
    var $, G = Le & D, J = Le & U, R = Le & Z;
    if (Re && ($ = w ? Re(Ee, ln, w, _) : Re(Ee)), $ !== void 0)
      return $;
    if (!y(Ee))
      return Ee;
    var z = S(Ee);
    if (z) {
      if ($ = h(Ee), !G)
        return s(Ee, $);
    } else {
      var re = f(Ee), fe = re == q || re == ee;
      if (N(Ee))
        return o(Ee, G);
      if (re == le || re == Q || fe && !w) {
        if ($ = J || fe ? {} : F(Ee), !G)
          return J ? d(Ee, a($, Ee)) : l(Ee, i($, Ee));
      } else {
        if (!me[re])
          return w ? Ee : {};
        $ = v(Ee, re, G);
      }
    }
    _ || (_ = new e());
    var _e = _.get(Ee);
    if (_e)
      return _e;
    _.set(Ee, $), H(Ee) ? Ee.forEach(function(rn) {
      $.add(he(rn, Le, Re, rn, Ee, _));
    }) : C(Ee) && Ee.forEach(function(rn, dn) {
      $.set(dn, he(rn, Le, Re, dn, Ee, _));
    });
    var en = R ? J ? u : m : J ? E : T, un = z ? void 0 : en(Ee);
    return n(un || Ee, function(rn, dn) {
      un && (dn = rn, rn = Ee[dn]), r($, dn, he(rn, Le, Re, dn, Ee, _));
    }), $;
  }
  return qd = he, qd;
}
var Hd, Fg;
function nI() {
  if (Fg) return Hd;
  Fg = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Hd = e, Hd;
}
var Wd, Ig;
function tI() {
  if (Ig) return Wd;
  Ig = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Wd = e, Wd;
}
var Kd, Eg;
function rI() {
  if (Eg) return Kd;
  Eg = 1;
  var e = $_(), n = tI();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Kd = r, Kd;
}
var Gd, Tg;
function iI() {
  if (Tg) return Gd;
  Tg = 1;
  var e = Gi(), n = nI(), r = rI(), i = Gs(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return Gd = s, Gd;
}
var Yd, $g;
function aI() {
  if ($g) return Yd;
  $g = 1;
  var e = Wi(), n = cp(), r = gi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return Yd = m, Yd;
}
var Jd, Dg;
function oI() {
  if (Dg) return Jd;
  Dg = 1;
  var e = aI();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Jd = n, Jd;
}
var Qd, Rg;
function sI() {
  if (Rg) return Qd;
  Rg = 1;
  var e = T_(), n = eI(), r = iI(), i = Gi(), a = uo(), o = oI(), s = P_(), l = K_(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var F = {};
    if (h == null)
      return F;
    var S = !1;
    v = e(v, function(C) {
      return C = i(C, h), S || (S = C.length > 1), C;
    }), a(h, l(h), F), S && (F = n(F, d | m | u, o));
    for (var N = v.length; N--; )
      r(F, v[N]);
    return F;
  });
  return Qd = f, Qd;
}
sI();
const _r = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = V_(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ mi.jsx(Pn, { ...a, children: /* @__PURE__ */ mi.jsx(
    Yr,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: Pn.getStatus(a.meta),
      children: e
    }
  ) });
};
var lI = O_();
const cI = /* @__PURE__ */ j_(lI), Ma = ({
  transformValue: e = cI,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = L_(a);
  return /* @__PURE__ */ mi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ mi.jsx(
      Gu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ mi.jsx(a0, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Ft = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = V_(e);
  return /* @__PURE__ */ mi.jsx(Pn, { ...i, children: /* @__PURE__ */ mi.jsx(
    br,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: Pn.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Xd = { exports: {} }, la = {}, Og;
function dI() {
  if (Og) return la;
  Og = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return la.Fragment = r, la.jsx = s, la.jsxs = s, la;
}
var No = {}, Pg;
function uI() {
  return Pg || (Pg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    No.Fragment = i, No.jsx = Rn, No.jsxs = Bn;
  })()), No;
}
var Ag;
function mI() {
  return Ag || (Ag = 1, process.env.NODE_ENV === "production" ? Xd.exports = dI() : Xd.exports = uI()), Xd.exports;
}
var ke = mI(), Pa = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Pa || {}), ii = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ii || {}), Bt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Bt || {});
const pI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, fI = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": pI
};
function hI(e) {
  return fI[e] ?? {};
}
const yI = hI(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Lg = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, G_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, gI = "_listItem_16pij_4", vI = "_clickableIcon_16pij_15", gs = {
  listItem: gI,
  clickableIcon: vI
}, Y_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ ke.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ ke.jsx(ue, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: gs.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ ke.jsx(
              ue,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ ke.jsx(We, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, F = l.currency ?? r;
      return /* @__PURE__ */ ke.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ ke.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ ke.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: G_(f / 100, F) })
          ] }),
          contentRight: h && /* @__PURE__ */ ke.jsx(Bi, { src: h, alt: m ?? "Product image" }),
          className: gs.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, kI = "_boxWrapper_89s7l_1", bI = "_trackButton_89s7l_10", Vg = {
  boxWrapper: kI,
  trackButton: bI
}, _I = {
  [Bt.StepUnknown]: "Unknown",
  [Bt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Bt.StepPreparedByMerchant]: "Prepared by merchant",
  [Bt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Bt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Bt.StepOnRoute]: "On route",
  [Bt.StepDeliveredToPickupPoint]: "At pickup point",
  [Bt.StepDeliveredToConsumer]: "Delivered to customer",
  [Bt.StepDeliveredToMerchant]: "Returned to merchant",
  [Bt.StepReturnRequested]: "Return requested",
  [Bt.StepSentBack]: "Sent back",
  [Bt.StepTerminated]: "Terminated",
  [Bt.StepAwaitingSupplier]: "Awaiting supplier"
}, xI = {
  [ii.Delivery]: "Home delivery",
  [ii.Pickup]: "Pickup point",
  [ii.Instore]: "In-store pickup",
  [ii.Mailbox]: "Mailbox",
  [ii.Inwarehouse]: "Warehouse",
  [ii.Unknown]: "Unknown"
}, SI = {
  [Pa.Outbound]: "From merchant to customer",
  [Pa.Return]: "Return from customer to merchant",
  [Pa.Unspecified]: "Unspecified",
  [Pa.UnknownDirectionType]: "Unknown"
}, NI = (e) => e ? _I[e] ?? e : "", jI = (e) => e ? xI[e] ?? e : "", wI = (e) => e ? SI[e] ?? e : "", CI = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, FI = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = er();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, F = a?.filter((T) => T?.time !== ""), S = NI(F?.[0]?.step), N = jI(u), C = wI(f), y = CI(e.location?.address), H = 14;
  return /* @__PURE__ */ ke.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Vg.boxWrapper,
      children: [
        /* @__PURE__ */ ke.jsx(A.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ ke.jsx(
              ue,
              {
                size: H,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ ke.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ke.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ ke.jsx(
            ue,
            {
              size: H,
              name: n ? "done" : "copy",
              className: gs.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ke.jsx(ue, { size: H, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        C && /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ke.jsx(ue, { size: H, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: C })
          ] })
        ] }),
        h && /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ke.jsx(ue, { size: H, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ ke.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Lg(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Lg(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ke.jsx(ue, { size: H, name: "info", color: "blue.900" }),
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        y && /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ke.jsx(ue, { size: H, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ ke.jsx(Y_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ ke.jsxs(
          St,
          {
            variant: "secondary",
            className: Vg.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ ke.jsx(ue, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, II = "_order_135ze_1", EI = "_orderIsOpen_135ze_9", TI = "_orderHeader_135ze_12", Zd = {
  order: II,
  orderIsOpen: EI,
  orderHeader: TI
}, $I = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = er();
  if (!e)
    return null;
  const {
    cart: s,
    parcels: l,
    external_id: d,
    sender_name: m,
    tos_id: u
  } = e, f = s?.currency || "", h = s?.prices?.total?.price ?? 0, v = G_(h / 100, f), F = 14, S = m && m.trim() !== "" ? m : "unknown sender";
  return /* @__PURE__ */ ke.jsxs(
    b,
    {
      className: ut(Zd.order, {
        [Zd.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ke.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Zd.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  S
                ] }),
                /* @__PURE__ */ ke.jsxs(A.Paragraph, { variant: "3", children: [
                  "#",
                  d
                ] })
              ] }),
              /* @__PURE__ */ ke.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ ke.jsx(
                ue,
                {
                  size: F,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !u && /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  u && /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: u })
                ] })
              ] })
            ] }),
            u && /* @__PURE__ */ ke.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ke.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ ke.jsx(
              ue,
              {
                size: F,
                name: a ? "done" : "copy",
                className: gs.clickableIcon,
                onClick: () => o(u)
              }
            ) }) })
          ] }),
          m && /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ ke.jsx(ue, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", children: m })
            ] })
          ] }),
          /* @__PURE__ */ ke.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ ke.jsx(ue, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", children: v })
            ] })
          ] }),
          /* @__PURE__ */ ke.jsx(
            Y_,
            {
              openByDefault: !0,
              title: "Order items",
              items: s?.items?.map((N) => N),
              currency: s?.currency
            }
          ),
          l && /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ ke.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              l.length > 0 && /* @__PURE__ */ ke.jsx(Un, { variant: "success", size: "small", children: l.length })
            ] }),
            l.length === 0 && /* @__PURE__ */ ke.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            l.map((N, C) => /* @__PURE__ */ ke.jsx(
              FI,
              {
                parcel: N
              },
              `parcel-${C}-${N?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, DI = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, RI = ({
  customerEmail: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(yI, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? HS({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? xb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(DI(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ke.jsx(sn, {}) }) : m || !d && !l ? /* @__PURE__ */ ke.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ ke.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ ke.jsx(Fn, { error: l }) : /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ke.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ ke.jsx(Un, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ ke.jsx(
      $I,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, OI = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ ke.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ ke.jsx(RI, { customerEmail: n })
    }
  );
}, PI = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
], zg = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], AI = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, LI = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i
}) => {
  const a = !e, [o, s] = se(!1), l = tr({
    mode: "onChange",
    defaultValues: AI
  }), {
    loading: d,
    error: m,
    refetch: u
  } = Ib(_b, {
    variables: { id: e },
    skip: !e,
    onCompleted: (T) => {
      const E = T?.Management?.widgetConfigurations?.[0];
      if (!E) {
        s(!0);
        return;
      }
      s(!1), l.reset({
        enabled: !!E.enabled,
        name: E.name,
        ...zS(
          E.settings ?? [],
          zg
        )
      }), E.misconfigured && C(
        E.misconfigurationCause ?? "The configuration of the integration is not correct. Please check the settings."
      );
    }
  }), {
    create: f,
    update: h,
    remove: v,
    isLoading: F,
    error: S,
    misconfigurationCause: N,
    setMisconfigurationCause: C
  } = US({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), y = async (T) => {
    const E = qS(T, zg);
    a ? await f({ name: T.name, enabled: T.enabled, settings: E }) : await h({ name: T.name, enabled: T.enabled, settings: E });
  };
  if (m || S)
    return /* @__PURE__ */ ke.jsx(
      Fn,
      {
        error: m ?? S,
        retry: m ? u : void 0
      }
    );
  if (F || d)
    return /* @__PURE__ */ ke.jsx(sn, { "data-testid": "widget-settings-loading" });
  if (!a && o)
    return /* @__PURE__ */ ke.jsxs(A.Paragraph, { children: [
      "A widget with the id ",
      /* @__PURE__ */ ke.jsx(An, { children: e }),
      " does not exist."
    ] });
  const H = l.watch("name");
  return /* @__PURE__ */ ke.jsx(Bs, { ...l, children: /* @__PURE__ */ ke.jsxs(
    "form",
    {
      noValidate: !0,
      tabIndex: -1,
      "data-testid": `widget-settings-form-${e ?? "create-new"}`,
      onSubmit: l.handleSubmit(y),
      children: [
        N && /* @__PURE__ */ ke.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ke.jsx(
          to,
          {
            variant: "fail",
            headline: "This integration is misconfigured",
            description: /* @__PURE__ */ ke.jsxs(b, { gap: "300", flexDirection: "column", children: [
              /* @__PURE__ */ ke.jsx(A.Paragraph, { children: N }),
              /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ ke.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
                /* @__PURE__ */ ke.jsx(A.Paragraph, { children: "This integration isn’t configured correctly. Please contact your administrator." })
              ] })
            ] })
          }
        ) }),
        /* @__PURE__ */ ke.jsxs(Et, { children: [
          /* @__PURE__ */ ke.jsx(Qe, { children: /* @__PURE__ */ ke.jsx(Pn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ke.jsx(
            Ma,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Ft,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3, children: /* @__PURE__ */ ke.jsx(Pn, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ ke.jsx(
            Ma,
            {
              name: "ingridUseStagingEnvironment",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Ft,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: l.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3, children: /* @__PURE__ */ ke.jsx(
            MS,
            {
              name: "ingridApiToken",
              label: "API token",
              control: l.control,
              isCreationMode: a,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Qe, { span: 3 })
        ] }),
        /* @__PURE__ */ ke.jsx(
          BS,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: H,
            isCreationMode: a,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => v()
          }
        )
      ]
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var eu = { exports: {} }, ca = {}, Ug;
function VI() {
  if (Ug) return ca;
  Ug = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ca.Fragment = r, ca.jsx = s, ca.jsxs = s, ca;
}
var jo = {}, Mg;
function zI() {
  return Mg || (Mg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    jo.Fragment = i, jo.jsx = Rn, jo.jsxs = Bn;
  })()), jo;
}
var Bg;
function UI() {
  return Bg || (Bg = 1, process.env.NODE_ENV === "production" ? eu.exports = VI() : eu.exports = zI()), eu.exports;
}
var ye = UI();
const mp = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => mp(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, MI = "_jiraCode_h30p6_1", BI = "_jiraCodeInline_h30p6_8", nu = {
  jiraCode: MI,
  jiraCodeInline: BI
}, J_ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ye.jsx(ye.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ye.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ye.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ye.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ye.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ye.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ye.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ye.jsx("pre", { children: /* @__PURE__ */ ye.jsx("code", { className: nu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ye.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ye.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ye.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ye.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ye.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ye.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ye.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ye.jsx("code", { className: ut(nu.jiraCode, nu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, vs = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ye.jsx(ue, { size: r, name: "question", className: n }) : /* @__PURE__ */ ye.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, qI = "_collapse_m2gjh_1", HI = "_collapseHeader_m2gjh_10", WI = "_collapseHeaderLink_m2gjh_31", KI = "_collapseHeaderStatus_m2gjh_40", GI = "_collapseHeaderTitle_m2gjh_51", YI = "_collapseContent_m2gjh_59", JI = "_collapseContentHeadline_m2gjh_62", QI = "_collapseContentButtonSpacer_m2gjh_68", XI = "_collapseContentButtonLink_m2gjh_71", ZI = "_collapseContentStatusTag_m2gjh_74", eE = "_collapseContentDescription_m2gjh_77", mr = {
  collapse: qI,
  collapseHeader: HI,
  collapseHeaderLink: WI,
  collapseHeaderStatus: KI,
  collapseHeaderTitle: GI,
  collapseContent: YI,
  collapseContentHeadline: JI,
  collapseContentButtonSpacer: QI,
  collapseContentButtonLink: XI,
  collapseContentStatusTag: ZI,
  collapseContentDescription: eE
}, Q_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, nE = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = bn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = Q_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), F = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ye.jsxs(
      sr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: F,
        className: mr.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(sr.Header, { className: mr.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ye.jsx(vs, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ ye.jsx(
                      "a",
                      {
                        className: mr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ye.jsx(ue, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ye.jsx("span", { className: mr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ye.jsx(An, { className: mr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ye.jsx("div", { className: mr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(sr.Content, { className: mr.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx("div", { className: mr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ye.jsx(Qn, { className: mr.collapseContentDescription, children: u ? mp(u, J_) : "" }),
            /* @__PURE__ */ ye.jsx(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: mr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ye.jsx(
              St,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: mr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, tE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, rE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, iE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, aE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, oE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, sE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, lE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, cE = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': tE,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": rE,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": iE,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": aE,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': oE,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': sE,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": lE
};
function ki(e) {
  return cE[e] ?? {};
}
const X_ = ki(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), dE = ki(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), uE = ki(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), mE = ki(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), pE = ki(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), fE = ki(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), hE = ki(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), pp = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), yE = new RegExp(`^${pp.source}$`), gE = new RegExp(`/${pp.source}$`), qg = new RegExp(
  `.+?[&?]selectedIssue=(${pp.source})[&?]?.*`
);
function Z_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = bn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = mn(), {
    loading: F,
    data: S,
    error: N,
    store: C
  } = Im(e ?? null), [
    y,
    { loading: H, error: T, data: E }
  ] = h(X_, {
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    const le = E?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((pe) => pe?.key).filter(Boolean)));
  }, [E]), qe(
    () => d(N || T || void 0),
    [N, T]
  ), qe(
    () => {
      F || M();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, F]
  );
  const D = async (le, pe) => {
    await C(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: pe.success.title,
        text: pe.success.text
      });
    }).catch((W) => {
      u({
        title: pe.error.title,
        text: `${pe.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = v(dE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (le, pe) => {
    const W = window.location.href, be = pe ? W.replace(
      e?.toString() ?? "",
      pe?.toString()
    ) : W, Fe = pe ? `# ${pe}` : `# ${e}`;
    U({
      variables: {
        issueKey: le,
        title: Fe,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [Q] = v(uE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ie = (le) => {
    const pe = window.location.href;
    Q({
      variables: {
        issueKey: le,
        globalId: `system=${pe}`
      }
    });
  }, Y = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), M = () => {
    S && S.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, O = async (le, pe) => {
    m("jira:issue:link:clicked", Y(le));
    const W = S?.jira?.issues ? S : r;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(le)
    ), await C(W, pe?.toString()).then(() => Z(le, pe)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (le) => {
    m("jira:issue:link:clicked", Y(le));
    const pe = S?.jira?.issues ? S : r;
    pe.jira.issues = Array.from(
      new Set(pe.jira.issues).add(le)
    ), D(pe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => Z(le));
  }, ee = (le) => {
    m("jira:issue:unlink:clicked", Y(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", Y(le));
        const pe = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((W) => W !== le) || []
          }
        };
        D(pe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => ie(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", Y(le))
    });
  }, ge = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && ie(le.key)), D(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, de = S?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: O,
    unlinkIssue: ee,
    loadIssues: M,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (pe) => !de.includes(pe)
          ) || []
        }
      };
      C(le);
    },
    unlinkAllIssues: ge,
    maybeExtractIssueKey: (le) => {
      const pe = le.replace(/\s/g, "");
      if (yE.test(pe))
        return pe;
      if (qg.test(le))
        return le.match(qg)?.[1];
      if (le.startsWith(n) && gE.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: F,
    danglingIssueLinks: de,
    isLoadingIssues: H,
    issues: o,
    error: l
  };
}
function vE(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const kE = "_result_axxxc_48", bE = "_resultName_axxxc_68", _E = "_resultNameIcon_axxxc_76", xE = "_resultDescription_axxxc_81", SE = "_resultLinkIcon_axxxc_93", NE = "_tooltip_axxxc_102", jE = "_tooltipContent_axxxc_108", wE = "_tooltipName_axxxc_115", CE = "_tooltipNameIcon_axxxc_120", FE = "_tooltipDescription_axxxc_125", IE = "_tooltipSummary_axxxc_133", EE = "_tooltipTag_axxxc_137", ir = {
  result: kE,
  resultName: bE,
  resultNameIcon: _E,
  resultDescription: xE,
  resultLinkIcon: SE,
  tooltip: NE,
  tooltipContent: jE,
  tooltipName: wE,
  tooltipNameIcon: CE,
  tooltipDescription: FE,
  tooltipSummary: IE,
  tooltipTag: EE
}, TE = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = Q_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ye.jsx(
    Ke,
    {
      disabled: i,
      className: ir.tooltip,
      content: /* @__PURE__ */ ye.jsxs("div", { className: ir.tooltipContent, children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ye.jsxs("span", { className: ir.tooltipName, children: [
                /* @__PURE__ */ ye.jsx(
                  vs,
                  {
                    width: 16,
                    iconUrl: h,
                    className: ir.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ye.jsx(An, { className: ir.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ye.jsx("div", { className: ir.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ye.jsx("div", { className: ir.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          ...a,
          className: ir.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs("span", { className: ir.resultName, children: [
                    /* @__PURE__ */ ye.jsx(
                      vs,
                      {
                        width: 16,
                        iconUrl: h,
                        className: ir.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ye.jsx("div", { className: ir.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ye.jsx(
              ue,
              {
                className: ir.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, $E = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ye.jsx(
  St,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), DE = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(X_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: F } = Z_(null, n);
  yi(
    () => {
      !u && l && v === Gt.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const T = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      T.map((E) => ({
        id: E?.key ?? "",
        name: E?.key ?? "",
        description: E?.fields.summary,
        status: E?.fields.status,
        issuetype: E?.fields.issuetype,
        text: E?.fields.description ? mp(E?.fields.description, J_) : /* @__PURE__ */ ye.jsx(ye.Fragment, {})
      }))
    );
  }, [h]);
  const S = (T) => {
    e(T.id), d("");
  }, N = (T) => {
    const E = T.trim(), D = F(E);
    if (D) {
      const U = D.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else E !== "" && d(
      `text ~ '${E}'${r ? " and project = " + r : ""}`
    );
  }, C = () => {
    d("");
  }, y = (T) => /* @__PURE__ */ ye.jsx($E, { ...T, jiraInstanceUrl: n }), H = (T) => /* @__PURE__ */ ye.jsx(
    TE,
    {
      ...T,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ye.jsx(Fn, { error: f }) : /* @__PURE__ */ ye.jsx(
    xr,
    {
      items: o,
      loading: u,
      onSearch: N,
      onSelect: S,
      onClear: C,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: H,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, RE = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ye.jsx(
    xr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, OE = "_itemButton_1hl53_1", PE = "_result_1hl53_6", AE = "_resultIcon_1hl53_26", LE = "_resultName_1hl53_30", VE = "_resultCheckIcon_1hl53_38", da = {
  itemButton: OE,
  result: PE,
  resultIcon: AE,
  resultName: LE,
  resultCheckIcon: VE
}, rm = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ye.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ye.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: da.itemButton,
          children: /* @__PURE__ */ ye.jsxs(b, { className: da.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ye.jsx(
              vs,
              {
                width: 36,
                iconUrl: o || "",
                className: da.resultIcon
              }
            ),
            /* @__PURE__ */ ye.jsx(Qn, { className: da.resultName, children: e.name }),
            n && /* @__PURE__ */ ye.jsx(Qn, { className: da.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(ue, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, zE = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: F }] = a(hE, {
    notifyOnNetworkStatusChange: !0
  });
  return yi(
    () => {
      !f && l && l.length >= m && F === Gt.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const N = S?.data?.Jira?.findUsers[0];
        r(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), qe(() => {
    const S = v?.Jira?.findUsers || [];
    s(
      S.filter(({ active: N }) => N).map(({ accountId: N, displayName: C, avatarUrls: y, active: H }) => ({
        id: N,
        name: C,
        avatarUrls: y,
        active: H
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ ye.jsx(Fn, { error: h }) : /* @__PURE__ */ ye.jsx(
    xr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => d(S),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: N, checked: C }) => /* @__PURE__ */ ye.jsx(
        rm,
        {
          item: S,
          checked: C,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Hg = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = l_();
  return qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ye.jsx(b, { children: /* @__PURE__ */ ye.jsx(ue, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ye.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ye.jsx(Ke, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ye.jsx(
      Yt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, UE = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ye.jsx(Hg, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ye.jsx(br, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ye.jsx(Ku, { onChange: n, value: r }) : /* @__PURE__ */ ye.jsx(br, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(Ku, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ye.jsx(br, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        zE,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ye.jsx(
        xr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ye.jsx(RE, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ye.jsx(Hg, { field: e });
  }
}, ME = ["description", "reporter", "summary"], BE = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || ME.includes(o)
).map((o) => /* @__PURE__ */ ye.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      Pn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: UE({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), qE = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ye.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ye.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ye.jsx(ue, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ye.jsx(Pn, { label: "Jira issue link", children: /* @__PURE__ */ ye.jsx(
        br,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), HE = "_modalBody_1hk1o_1", WE = "_modalBodyFormFields_1hk1o_4", Wg = {
  modalBody: HE,
  modalBodyFormFields: WE
}, KE = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), GE = (e) => e?.custom?.split(":")?.[1] || null, YE = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, JE = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = YE(a, n), l = GE(s) ?? a;
        return r.includes(l) ? i[a] = KE(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, QE = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, F] = se([]), [S, N] = se([]), [C, y] = se(!1), [H, T] = se(!1), [E, D] = se({}), { track: U } = bn(), { isCopied: Z, copyToClipboard: Q } = vE(), ie = qn(() => i?.conversationId, [e]), { useMutation: Y, useLazyQuery: M, showNotification: O } = mn(), {
    control: q,
    handleSubmit: ee,
    formState: { errors: ge },
    reset: de,
    setValue: le,
    getValues: pe
  } = tr({
    defaultValues: s
  }), W = S.length > 0, be = `${a}/browse`, Fe = Object.keys(E).length > 0, [K, { loading: Be, error: Me }] = M(mE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      d(he.Jira.getAllProjects);
    },
    onError: (he) => {
      O({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", he), d([]);
    }
  }), [
    Pe,
    { loading: Ue, error: we }
  ] = M(pE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      h(0);
      const Ee = he?.Jira?.getCreateIssueMeta?.projects[0];
      if (Ee) {
        const Le = Ee?.issuetypes.filter(
          ({ subtask: Re }) => !Re
        );
        F(Le || []), le(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        O({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), F([]), N([]);
    },
    onError: (he) => {
      O({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", he), F([]), N([]), h(0);
    }
  }), [Ae, { error: $e }] = Y(
    fE,
    {
      onError: () => {
        y(!1), O({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (he) => {
        if (y(!1), he?.Jira && "key" in he.Jira.createIssue)
          u(he?.Jira?.createIssue), O({
            title: "Success",
            text: `Jira issue '${he.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: he.Jira.createIssue.key
          }), ie && r(
            he.Jira.createIssue.key,
            ie
          );
        else if ("errorMessages" in he.Jira.createIssue || "errors" in he.Jira.createIssue) {
          const Ee = he?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Ee), O({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), tn = (he) => {
    y(!0), D({}), Ae({
      variables: {
        input: JE(he, S)
      }
    });
  };
  qe(() => {
    if (e)
      try {
        K();
      } catch (he) {
        console.warn("Error when fetching initial projects", he);
      }
  }, [e]), qe(() => {
    const he = H ? window.setTimeout(() => T(!1), 2e3) : void 0;
    return () => window.clearTimeout(he);
  }, [H]), qe(() => {
    if (v?.length > 0) {
      le("issuetype", v[f]);
      const he = v[f]?.fields?.additionalProperties;
      if (he?.length > 0) {
        const Ee = he.map(
          ({ value: w }) => w
        ), Le = (o ? Ee.sort(({ name: w }, { name: _ }) => w.localeCompare(_)) : Ee).sort(
          ({ required: w }, { required: _ }) => Number(_) - Number(w)
        ), { project: Re, issuetype: ln } = pe();
        de({ project: Re, issuetype: ln }), N(Le);
      }
    } else
      N([]), le("issuetype", void 0);
  }, [v, le, f]), qe(() => {
    if ($e && Eb($e)) {
      if ($e?.graphQLErrors?.length > 0) {
        const { graphQLErrors: he } = $e, Ee = he[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(Ee);
          if (Le?.errors) {
            const Re = Object.keys(Le.errors).reduce(
              (ln, w) => ({
                ...ln,
                [w]: {
                  type: "required",
                  message: Le.errors[w],
                  ref: {
                    name: w
                  }
                }
              }),
              {}
            );
            D(Re);
          }
        } catch {
        }
      }
    } else
      D({});
  }, [$e]);
  const Ce = () => {
    d([]), N([]), F([]), u(void 0), h(0), y(!1), D({});
  }, He = () => {
    Ce(), de(s), n();
  }, Ze = (he) => {
    he && Pe({
      variables: {
        projectKey: he
      }
    });
  }, me = (he) => {
    const Ee = v.map((Le) => Le.id).indexOf(he);
    h(Ee ?? 0);
  };
  return /* @__PURE__ */ ye.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: He,
      children: [
        /* @__PURE__ */ ye.jsx(
          jt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: He
          }
        ),
        /* @__PURE__ */ ye.jsxs(wt, { className: Wg.modalBody, children: [
          !Be && Me && /* @__PURE__ */ ye.jsx(Fn, { error: Me, retry: K }),
          !Ue && we && /* @__PURE__ */ ye.jsx(
            Fn,
            {
              error: we,
              retry: Pe
            }
          ),
          !C && Fe && /* @__PURE__ */ ye.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ye.jsx(
            to,
            {
              variant: "warning",
              description: /* @__PURE__ */ ye.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ye.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ye.jsx(
                      Kn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ye.jsx(
            qE,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: H,
              setIssueLinkCopied: T,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(tn),
              children: /* @__PURE__ */ ye.jsxs(Et, { children: [
                /* @__PURE__ */ ye.jsx(Qe, { span: 3, children: /* @__PURE__ */ ye.jsx(Pn, { label: "Project", required: !0, children: /* @__PURE__ */ ye.jsx(
                  zt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: he, value: Ee } }) => /* @__PURE__ */ ye.jsx(
                      xr,
                      {
                        searchable: !0,
                        loading: Be,
                        onSelect: (Le) => {
                          Ze(Le.key), he(Le);
                        },
                        selectedItems: [Ee],
                        placeholder: "Select Jira project",
                        emptyMessage: Me ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Re, checked: ln }) => /* @__PURE__ */ ye.jsx(
                          rm,
                          {
                            item: Le,
                            checked: ln,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(Qe, { span: 3, children: /* @__PURE__ */ ye.jsx(Pn, { label: "Issue type", required: !0, children: /* @__PURE__ */ ye.jsx(
                  zt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: he, value: Ee } }) => /* @__PURE__ */ ye.jsx(
                      xr,
                      {
                        disabled: v.length === 0,
                        loading: Ue,
                        onSelect: (Le) => {
                          me(Le.id), he(Le);
                        },
                        selectedItems: [Ee],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: we ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Le, onSelect: Re, checked: ln }) => /* @__PURE__ */ ye.jsx(
                          rm,
                          {
                            item: Le,
                            checked: ln,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ye.jsx(Qe, { className: Wg.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  BE,
                  {
                    control: q,
                    errors: { ...ge, ...E },
                    getValues: pe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          Tt,
          {
            confirmOnClick: m ? He : ee(tn),
            confirmProps: {
              disabled: !W,
              isLoading: C,
              loadingIndicator: /* @__PURE__ */ ye.jsx(sn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : He
          }
        )
      ]
    }
  );
}, XE = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, ZE = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, eT = "_wrapper_1bylq_1", nT = "_inputWrapper_1bylq_6", tT = "_inputSeparator_1bylq_18", rT = "_buttonLink_1bylq_23", iT = "_noIssuesFound_1bylq_27", ua = {
  wrapper: eT,
  inputWrapper: nT,
  inputSeparator: tT,
  buttonLink: rT,
  noIssuesFound: iT
}, aT = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = bn(), i = XE(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: F,
    isLoadingIssues: S,
    issues: N,
    error: C
  } = Z_(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, H = !!n?.enableSortIssueTypeByLabel, T = !!(N?.length || v?.length), E = !!n?.enableRemoveAllLinks && T, D = !F && !S && v?.length > 0 && !!n?.showDanglingLinks;
  return !S && C ? /* @__PURE__ */ ye.jsx(Fn, { error: C, retry: () => f() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: ua.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: ua.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: ua.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          DE,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ye.jsx(sn, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ ye.jsx(
        nE,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ye.jsx(A.Paragraph, { align: "center", className: ua.noIssuesFound, children: "No linked issues found" }),
      E && N?.length > 0 && /* @__PURE__ */ ye.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: !N?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      D && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((U) => /* @__PURE__ */ ye.jsx(An, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ ye.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ye.jsx(
        St,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: ua.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ye.jsx(
      QE,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: H
      }
    )
  ] });
}, Kg = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => ZE(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var tu = { exports: {} }, ma = {}, Gg;
function oT() {
  if (Gg) return ma;
  Gg = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ma.Fragment = r, ma.jsx = s, ma.jsxs = s, ma;
}
var wo = {}, Yg;
function sT() {
  return Yg || (Yg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    wo.Fragment = i, wo.jsx = Rn, wo.jsxs = Bn;
  })()), wo;
}
var Jg;
function lT() {
  return Jg || (Jg = 1, process.env.NODE_ENV === "production" ? tu.exports = oT() : tu.exports = sT()), tu.exports;
}
var Te = lT();
function cT({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = mn(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((F) => {
        const S = setTimeout(F, r);
        d([...l, S]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
var ex = /* @__PURE__ */ ((e) => (e.List = "list", e))(ex || {}), im = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(im || {}), am = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(am || {});
const dT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, uT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, mT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, pT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, fT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, hT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, yT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, gT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, vT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, kT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, bT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, _T = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, xT = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": dT,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": uT,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": pT,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": fT,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": mT,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": hT,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": yT,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": gT,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": vT,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": kT,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": bT,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": _T
};
function Hr(e) {
  return xT[e] ?? {};
}
const ST = Hr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), NT = Hr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), jT = Hr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), wT = Hr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), CT = Hr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), FT = Hr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), IT = Hr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ET = Hr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), TT = Hr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function om(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function Qg(e) {
  return om(e) && e?.attributes?.event_properties?.$message;
}
function $T(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function Xg(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function DT(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function RT(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function OT(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function PT(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function AT(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function LT(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Zg(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function VT(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function zT(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const UT = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function MT(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function BT(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function qT({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = mn(), { track: a } = bn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, F] = se(
    null
  ), [S, N] = se([]), {
    data: C,
    error: y,
    loading: H,
    networkStatus: T
  } = i(jT, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    E,
    {
      data: D,
      error: U,
      loading: Z,
      networkStatus: Q
    }
  ] = r(ST, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return qe(() => {
    if (C && !H && T === Gt.ready) {
      const ie = DT(C);
      s(
        ie.find((Y) => Y?.attributes?.name === "Received Email")?.id || null
      ), d(
        ie.find((Y) => Y?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ie.find((Y) => Y?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ie.find((Y) => Y?.attributes?.name === "Bounced Email")?.id || null
      ), F(
        ie.find((Y) => Y?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), F(null);
  }, [C]), qe(() => {
    o && l && m && f && v && !Z && Q === Gt.ready ? E({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), qe(() => {
    if (!Z && D) {
      const ie = RT(D), Y = PT(
        D
      ).map(
        (de) => de?.attributes?.event_properties.$message
      ), M = AT(
        D
      ).map(
        (de) => de?.attributes?.event_properties.$message
      );
      ie.forEach((de) => {
        const le = de.attributes?.event_properties.$message;
        de.opened = Y.includes(le), de.clicked = M.includes(le);
      });
      const O = OT(D), q = LT(D), ee = [
        ...ie,
        ...q,
        ...O
      ].sort((de, le) => {
        const pe = Xg(de), W = Xg(le);
        return pe == null && W == null ? 0 : pe == null ? 1 : W == null ? -1 : W - pe;
      }).slice(0, n);
      N(ee);
      const ge = ee.map((de) => de.id);
      a("klaviyo:messages:received", {
        emailsReceived: ie.filter(
          (de) => ge.includes(de.id)
        ).length,
        emailsBounced: q.filter(
          (de) => ge.includes(de.id)
        ).length,
        smsReceived: O.filter(
          (de) => ge.includes(de.id)
        ).length,
        total: ge.length
      });
    } else
      N([]);
  }, [Z, D]), qn(
    () => ({
      receivedMessages: S,
      isLoading: H || Z,
      error: y || U
    }),
    [
      S,
      H,
      Z,
      y,
      U
    ]
  );
}
function HT({ profileId: e }) {
  const { useQuery: n } = mn(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(CT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  qe(() => {
    l && o(l);
  }, [l]), qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return qn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function WT({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = bn(), { useLazyQuery: i } = mn(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(wT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, F = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, F);
    }
  }, [f, m]);
  const h = (v, F) => {
    const S = v?.data?.length === 1 && v.data[0]?.id || void 0, N = F?.data?.length === 1 && F.data[0]?.id || void 0, C = S || N, y = !S || !N || S === N;
    if (C && y) {
      o(S || N), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return qn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const ev = 800, KT = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, GT = 3, YT = 1.5, JT = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = GT,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = se(0), [d, m] = se(n || ev), [u, f] = se(r || KT), [h, v] = se(!1), [F, S] = se(!1), N = a || !!r, C = N ? o(u) : n || ev, [y, H] = se(C);
  Ow(
    async () => {
      const U = s + 1, Z = YT ** U;
      l(U), H(
        (N ? o(u) : d) * Z
      ), await e().then(() => {
        S(!0), D();
      });
    },
    h ? y : null
  ), Aw(() => D());
  const T = tt(() => {
    l(0), H(C);
  }, [C]), E = tt(
    (U = {}) => {
      const { delay: Z, delayRange: Q } = U;
      S(!1), T(), Q && (f(Q), H(o(Q))), Z && (m(Z), H(Z)), v(!0);
    },
    [T]
  ), D = tt(() => {
    v(!1), T();
  }, [T]);
  return qe(() => {
    s >= i && D();
  }, [s, i, D]), qn(
    () => ({ isRunning: h, isSuccessful: F, start: E, stop: D }),
    [h, F, E, D]
  );
}, QT = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, XT = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function ZT({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = mn(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? FT : IT,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: F
  } = JT({
    query: u,
    useDelayRange: !0
  }), S = m || h;
  return qe(() => {
    if (d)
      if (GS({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const N = QT(d);
          v({
            ...N && {
              delayRange: XT(N)
            }
          });
        }
      } else
        s(d);
  }, [d]), qe(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, C = {};
      n === "lists" && (N = l?.Klaviyo?.get_profile_lists), n === "segments" && (C = l?.Klaviyo?.get_profile_segments), (N?.data || C?.data) && (F(), a(
        (n === "lists" ? N?.data : C?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), qn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, v]
  );
}
const e$ = "_notificationText_1polx_1", fp = {
  notificationText: e$
}, Ys = ({ error: e }) => {
  const { track: n } = bn();
  let r = e;
  if (Eb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && xb({ error: i[0] }), o = i.length === 1 && KS({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Te.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ Te.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Te.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ Te.jsx(ue, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, n$ = "_message_1vrar_48", t$ = "_messageIsOpen_1vrar_56", r$ = "_messageHeader_1vrar_59", i$ = "_messageLabel_1vrar_65", a$ = "_messageText_1vrar_68", Oi = {
  message: n$,
  messageIsOpen: t$,
  messageHeader: r$,
  messageLabel: i$,
  messageText: a$
}, o$ = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && VT(e.flowMessage);
  return /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
    /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", className: Oi.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Te.jsx(sn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Te.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Oi.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", className: Oi.messageText, children: i })
        ]
      }
    )
  ] });
}, s$ = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Te.jsx(Te.Fragment, { children: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Te.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, l$ = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = qn(
    () => () => l ? Ln(l).format(m) : d ? Ln.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, F = f && e.clicked, S = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], C = f ? "mail" : "sms";
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ut(Oi.message, {
        [Oi.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Te.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Oi.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Te.jsx(ue, { size: 16, name: C }),
                  " ",
                  UT(s),
                  u && /* @__PURE__ */ Te.jsx(Un, { size: "small", variant: "info", children: u })
                ] }),
                S && S,
                N && N
              ] }),
              /* @__PURE__ */ Te.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Te.jsx(Tm, {}),
          $T(e) && /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(Un, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
            /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Te.jsx(An, { children: /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Te.jsx(
                  ue,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Te.jsx(An, { children: /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Te.jsx(
                  ue,
                  {
                    size: 16,
                    color: F ? "green.400" : "red.400",
                    name: F ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Te.jsx(o$, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Te.jsx(s$, { event: e })
        ] })
      ]
    }
  );
}, c$ = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, d$ = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = qT({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = cT({
    query: NT,
    options: c$,
    delayMs: 1e3
  }), [m, u] = se([]);
  qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => om(v)).map((v) => Qg(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && om(h) && !h.flowMessage) {
          const v = Qg(h), F = d.find((N) => (N.data && Zg(N.data))?.id === v), S = F?.data && Zg(F.data);
          if (S)
            return {
              ...zT(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Te.jsx(Te.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ Te.jsx(
    Fn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ Te.jsx(
    Ys,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(sn, {}) }) : /* @__PURE__ */ Te.jsx(Te.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ Te.jsx(
      l$,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: fp.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, u$ = "_list_ld0hf_1", m$ = "_listItem_ld0hf_4", Aa = {
  list: u$,
  listItem: m$
}, nv = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = ZT({ profileId: e, query: n });
  qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ Te.jsx(Ys, { error: o }) : s ? /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ Te.jsx(sn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ Te.jsx(Te.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Te.jsx(An, { children: $s(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Te.jsx(ue, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Te.jsx(Ke, { content: "Refresh lists and segments", children: /* @__PURE__ */ Te.jsx(Kn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ Te.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Te.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, p$ = "_tagHover_kzbzk_1", f$ = "_channelUnsubscribed_kzbzk_6", tv = {
  tagHover: p$,
  channelUnsubscribed: f$
}, rv = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Te.jsx(
    Ke,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Te.jsx(
        An,
        {
          className: tv.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Te.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ut({
                [tv.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Te.jsx(sn, { size: 16 }) : /* @__PURE__ */ Te.jsx(ue, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, h$ = "_subscriptionError_1qhhx_1", y$ = {
  subscriptionError: h$
}, g$ = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = bn(), [v, F] = Pw({
    channel: null,
    request: null
  }), S = MT(n), N = BT(n), C = !!e, { useMutation: y } = mn(), [H] = y(
    ET
  ), [T] = y(
    TT
  ), E = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), F.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => H({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: im.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: am.Subscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: am.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: ex.List,
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, D = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), F.setAll({
      channel: Z,
      request: "unsubscribed"
    }), T({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: im.Profile,
                attributes: {
                  ...Z === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: ie,
    isSubscriptionRequest: Y
  }) => {
    const M = ie?.networkError, O = M ? M?.statusCode : NaN, q = Q?.errors, ee = !!q && Sb({
      errors: q
    });
    O === 202 ? (h(
      Y ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ee ? (h(
      Y ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${Y ? "opt-in" : "opt-out"}.`
    )) : (h(
      Y ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: M?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${Y ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return qe(() => {
    if (v.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), F.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), F.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ Te.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(
            rv,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: C,
              handleAction: () => {
                l(!0), f(void 0), S ? D("EMAIL") : E("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Te.jsx(
            rv,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: C,
              handleAction: () => {
                m(!0), f(void 0), N ? D("SMS") : E("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ Te.jsx(b, { className: y$.subscriptionError, children: u })
      ] })
    }
  );
}, v$ = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: d,
    error: m,
    isLoading: u,
    refetchProfile: f
  } = HT({ profileId: e });
  return m ? /* @__PURE__ */ Te.jsx(Ys, { error: m }) : u ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(sn, {}) }) : !d && !u ? /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: fp.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Te.jsxs(We, { className: Aa.list, children: [
        i && /* @__PURE__ */ Te.jsx(nv, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Te.jsx(
          nv,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ Te.jsx(
      g$,
      {
        profile: d,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: r
      }
    ),
    /* @__PURE__ */ Te.jsx(
      d$,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, k$ = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: m,
    getProfileId: u,
    isLoading: f,
    error: h
  } = WT({ email: r, phoneNumber: i });
  return n0(() => {
    (r || i) && u({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(sn, {}) }) : h ? /* @__PURE__ */ Te.jsx(Ys, { error: h }) : m ? /* @__PURE__ */ Te.jsx(
    v$,
    {
      profileId: m,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: fp.notificationText,
      children: "No profile ID found"
    }
  );
}, b$ = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: WS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], _$ = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
], x$ = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function S$(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const N$ = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, j$ = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, w$ = {};
function iv(e, n) {
  return (w$.jsx ? j$ : N$).test(e);
}
const C$ = /[ \t\n\f\r]/g;
function F$(e) {
  return typeof e == "object" ? e.type === "text" ? av(e.value) : !1 : av(e);
}
function av(e) {
  return e.replace(C$, "") === "";
}
class mo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
mo.prototype.property = {};
mo.prototype.normal = {};
mo.prototype.space = null;
function nx(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new mo(r, i, n);
}
function sm(e) {
  return e.toLowerCase();
}
class dr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
dr.prototype.space = null;
dr.prototype.boolean = !1;
dr.prototype.booleanish = !1;
dr.prototype.overloadedBoolean = !1;
dr.prototype.number = !1;
dr.prototype.commaSeparated = !1;
dr.prototype.spaceSeparated = !1;
dr.prototype.commaOrSpaceSeparated = !1;
dr.prototype.mustUseProperty = !1;
dr.prototype.defined = !1;
let I$ = 0;
const In = bi(), pt = bi(), tx = bi(), Ve = bi(), Zn = bi(), Pi = bi(), Jt = bi();
function bi() {
  return 2 ** ++I$;
}
const lm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: In,
  booleanish: pt,
  commaOrSpaceSeparated: Jt,
  commaSeparated: Pi,
  number: Ve,
  overloadedBoolean: tx,
  spaceSeparated: Zn
}, Symbol.toStringTag, { value: "Module" })), ru = Object.keys(lm);
class hp extends dr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), ov(this, "space", a), typeof i == "number")
      for (; ++o < ru.length; ) {
        const s = ru[o];
        ov(this, ru[o], (i & lm[s]) === lm[s]);
      }
  }
}
hp.prototype.defined = !0;
function ov(e, n, r) {
  r && (e[n] = r);
}
const E$ = {}.hasOwnProperty;
function Yi(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (E$.call(e.properties, i)) {
      const a = e.properties[i], o = new hp(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[sm(i)] = i, r[sm(o.attribute)] = i;
    }
  return new mo(n, r, e.space);
}
const rx = Yi({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), ix = Yi({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function ax(e, n) {
  return n in e ? e[n] : n;
}
function ox(e, n) {
  return ax(e, n.toLowerCase());
}
const sx = Yi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: ox,
  properties: { xmlns: null, xmlnsXLink: null }
}), lx = Yi({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: pt,
    ariaAutoComplete: null,
    ariaBusy: pt,
    ariaChecked: pt,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Zn,
    ariaCurrent: null,
    ariaDescribedBy: Zn,
    ariaDetails: null,
    ariaDisabled: pt,
    ariaDropEffect: Zn,
    ariaErrorMessage: null,
    ariaExpanded: pt,
    ariaFlowTo: Zn,
    ariaGrabbed: pt,
    ariaHasPopup: null,
    ariaHidden: pt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Zn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: pt,
    ariaMultiLine: pt,
    ariaMultiSelectable: pt,
    ariaOrientation: null,
    ariaOwns: Zn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: pt,
    ariaReadOnly: pt,
    ariaRelevant: null,
    ariaRequired: pt,
    ariaRoleDescription: Zn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: pt,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), T$ = Yi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: ox,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Pi,
    acceptCharset: Zn,
    accessKey: Zn,
    action: null,
    allow: null,
    allowFullScreen: In,
    allowPaymentRequest: In,
    allowUserMedia: In,
    alt: null,
    as: null,
    async: In,
    autoCapitalize: null,
    autoComplete: Zn,
    autoFocus: In,
    autoPlay: In,
    blocking: Zn,
    capture: null,
    charSet: null,
    checked: In,
    cite: null,
    className: Zn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: pt,
    controls: In,
    controlsList: Zn,
    coords: Ve | Pi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: In,
    defer: In,
    dir: null,
    dirName: null,
    disabled: In,
    download: tx,
    draggable: pt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: In,
    formTarget: null,
    headers: Zn,
    height: Ve,
    hidden: In,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Zn,
    httpEquiv: Zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: In,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: In,
    itemId: null,
    itemProp: Zn,
    itemRef: Zn,
    itemScope: In,
    itemType: Zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: In,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: In,
    muted: In,
    name: null,
    nonce: null,
    noModule: In,
    noValidate: In,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: In,
    optimum: Ve,
    pattern: null,
    ping: Zn,
    placeholder: null,
    playsInline: In,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: In,
    referrerPolicy: null,
    rel: Zn,
    required: In,
    reversed: In,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Zn,
    scope: null,
    scoped: In,
    seamless: In,
    selected: In,
    shadowRootClonable: In,
    shadowRootDelegatesFocus: In,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: pt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: In,
    useMap: null,
    value: pt,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: In,
    // Lists. Use CSS to reduce space between items instead
    declare: In,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: In,
    // `<frame>`
    noHref: In,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: In,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: In,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: pt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: In,
    disableRemotePlayback: In,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), $$ = Yi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: ax,
  properties: {
    about: Jt,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: In,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Pi,
    g2: Pi,
    glyphName: Pi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), D$ = /^data[-\w.:]+$/i, sv = /-[a-z]/g, R$ = /[A-Z]/g;
function O$(e, n) {
  const r = sm(n);
  let i = n, a = dr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && D$.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(sv, A$);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!sv.test(o)) {
        let s = o.replace(R$, P$);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = hp;
  }
  return new a(i, n);
}
function P$(e) {
  return "-" + e.toLowerCase();
}
function A$(e) {
  return e.charAt(1).toUpperCase();
}
const L$ = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, V$ = nx([ix, rx, sx, lx, T$], "html"), yp = nx([ix, rx, sx, lx, $$], "svg");
function z$(e) {
  return e.join(" ").trim();
}
var Ni = {}, iu, lv;
function U$() {
  if (lv) return iu;
  lv = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  iu = function(S, N) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    N = N || {};
    var C = 1, y = 1;
    function H(O) {
      var q = O.match(n);
      q && (C += q.length);
      var ee = O.lastIndexOf(d);
      y = ~ee ? O.length - ee : y + O.length;
    }
    function T() {
      var O = { line: C, column: y };
      return function(q) {
        return q.position = new E(O), Z(), q;
      };
    }
    function E(O) {
      this.start = O, this.end = { line: C, column: y }, this.source = N.source;
    }
    E.prototype.content = S;
    function D(O) {
      var q = new Error(
        N.source + ":" + C + ":" + y + ": " + O
      );
      if (q.reason = O, q.filename = N.source, q.line = C, q.column = y, q.source = S, !N.silent) throw q;
    }
    function U(O) {
      var q = O.exec(S);
      if (q) {
        var ee = q[0];
        return H(ee), S = S.slice(ee.length), q;
      }
    }
    function Z() {
      U(r);
    }
    function Q(O) {
      var q;
      for (O = O || []; q = ie(); )
        q !== !1 && O.push(q);
      return O;
    }
    function ie() {
      var O = T();
      if (!(m != S.charAt(0) || u != S.charAt(1))) {
        for (var q = 2; f != S.charAt(q) && (u != S.charAt(q) || m != S.charAt(q + 1)); )
          ++q;
        if (q += 2, f === S.charAt(q - 1))
          return D("End of comment missing");
        var ee = S.slice(2, q - 2);
        return y += 2, H(ee), S = S.slice(q), y += 2, O({
          type: h,
          comment: ee
        });
      }
    }
    function Y() {
      var O = T(), q = U(i);
      if (q) {
        if (ie(), !U(a)) return D("property missing ':'");
        var ee = U(o), ge = O({
          type: v,
          property: F(q[0].replace(e, f)),
          value: ee ? F(ee[0].replace(e, f)) : f
        });
        return U(s), ge;
      }
    }
    function M() {
      var O = [];
      Q(O);
      for (var q; q = Y(); )
        q !== !1 && (O.push(q), Q(O));
      return O;
    }
    return Z(), M();
  };
  function F(S) {
    return S ? S.replace(l, f) : f;
  }
  return iu;
}
var cv;
function M$() {
  if (cv) return Ni;
  cv = 1;
  var e = Ni && Ni.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.default = r;
  var n = e(U$());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ni;
}
var B$ = M$();
const dv = /* @__PURE__ */ Rm(B$), q$ = dv.default || dv, cx = dx("end"), gp = dx("start");
function dx(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function H$(e) {
  const n = gp(e), r = cx(e);
  if (n && r)
    return { start: n, end: r };
}
function Ba(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? uv(e.position) : "start" in e || "end" in e ? uv(e) : "line" in e || "column" in e ? cm(e) : "";
}
function cm(e) {
  return mv(e && e.line) + ":" + mv(e && e.column);
}
function uv(e) {
  return cm(e && e.start) + "-" + cm(e && e.end);
}
function mv(e) {
  return e && typeof e == "number" ? e : 1;
}
class $t extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ba(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
$t.prototype.file = "";
$t.prototype.name = "";
$t.prototype.reason = "";
$t.prototype.message = "";
$t.prototype.stack = "";
$t.prototype.column = void 0;
$t.prototype.line = void 0;
$t.prototype.ancestors = void 0;
$t.prototype.cause = void 0;
$t.prototype.fatal = void 0;
$t.prototype.place = void 0;
$t.prototype.ruleId = void 0;
$t.prototype.source = void 0;
const vp = {}.hasOwnProperty, W$ = /* @__PURE__ */ new Map(), K$ = /[A-Z]/g, G$ = /-([a-z])/g, Y$ = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), J$ = /* @__PURE__ */ new Set(["td", "th"]), ux = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Q$(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = aD(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = iD(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? yp : V$,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = mx(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function mx(e, n, r) {
  if (n.type === "element")
    return X$(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return Z$(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return nD(e, n, r);
  if (n.type === "mdxjsEsm")
    return eD(e, n);
  if (n.type === "root")
    return tD(e, n, r);
  if (n.type === "text")
    return rD(e, n);
}
function X$(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = yp, e.schema = a), e.ancestors.push(n);
  const o = fx(e, n.tagName, !1), s = oD(e, n);
  let l = bp(e, n);
  return Y$.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !F$(d) : !0;
  })), px(e, s, o, n), kp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function Z$(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Za(e, n.position);
}
function eD(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Za(e, n.position);
}
function nD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = yp, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : fx(e, n.name, !0), s = sD(e, n), l = bp(e, n);
  return px(e, s, o, n), kp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function tD(e, n, r) {
  const i = {};
  return kp(i, bp(e, n)), e.create(n, e.Fragment, i, r);
}
function rD(e, n) {
  return n.value;
}
function px(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function kp(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function iD(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function aD(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = gp(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function oD(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && vp.call(n.properties, a)) {
      const o = lD(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && J$.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function sD(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Za(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Za(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function bp(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : W$;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = mx(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function lD(e, n, r) {
  const i = O$(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? S$(r) : z$(r)), i.property === "style") {
      let a = typeof r == "object" ? r : cD(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = dD(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? L$[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function cD(e, n) {
  const r = {};
  try {
    q$(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new $t("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = ux + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(G$, mD)), r[s] = o;
  }
}
function fx(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = iv(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = iv(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return vp.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Za(e);
}
function Za(e, n) {
  const r = new $t(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = ux + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function dD(e) {
  const n = {};
  let r;
  for (r in e)
    vp.call(e, r) && (n[uD(r)] = e[r]);
  return n;
}
function uD(e) {
  let n = e.replace(K$, pD);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function mD(e, n) {
  return n.toUpperCase();
}
function pD(e) {
  return "-" + e.toLowerCase();
}
const au = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, fD = {};
function hD(e, n) {
  const r = fD, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return hx(e, i, a);
}
function hx(e, n, r) {
  if (yD(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return pv(e.children, n, r);
  }
  return Array.isArray(e) ? pv(e, n, r) : "";
}
function pv(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = hx(e[a], n, r);
  return i.join("");
}
function yD(e) {
  return !!(e && typeof e == "object");
}
const fv = document.createElement("i");
function _p(e) {
  const n = "&" + e + ";";
  fv.innerHTML = n;
  const r = fv.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Rr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function or(e, n) {
  return e.length > 0 ? (Rr(e, e.length, 0, n), e) : n;
}
const hv = {}.hasOwnProperty;
function gD(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    vD(n, e[r]);
  return n;
}
function vD(e, n) {
  let r;
  for (r in n) {
    const a = (hv.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        hv.call(a, s) || (a[s] = []);
        const l = o[s];
        kD(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function kD(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Rr(e, 0, 0, i);
}
function yx(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Ai(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Fr = ei(/[A-Za-z]/), nr = ei(/[\dA-Za-z]/), bD = ei(/[#-'*+\--9=?A-Z^-~]/);
function dm(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const um = ei(/\d/), _D = ei(/[\dA-Fa-f]/), xD = ei(/[!-/:-@[-`{-~]/);
function vn(e) {
  return e !== null && e < -2;
}
function Kt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const SD = ei(new RegExp("\\p{P}|\\p{S}", "u")), ND = ei(/\s/);
function ei(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Ji(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && nr(e.charCodeAt(r + 1)) && nr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const jD = {
  tokenize: wD
};
function wD(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return vn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const CD = {
  tokenize: FD
}, yv = {
  tokenize: ID
};
function FD(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(H) {
    if (i < r.length) {
      const T = r[i];
      return n.containerState = T[1], e.attempt(T[0].continuation, d, m)(H);
    }
    return m(H);
  }
  function d(H) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const T = n.events.length;
      let E = T, D;
      for (; E--; )
        if (n.events[E][0] === "exit" && n.events[E][1].type === "chunkFlow") {
          D = n.events[E][1].end;
          break;
        }
      C(i);
      let U = T;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...D
        }, U++;
      return Rr(n.events, E + 1, 0, n.events.slice(T)), n.events.length = U, m(H);
    }
    return l(H);
  }
  function m(H) {
    if (i === r.length) {
      if (!a)
        return h(H);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return F(H);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(yv, u, f)(H);
  }
  function u(H) {
    return a && y(), C(i), h(H);
  }
  function f(H) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, F(H);
  }
  function h(H) {
    return n.containerState = {}, e.attempt(yv, v, F)(H);
  }
  function v(H) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(H);
  }
  function F(H) {
    if (H === null) {
      a && y(), C(0), e.consume(H);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(H);
  }
  function S(H) {
    if (H === null) {
      N(e.exit("chunkFlow"), !0), C(0), e.consume(H);
      return;
    }
    return vn(H) ? (e.consume(H), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(H), S);
  }
  function N(H, T) {
    const E = n.sliceStream(H);
    if (T && E.push(null), H.previous = o, o && (o.next = H), o = H, a.defineSkip(H.start), a.write(E), n.parser.lazy[H.start.line]) {
      let D = a.events.length;
      for (; D--; )
        if (
          // The token starts before the line ending…
          a.events[D][1].start.offset < s && // …and either is not ended yet…
          (!a.events[D][1].end || // …or ends after it.
          a.events[D][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Z = U, Q, ie;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            ie = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (C(i), D = U; D < n.events.length; )
        n.events[D][1].end = {
          ...ie
        }, D++;
      Rr(n.events, Z + 1, 0, n.events.slice(U)), n.events.length = D;
    }
  }
  function C(H) {
    let T = r.length;
    for (; T-- > H; ) {
      const E = r[T];
      n.containerState = E[1], E[0].exit.call(n, e);
    }
    r.length = H;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function ID(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function gv(e) {
  if (e === null || Kt(e) || ND(e))
    return 1;
  if (SD(e))
    return 2;
}
function xp(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const mm = {
  name: "attention",
  resolveAll: ED,
  tokenize: TD
};
function ED(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          vv(f, -d), vv(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = or(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = or(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = or(m, xp(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = or(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = or(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Rr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function TD(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = gv(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = gv(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function vv(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const $D = {
  name: "autolink",
  tokenize: DD
};
function DD(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Fr(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || nr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || nr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || dm(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : bD(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return nr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || nr(v)) && i++ < 63) {
      const F = v === 45 ? h : f;
      return e.consume(v), F;
    }
    return r(v);
  }
}
const Js = {
  partial: !0,
  tokenize: RD
};
function RD(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || vn(o) ? n(o) : r(o);
  }
}
const gx = {
  continuation: {
    tokenize: PD
  },
  exit: AD,
  name: "blockQuote",
  tokenize: OD
};
function OD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function PD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(gx, n, r)(s);
  }
}
function AD(e) {
  e.exit("blockQuote");
}
const vx = {
  name: "characterEscape",
  tokenize: LD
};
function LD(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return xD(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const kx = {
  name: "characterReference",
  tokenize: VD
};
function VD(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = nr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = _D, u) : (e.enter("characterReferenceValue"), o = 7, s = um, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === nr && !_p(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const kv = {
  partial: !0,
  tokenize: UD
}, bv = {
  concrete: !0,
  name: "codeFenced",
  tokenize: zD
};
function zD(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: E
  };
  let o = 0, s = 0, l;
  return d;
  function d(D) {
    return m(D);
  }
  function m(D) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = D, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(D);
  }
  function u(D) {
    return D === l ? (s++, e.consume(D), u) : s < 3 ? r(D) : (e.exit("codeFencedFenceSequence"), zn(D) ? et(e, f, "whitespace")(D) : f(D));
  }
  function f(D) {
    return D === null || vn(D) ? (e.exit("codeFencedFence"), i.interrupt ? n(D) : e.check(kv, S, T)(D)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(D));
  }
  function h(D) {
    return D === null || vn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(D)) : zn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, v, "whitespace")(D)) : D === 96 && D === l ? r(D) : (e.consume(D), h);
  }
  function v(D) {
    return D === null || vn(D) ? f(D) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), F(D));
  }
  function F(D) {
    return D === null || vn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(D)) : D === 96 && D === l ? r(D) : (e.consume(D), F);
  }
  function S(D) {
    return e.attempt(a, T, N)(D);
  }
  function N(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), C;
  }
  function C(D) {
    return o > 0 && zn(D) ? et(e, y, "linePrefix", o + 1)(D) : y(D);
  }
  function y(D) {
    return D === null || vn(D) ? e.check(kv, S, T)(D) : (e.enter("codeFlowValue"), H(D));
  }
  function H(D) {
    return D === null || vn(D) ? (e.exit("codeFlowValue"), y(D)) : (e.consume(D), H);
  }
  function T(D) {
    return e.exit("codeFenced"), n(D);
  }
  function E(D, U, Z) {
    let Q = 0;
    return ie;
    function ie(ee) {
      return D.enter("lineEnding"), D.consume(ee), D.exit("lineEnding"), Y;
    }
    function Y(ee) {
      return D.enter("codeFencedFence"), zn(ee) ? et(D, M, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : M(ee);
    }
    function M(ee) {
      return ee === l ? (D.enter("codeFencedFenceSequence"), O(ee)) : Z(ee);
    }
    function O(ee) {
      return ee === l ? (Q++, D.consume(ee), O) : Q >= s ? (D.exit("codeFencedFenceSequence"), zn(ee) ? et(D, q, "whitespace")(ee) : q(ee)) : Z(ee);
    }
    function q(ee) {
      return ee === null || vn(ee) ? (D.exit("codeFencedFence"), U(ee)) : Z(ee);
    }
  }
}
function UD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const ou = {
  name: "codeIndented",
  tokenize: BD
}, MD = {
  partial: !0,
  tokenize: qD
};
function BD(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : vn(m) ? e.attempt(MD, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || vn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function qD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : vn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : vn(s) ? a(s) : r(s);
  }
}
const HD = {
  name: "codeText",
  previous: KD,
  resolve: WD,
  tokenize: GD
};
function WD(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function KD(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function GD(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : vn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || vn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class YD {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && pa(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), pa(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), pa(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        pa(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        pa(this.left, r.reverse());
      }
  }
}
function pa(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function bx(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new YD(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, JD(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Rr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function JD(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, F = 0, S = 0;
  const N = [S];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, N.push(S), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const C = l.slice(N[h], N[h + 1]), y = o.pop();
    d.push([y, y + C.length - 1]), e.splice(y, 2, C);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[F + d[h][0]] = F + d[h][1], F += d[h][1] - d[h][0] - 1;
  return m;
}
const QD = {
  resolve: ZD,
  tokenize: eR
}, XD = {
  partial: !0,
  tokenize: nR
};
function ZD(e) {
  return bx(e), e;
}
function eR(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : vn(l) ? e.check(XD, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function nR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || vn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function _x(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(C) {
    return C === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(C), e.exit(o), h) : C === null || C === 32 || C === 41 || dm(C) ? r(C) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(C));
  }
  function h(C) {
    return C === 62 ? (e.enter(o), e.consume(C), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(C));
  }
  function v(C) {
    return C === 62 ? (e.exit("chunkString"), e.exit(l), h(C)) : C === null || C === 60 || vn(C) ? r(C) : (e.consume(C), C === 92 ? F : v);
  }
  function F(C) {
    return C === 60 || C === 62 || C === 92 ? (e.consume(C), v) : v(C);
  }
  function S(C) {
    return !u && (C === null || C === 41 || Kt(C)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(C)) : u < m && C === 40 ? (e.consume(C), u++, S) : C === 41 ? (e.consume(C), u--, S) : C === null || C === 32 || C === 40 || dm(C) ? r(C) : (e.consume(C), C === 92 ? N : S);
  }
  function N(C) {
    return C === 40 || C === 41 || C === 92 ? (e.consume(C), S) : S(C);
  }
}
function xx(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : vn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || vn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function Sx(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : vn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || vn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function qa(e, n) {
  let r;
  return i;
  function i(a) {
    return vn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const tR = {
  name: "definition",
  tokenize: iR
}, rR = {
  partial: !0,
  tokenize: aR
};
function iR(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return xx.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = Ai(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Kt(v) ? qa(e, m)(v) : m(v);
  }
  function m(v) {
    return _x(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(rR, f, f)(v);
  }
  function f(v) {
    return zn(v) ? et(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || vn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function aR(e, n, r) {
  return i;
  function i(l) {
    return Kt(l) ? qa(e, a)(l) : r(l);
  }
  function a(l) {
    return Sx(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || vn(l) ? n(l) : r(l);
  }
}
const oR = {
  name: "hardBreakEscape",
  tokenize: sR
};
function sR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return vn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const lR = {
  name: "headingAtx",
  resolve: cR,
  tokenize: dR
};
function cR(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Rr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function dR(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Kt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || vn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Kt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const uR = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], _v = ["pre", "script", "style", "textarea"], mR = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: hR,
  tokenize: yR
}, pR = {
  partial: !0,
  tokenize: vR
}, fR = {
  partial: !0,
  tokenize: gR
};
function hR(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function yR(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, S) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : W) : Fr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, v) : K === 91 ? (e.consume(K), a = 5, l = 0, F) : Fr(K) ? (e.consume(K), a = 4, i.interrupt ? n : W) : r(K);
  }
  function v(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : W) : r(K);
  }
  function F(K) {
    const Be = "CDATA[";
    return K === Be.charCodeAt(l++) ? (e.consume(K), l === Be.length ? i.interrupt ? n : M : F) : r(K);
  }
  function S(K) {
    return Fr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : r(K);
  }
  function N(K) {
    if (K === null || K === 47 || K === 62 || Kt(K)) {
      const Be = K === 47, Me = s.toLowerCase();
      return !Be && !o && _v.includes(Me) ? (a = 1, i.interrupt ? n(K) : M(K)) : uR.includes(s.toLowerCase()) ? (a = 6, Be ? (e.consume(K), C) : i.interrupt ? n(K) : M(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? y(K) : H(K));
    }
    return K === 45 || nr(K) ? (e.consume(K), s += String.fromCharCode(K), N) : r(K);
  }
  function C(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : M) : r(K);
  }
  function y(K) {
    return zn(K) ? (e.consume(K), y) : ie(K);
  }
  function H(K) {
    return K === 47 ? (e.consume(K), ie) : K === 58 || K === 95 || Fr(K) ? (e.consume(K), T) : zn(K) ? (e.consume(K), H) : ie(K);
  }
  function T(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || nr(K) ? (e.consume(K), T) : E(K);
  }
  function E(K) {
    return K === 61 ? (e.consume(K), D) : zn(K) ? (e.consume(K), E) : H(K);
  }
  function D(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, U) : zn(K) ? (e.consume(K), D) : Z(K);
  }
  function U(K) {
    return K === d ? (e.consume(K), d = null, Q) : K === null || vn(K) ? r(K) : (e.consume(K), U);
  }
  function Z(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Kt(K) ? E(K) : (e.consume(K), Z);
  }
  function Q(K) {
    return K === 47 || K === 62 || zn(K) ? H(K) : r(K);
  }
  function ie(K) {
    return K === 62 ? (e.consume(K), Y) : r(K);
  }
  function Y(K) {
    return K === null || vn(K) ? M(K) : zn(K) ? (e.consume(K), Y) : r(K);
  }
  function M(K) {
    return K === 45 && a === 2 ? (e.consume(K), ge) : K === 60 && a === 1 ? (e.consume(K), de) : K === 62 && a === 4 ? (e.consume(K), be) : K === 63 && a === 3 ? (e.consume(K), W) : K === 93 && a === 5 ? (e.consume(K), pe) : vn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(pR, Fe, O)(K)) : K === null || vn(K) ? (e.exit("htmlFlowData"), O(K)) : (e.consume(K), M);
  }
  function O(K) {
    return e.check(fR, q, Fe)(K);
  }
  function q(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ee;
  }
  function ee(K) {
    return K === null || vn(K) ? O(K) : (e.enter("htmlFlowData"), M(K));
  }
  function ge(K) {
    return K === 45 ? (e.consume(K), W) : M(K);
  }
  function de(K) {
    return K === 47 ? (e.consume(K), s = "", le) : M(K);
  }
  function le(K) {
    if (K === 62) {
      const Be = s.toLowerCase();
      return _v.includes(Be) ? (e.consume(K), be) : M(K);
    }
    return Fr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), le) : M(K);
  }
  function pe(K) {
    return K === 93 ? (e.consume(K), W) : M(K);
  }
  function W(K) {
    return K === 62 ? (e.consume(K), be) : K === 45 && a === 2 ? (e.consume(K), W) : M(K);
  }
  function be(K) {
    return K === null || vn(K) ? (e.exit("htmlFlowData"), Fe(K)) : (e.consume(K), be);
  }
  function Fe(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function gR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return vn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function vR(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Js, n, r);
  }
}
const kR = {
  name: "htmlText",
  tokenize: bR
};
function bR(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), E) : W === 63 ? (e.consume(W), H) : Fr(W) ? (e.consume(W), Z) : r(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, F) : Fr(W) ? (e.consume(W), y) : r(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), v) : r(W);
  }
  function f(W) {
    return W === null ? r(W) : W === 45 ? (e.consume(W), h) : vn(W) ? (s = f, de(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), v) : f(W);
  }
  function v(W) {
    return W === 62 ? ge(W) : W === 45 ? h(W) : f(W);
  }
  function F(W) {
    const be = "CDATA[";
    return W === be.charCodeAt(o++) ? (e.consume(W), o === be.length ? S : F) : r(W);
  }
  function S(W) {
    return W === null ? r(W) : W === 93 ? (e.consume(W), N) : vn(W) ? (s = S, de(W)) : (e.consume(W), S);
  }
  function N(W) {
    return W === 93 ? (e.consume(W), C) : S(W);
  }
  function C(W) {
    return W === 62 ? ge(W) : W === 93 ? (e.consume(W), C) : S(W);
  }
  function y(W) {
    return W === null || W === 62 ? ge(W) : vn(W) ? (s = y, de(W)) : (e.consume(W), y);
  }
  function H(W) {
    return W === null ? r(W) : W === 63 ? (e.consume(W), T) : vn(W) ? (s = H, de(W)) : (e.consume(W), H);
  }
  function T(W) {
    return W === 62 ? ge(W) : H(W);
  }
  function E(W) {
    return Fr(W) ? (e.consume(W), D) : r(W);
  }
  function D(W) {
    return W === 45 || nr(W) ? (e.consume(W), D) : U(W);
  }
  function U(W) {
    return vn(W) ? (s = U, de(W)) : zn(W) ? (e.consume(W), U) : ge(W);
  }
  function Z(W) {
    return W === 45 || nr(W) ? (e.consume(W), Z) : W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function Q(W) {
    return W === 47 ? (e.consume(W), ge) : W === 58 || W === 95 || Fr(W) ? (e.consume(W), ie) : vn(W) ? (s = Q, de(W)) : zn(W) ? (e.consume(W), Q) : ge(W);
  }
  function ie(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || nr(W) ? (e.consume(W), ie) : Y(W);
  }
  function Y(W) {
    return W === 61 ? (e.consume(W), M) : vn(W) ? (s = Y, de(W)) : zn(W) ? (e.consume(W), Y) : Q(W);
  }
  function M(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), a = W, O) : vn(W) ? (s = M, de(W)) : zn(W) ? (e.consume(W), M) : (e.consume(W), q);
  }
  function O(W) {
    return W === a ? (e.consume(W), a = void 0, ee) : W === null ? r(W) : vn(W) ? (s = O, de(W)) : (e.consume(W), O);
  }
  function q(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? r(W) : W === 47 || W === 62 || Kt(W) ? Q(W) : (e.consume(W), q);
  }
  function ee(W) {
    return W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function ge(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(W);
  }
  function de(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), le;
  }
  function le(W) {
    return zn(W) ? et(e, pe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : pe(W);
  }
  function pe(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const Sp = {
  name: "labelEnd",
  resolveAll: NR,
  resolveTo: jR,
  tokenize: wR
}, _R = {
  tokenize: CR
}, xR = {
  tokenize: FR
}, SR = {
  tokenize: IR
};
function NR(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Rr(e, 0, e.length, r), e;
}
function jR(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = or(l, e.slice(o + 1, o + i + 3)), l = or(l, [["enter", u, n]]), l = or(l, xp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = or(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = or(l, e.slice(s + 1)), l = or(l, [["exit", d, n]]), Rr(e, o, e.length, l), e;
}
function wR(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Ai(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(_R, u, s ? u : f)(h) : h === 91 ? e.attempt(xR, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(SR, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function CR(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Kt(f) ? qa(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : _x(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Kt(f) ? qa(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? Sx(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Kt(f) ? qa(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function FR(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return xx.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Ai(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function IR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const ER = {
  name: "labelStartImage",
  resolveAll: Sp.resolveAll,
  tokenize: TR
};
function TR(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const $R = {
  name: "labelStartLink",
  resolveAll: Sp.resolveAll,
  tokenize: DR
};
function DR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const su = {
  name: "lineEnding",
  tokenize: RR
};
function RR(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const rs = {
  name: "thematicBreak",
  tokenize: OR
};
function OR(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || vn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const qt = {
  continuation: {
    tokenize: VR
  },
  exit: UR,
  name: "list",
  tokenize: LR
}, PR = {
  partial: !0,
  tokenize: MR
}, AR = {
  partial: !0,
  tokenize: zR
};
function LR(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const F = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (F === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : um(v)) {
      if (i.containerState.type || (i.containerState.type = F, e.enter(F, {
        _container: !0
      })), F === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(rs, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return um(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Js,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(PR, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function VR(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Js, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(AR, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(qt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function zR(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function UR(e) {
  e.exit(this.containerState.type);
}
function MR(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const xv = {
  name: "setextUnderline",
  resolveTo: BR,
  tokenize: qR
};
function BR(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function qR(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || vn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const HR = {
  tokenize: WR
};
function WR(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Js,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt(QD, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const KR = {
  resolveAll: jx()
}, GR = Nx("string"), YR = Nx("text");
function Nx(e) {
  return {
    resolveAll: jx(e === "text" ? JR : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function jx(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function JR(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const QR = {
  42: qt,
  43: qt,
  45: qt,
  48: qt,
  49: qt,
  50: qt,
  51: qt,
  52: qt,
  53: qt,
  54: qt,
  55: qt,
  56: qt,
  57: qt,
  62: gx
}, XR = {
  91: tR
}, ZR = {
  [-2]: ou,
  [-1]: ou,
  32: ou
}, eO = {
  35: lR,
  42: rs,
  45: [xv, rs],
  60: mR,
  61: xv,
  95: rs,
  96: bv,
  126: bv
}, nO = {
  38: kx,
  92: vx
}, tO = {
  [-5]: su,
  [-4]: su,
  [-3]: su,
  33: ER,
  38: kx,
  42: mm,
  60: [$D, kR],
  91: $R,
  92: [oR, vx],
  93: Sp,
  95: mm,
  96: HD
}, rO = {
  null: [mm, KR]
}, iO = {
  null: [42, 95]
}, aO = {
  null: []
}, oO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: iO,
  contentInitial: XR,
  disable: aO,
  document: QR,
  flow: eO,
  flowInitial: ZR,
  insideSpan: rO,
  string: nO,
  text: tO
}, Symbol.toStringTag, { value: "Module" }));
function sO(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(E),
    check: U(D),
    consume: y,
    enter: H,
    exit: T,
    interrupt: U(D, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: F,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(Y) {
    return s = or(s, Y), N(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = xp(o, m.events, m), m.events);
  }
  function h(Y, M) {
    return cO(v(Y), M);
  }
  function v(Y) {
    return lO(s, Y);
  }
  function F() {
    const {
      _bufferIndex: Y,
      _index: M,
      line: O,
      column: q,
      offset: ee
    } = i;
    return {
      _bufferIndex: Y,
      _index: M,
      line: O,
      column: q,
      offset: ee
    };
  }
  function S(Y) {
    a[Y.line] = Y.column, ie();
  }
  function N() {
    let Y;
    for (; i._index < s.length; ) {
      const M = s[i._index];
      if (typeof M == "string")
        for (Y = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === Y && i._bufferIndex < M.length; )
          C(M.charCodeAt(i._bufferIndex));
      else
        C(M);
    }
  }
  function C(Y) {
    u = u(Y);
  }
  function y(Y) {
    vn(Y) ? (i.line++, i.column = 1, i.offset += Y === -3 ? 2 : 1, ie()) : Y !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = Y;
  }
  function H(Y, M) {
    const O = M || {};
    return O.type = Y, O.start = F(), m.events.push(["enter", O, m]), l.push(O), O;
  }
  function T(Y) {
    const M = l.pop();
    return M.end = F(), m.events.push(["exit", M, m]), M;
  }
  function E(Y, M) {
    Z(Y, M.from);
  }
  function D(Y, M) {
    M.restore();
  }
  function U(Y, M) {
    return O;
    function O(q, ee, ge) {
      let de, le, pe, W;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        Fe(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        Fe([
          /** @type {Construct} */
          q
        ])
      ) : be(q);
      function be(Pe) {
        return Ue;
        function Ue(we) {
          const Ae = we !== null && Pe[we], $e = we !== null && Pe.null, tn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : [],
            ...Array.isArray($e) ? $e : $e ? [$e] : []
          ];
          return Fe(tn)(we);
        }
      }
      function Fe(Pe) {
        return de = Pe, le = 0, Pe.length === 0 ? ge : K(Pe[le]);
      }
      function K(Pe) {
        return Ue;
        function Ue(we) {
          return W = Q(), pe = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Me() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            M ? Object.assign(Object.create(m), M) : m,
            d,
            Be,
            Me
          )(we);
        }
      }
      function Be(Pe) {
        return Y(pe, W), ee;
      }
      function Me(Pe) {
        return W.restore(), ++le < de.length ? K(de[le]) : ge;
      }
    }
  }
  function Z(Y, M) {
    Y.resolveAll && !o.includes(Y) && o.push(Y), Y.resolve && Rr(m.events, M, m.events.length - M, Y.resolve(m.events.slice(M), m)), Y.resolveTo && (m.events = Y.resolveTo(m.events, m));
  }
  function Q() {
    const Y = F(), M = m.previous, O = m.currentConstruct, q = m.events.length, ee = Array.from(l);
    return {
      from: q,
      restore: ge
    };
    function ge() {
      i = Y, m.previous = M, m.currentConstruct = O, m.events.length = q, l = ee, ie();
    }
  }
  function ie() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function lO(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function cO(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function dO(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      gD([oO, ...(e || {}).extensions || []])
    ),
    content: a(jD),
    defined: [],
    document: a(CD),
    flow: a(HR),
    lazy: {},
    string: a(GR),
    text: a(YR)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return sO(i, o, l);
    }
  }
}
function uO(e) {
  for (; !bx(e); )
    ;
  return e;
}
const Sv = /[\0\t\n\r]/g;
function mO() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Sv.lastIndex = f, m = Sv.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const pO = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function fO(e) {
  return e.replace(pO, hO);
}
function hO(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return yx(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return _p(r) || e;
}
const wx = {}.hasOwnProperty;
function yO(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), gO(r)(uO(dO(r).document().write(mO()(e, n, !0))));
}
function gO(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Re),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(me),
      blockQuote: o($e),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(tn),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(tn, s),
      codeText: o(Ce, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(He),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ze),
      hardBreakEscape: o(he),
      hardBreakTrailing: o(he),
      htmlFlow: o(Ee, s),
      htmlFlowData: Q,
      htmlText: o(Ee, s),
      htmlTextData: Q,
      image: o(Le),
      label: s,
      link: o(Re),
      listItem: o(w),
      listItemValue: h,
      listOrdered: o(ln, f),
      listUnordered: o(ln),
      paragraph: o(_),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(me),
      strong: o($),
      thematicBreak: o(J)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: E,
      autolink: d(),
      autolinkEmail: Ae,
      autolinkProtocol: we,
      blockQuote: d(),
      characterEscapeValue: ie,
      characterReferenceMarkerHexadecimal: Me,
      characterReferenceMarkerNumeric: Me,
      characterReferenceValue: Pe,
      characterReference: Ue,
      codeFenced: d(N),
      codeFencedFence: S,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: F,
      codeFlowValue: ie,
      codeIndented: d(C),
      codeText: d(ee),
      codeTextData: ie,
      data: ie,
      definition: d(),
      definitionDestinationString: T,
      definitionLabelString: y,
      definitionTitleString: H,
      emphasis: d(),
      hardBreakEscape: d(M),
      hardBreakTrailing: d(M),
      htmlFlow: d(O),
      htmlFlowData: ie,
      htmlText: d(q),
      htmlTextData: ie,
      image: d(de),
      label: pe,
      labelText: le,
      lineEnding: Y,
      link: d(ge),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: Be,
      resourceDestinationString: W,
      resourceTitleString: be,
      resource: Fe,
      setextHeading: d(Z),
      setextHeadingLineSequence: U,
      setextHeadingText: D,
      strong: d(),
      thematicBreak: d()
    }
  };
  Cx(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(R) {
    let z = {
      type: "root",
      children: []
    };
    const re = {
      stack: [z],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, fe = [];
    let _e = -1;
    for (; ++_e < R.length; )
      if (R[_e][1].type === "listOrdered" || R[_e][1].type === "listUnordered")
        if (R[_e][0] === "enter")
          fe.push(_e);
        else {
          const en = fe.pop();
          _e = a(R, en, _e);
        }
    for (_e = -1; ++_e < R.length; ) {
      const en = n[R[_e][0]];
      wx.call(en, R[_e][1].type) && en[R[_e][1].type].call(Object.assign({
        sliceSerialize: R[_e][2].sliceSerialize
      }, re), R[_e][1]);
    }
    if (re.tokenStack.length > 0) {
      const en = re.tokenStack[re.tokenStack.length - 1];
      (en[1] || Nv).call(re, void 0, en[0]);
    }
    for (z.position = {
      start: Kr(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Kr(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, _e = -1; ++_e < n.transforms.length; )
      z = n.transforms[_e](z) || z;
    return z;
  }
  function a(R, z, re) {
    let fe = z - 1, _e = -1, en = !1, un, rn, dn, pn;
    for (; ++fe <= re; ) {
      const cn = R[fe];
      switch (cn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          cn[0] === "enter" ? _e++ : _e--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          cn[0] === "enter" && (un && !pn && !_e && !dn && (dn = fe), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!_e && cn[0] === "enter" && cn[1].type === "listItemPrefix" || _e === -1 && cn[0] === "exit" && (cn[1].type === "listUnordered" || cn[1].type === "listOrdered")) {
        if (un) {
          let kn = fe;
          for (rn = void 0; kn--; ) {
            const Xe = R[kn];
            if (Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank") {
              if (Xe[0] === "exit") continue;
              rn && (R[rn][1].type = "lineEndingBlank", en = !0), Xe[1].type = "lineEnding", rn = kn;
            } else if (!(Xe[1].type === "linePrefix" || Xe[1].type === "blockQuotePrefix" || Xe[1].type === "blockQuotePrefixWhitespace" || Xe[1].type === "blockQuoteMarker" || Xe[1].type === "listItemIndent")) break;
          }
          dn && (!rn || dn < rn) && (un._spread = !0), un.end = Object.assign({}, rn ? R[rn][1].start : cn[1].end), R.splice(rn || fe, 0, ["exit", un, cn[2]]), fe++, re++;
        }
        if (cn[1].type === "listItemPrefix") {
          const kn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, cn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          un = kn, R.splice(fe, 0, ["enter", kn, cn[2]]), fe++, re++, dn = void 0, pn = !0;
        }
      }
    }
    return R[z][1]._spread = en, re;
  }
  function o(R, z) {
    return re;
    function re(fe) {
      l.call(this, R(fe), fe), z && z.call(this, fe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(R, z, re) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([z, re || void 0]), R.position = {
      start: Kr(z.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(R) {
    return z;
    function z(re) {
      R && R.call(this, re), m.call(this, re);
    }
  }
  function m(R, z) {
    const re = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== R.type && (z ? z.call(this, R, fe[0]) : (fe[1] || Nv).call(this, R, fe[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + Ba({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    re.position.end = Kr(R.end);
  }
  function u() {
    return hD(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(R) {
    if (this.data.expectingFirstListItemValue) {
      const z = this.stack[this.stack.length - 2];
      z.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.lang = R;
  }
  function F() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.meta = R;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function C() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function y(R) {
    const z = this.resume(), re = this.stack[this.stack.length - 1];
    re.label = z, re.identifier = Ai(this.sliceSerialize(R)).toLowerCase();
  }
  function H() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function T() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function E(R) {
    const z = this.stack[this.stack.length - 1];
    if (!z.depth) {
      const re = this.sliceSerialize(R).length;
      z.depth = re;
    }
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(R) {
    const z = this.stack[this.stack.length - 1];
    z.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(R) {
    const re = this.stack[this.stack.length - 1].children;
    let fe = re[re.length - 1];
    (!fe || fe.type !== "text") && (fe = G(), fe.position = {
      start: Kr(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, re.push(fe)), this.stack.push(fe);
  }
  function ie(R) {
    const z = this.stack.pop();
    z.value += this.sliceSerialize(R), z.position.end = Kr(R.end);
  }
  function Y(R) {
    const z = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const re = z.children[z.children.length - 1];
      re.position.end = Kr(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(z.type) && (Q.call(this, R), ie.call(this, R));
  }
  function M() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function q() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function ee() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function ge() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function de() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function le(R) {
    const z = this.sliceSerialize(R), re = this.stack[this.stack.length - 2];
    re.label = fO(z), re.identifier = Ai(z).toLowerCase();
  }
  function pe() {
    const R = this.stack[this.stack.length - 1], z = this.resume(), re = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, re.type === "link") {
      const fe = R.children;
      re.children = fe;
    } else
      re.alt = z;
  }
  function W() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function be() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function Fe() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function Be(R) {
    const z = this.resume(), re = this.stack[this.stack.length - 1];
    re.label = z, re.identifier = Ai(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function Me(R) {
    this.data.characterReferenceType = R.type;
  }
  function Pe(R) {
    const z = this.sliceSerialize(R), re = this.data.characterReferenceType;
    let fe;
    re ? (fe = yx(z, re === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = _p(z);
    const _e = this.stack[this.stack.length - 1];
    _e.value += fe;
  }
  function Ue(R) {
    const z = this.stack.pop();
    z.position.end = Kr(R.end);
  }
  function we(R) {
    ie.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = this.sliceSerialize(R);
  }
  function Ae(R) {
    ie.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = "mailto:" + this.sliceSerialize(R);
  }
  function $e() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function tn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ce() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function He() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ze() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function me() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function he() {
    return {
      type: "break"
    };
  }
  function Ee() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ln(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function w(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function $() {
    return {
      type: "strong",
      children: []
    };
  }
  function G() {
    return {
      type: "text",
      value: ""
    };
  }
  function J() {
    return {
      type: "thematicBreak"
    };
  }
}
function Kr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Cx(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? Cx(e, i) : vO(e, i);
  }
}
function vO(e, n) {
  let r;
  for (r in n)
    if (wx.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Nv(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ba({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ba({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ba({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function kO(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return yO(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function bO(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function _O(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function xO(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function SO(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function NO(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function jO(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ji(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function wO(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function CO(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function Fx(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function FO(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Fx(e, n);
  const a = { src: Ji(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function IO(e, n) {
  const r = { src: Ji(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function EO(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function TO(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Fx(e, n);
  const a = { href: Ji(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function $O(e, n) {
  const r = { href: Ji(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function DO(e, n, r) {
  const i = e.all(n), a = r ? RO(r) : Ix(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function RO(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = Ix(r[i]);
  }
  return n;
}
function Ix(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function OO(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function PO(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function AO(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function LO(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function VO(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = gp(n.children[1]), d = cx(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function zO(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let F = { type: "element", tagName: o, properties: h, children: [] };
    f && (F.children = e.all(f), e.patch(f, F), F = e.applyData(f, F)), m.push(F);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function UO(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const jv = 9, wv = 32;
function MO(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Cv(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Cv(n.slice(a), a > 0, !1)), o.join("");
}
function Cv(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === jv || o === wv; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === jv || o === wv; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function BO(e, n) {
  const r = { type: "text", value: MO(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function qO(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const HO = {
  blockquote: bO,
  break: _O,
  code: xO,
  delete: SO,
  emphasis: NO,
  footnoteReference: jO,
  heading: wO,
  html: CO,
  imageReference: FO,
  image: IO,
  inlineCode: EO,
  linkReference: TO,
  link: $O,
  listItem: DO,
  list: OO,
  paragraph: PO,
  // @ts-expect-error: root is different, but hard to type.
  root: AO,
  strong: LO,
  table: VO,
  tableCell: UO,
  tableRow: zO,
  text: BO,
  thematicBreak: qO,
  toml: Co,
  yaml: Co,
  definition: Co,
  footnoteDefinition: Co
};
function Co() {
}
const Ex = -1, Qs = 0, ks = 1, bs = 2, Np = 3, jp = 4, wp = 5, Cp = 6, Tx = 7, $x = 8, Fv = typeof self == "object" ? self : globalThis, WO = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Qs:
      case Ex:
        return r(s, a);
      case ks: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case bs: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Np:
        return r(new Date(s), a);
      case jp: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case wp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Cp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case Tx: {
        const { name: l, message: d } = s;
        return r(new Fv[l](d), a);
      }
      case $x:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Fv[o](s), a);
  };
  return i;
}, Iv = (e) => WO(/* @__PURE__ */ new Map(), e)(0), ji = "", { toString: KO } = {}, { keys: GO } = Object, fa = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Qs, n];
  const r = KO.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [ks, ji];
    case "Object":
      return [bs, ji];
    case "Date":
      return [Np, ji];
    case "RegExp":
      return [jp, ji];
    case "Map":
      return [wp, ji];
    case "Set":
      return [Cp, ji];
  }
  return r.includes("Array") ? [ks, r] : r.includes("Error") ? [Tx, r] : [bs, r];
}, Fo = ([e, n]) => e === Qs && (n === "function" || n === "symbol"), YO = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = fa(s);
    switch (l) {
      case Qs: {
        let u = s;
        switch (d) {
          case "bigint":
            l = $x, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([Ex], s);
        }
        return a([l, u], s);
      }
      case ks: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case bs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of GO(s))
          (e || !Fo(fa(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Np:
        return a([l, s.toISOString()], s);
      case jp: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case wp: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(Fo(fa(h)) || Fo(fa(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case Cp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !Fo(fa(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Ev = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return YO(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, _s = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Iv(Ev(e, n)) : structuredClone(e)
) : (e, n) => Iv(Ev(e, n));
function JO(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function QO(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function XO(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || JO, i = e.options.footnoteBackLabel || QO, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Ji(f.toLowerCase());
    let v = 0;
    const F = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++v <= S; ) {
      F.length > 0 && F.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(d, v);
      typeof y == "string" && (y = { type: "text", value: y }), F.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const N = u[u.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const y = N.children[N.children.length - 1];
      y && y.type === "text" ? y.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...F);
    } else
      u.push(...F);
    const C = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, C), l.push(C);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ..._s(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Dx = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return tP;
    if (typeof e == "function")
      return Xs(e);
    if (typeof e == "object")
      return Array.isArray(e) ? ZO(e) : eP(e);
    if (typeof e == "string")
      return nP(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function ZO(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = Dx(e[r]);
  return Xs(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function eP(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Xs(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function nP(e) {
  return Xs(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Xs(e) {
  return n;
  function n(r, i, a) {
    return !!(rP(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function tP() {
  return !0;
}
function rP(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Rx = [], iP = !0, Tv = !1, aP = "skip";
function oP(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = Dx(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = Rx, F, S, N;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = sP(r(d, u)), v[0] === Tv))
        return v;
      if ("children" in d && d.children) {
        const C = (
          /** @type {UnistParent} */
          d
        );
        if (C.children && v[0] !== aP)
          for (S = (i ? C.children.length : -1) + s, N = u.concat(C); S > -1 && S < C.children.length; ) {
            const y = C.children[S];
            if (F = l(y, S, N)(), F[0] === Tv)
              return F;
            S = typeof F[1] == "number" ? F[1] : S + s;
          }
      }
      return v;
    }
  }
}
function sP(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [iP, e] : e == null ? Rx : [e];
}
function Ox(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), oP(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const pm = {}.hasOwnProperty, lP = {};
function cP(e, n) {
  const r = n || lP, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...HO, ...r.handlers }, l = {
    all: m,
    applyData: uP,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: dP,
    wrap: pP
  };
  return Ox(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (pm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: S, ...N } = u, C = _s(N);
        return C.children = l.all(u), C;
      }
      return _s(u);
    }
    return (l.options.unknownHandler || mP)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const F = l.one(h[v], u);
        if (F) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(F) && F.type === "text" && (F.value = $v(F.value)), !Array.isArray(F) && F.type === "element")) {
            const S = F.children[0];
            S && S.type === "text" && (S.value = $v(S.value));
          }
          Array.isArray(F) ? f.push(...F) : f.push(F);
        }
      }
    }
    return f;
  }
}
function dP(e, n) {
  e.position && (n.position = H$(e));
}
function uP(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, _s(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function mP(e, n) {
  const r = n.data || {}, i = "value" in n && !(pm.call(r, "hProperties") || pm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function pP(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function $v(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Dv(e, n) {
  const r = cP(e, n), i = r.one(e, void 0), a = XO(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function fP(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Dv(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Dv(r, { file: i, ...e || n })
    );
  };
}
function Rv(e) {
  if (e)
    throw e;
}
var lu, Ov;
function hP() {
  if (Ov) return lu;
  Ov = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return lu = function d() {
    var m, u, f, h, v, F, S = arguments[0], N = 1, C = arguments.length, y = !1;
    for (typeof S == "boolean" && (y = S, S = arguments[1] || {}, N = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); N < C; ++N)
      if (m = arguments[N], m != null)
        for (u in m)
          f = l(S, u), h = l(m, u), S !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, F = f && a(f) ? f : []) : F = f && o(f) ? f : {}, s(S, { name: u, newValue: d(y, F, h) })) : typeof h < "u" && s(S, { name: u, newValue: h }));
    return S;
  }, lu;
}
var yP = hP();
const cu = /* @__PURE__ */ Rm(yP);
function fm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function gP() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? vP(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function vP(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const wr = { basename: kP, dirname: bP, extname: _P, join: xP, sep: "/" };
function kP(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  po(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function bP(e) {
  if (po(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function _P(e) {
  po(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function xP(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    po(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : SP(r);
}
function SP(e) {
  po(e);
  const n = e.codePointAt(0) === 47;
  let r = NP(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function NP(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function po(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const jP = { cwd: wP };
function wP() {
  return "/";
}
function hm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function CP(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!hm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return FP(e);
}
function FP(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const du = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Px {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? hm(n) ? r = { path: n } : typeof n == "string" || IP(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : jP.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < du.length; ) {
      const o = du[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      du.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? wr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    mu(n, "basename"), uu(n, "basename"), this.path = wr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? wr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Pv(this.basename, "dirname"), this.path = wr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? wr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (uu(n, "extname"), Pv(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = wr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    hm(n) && (n = CP(n)), mu(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? wr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    mu(n, "stem"), uu(n, "stem"), this.path = wr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new $t(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function uu(e, n) {
  if (e && e.includes(wr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + wr.sep + "`"
    );
}
function mu(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Pv(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function IP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const EP = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), TP = {}.hasOwnProperty;
class Fp extends EP {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = gP();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Fp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(cu(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (hu("data", this.frozen), this.namespace[n] = r, this) : TP.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (hu("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = Io(n), i = this.parser || this.Parser;
    return pu("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), pu("process", this.parser || this.Parser), fu("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = Io(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), F = i.stringify(v, h);
        RP(F) ? h.value = F : h.result = F, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), pu("processSync", this.parser || this.Parser), fu("processSync", this.compiler || this.Compiler), this.process(n, a), Lv("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Rv(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Av(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = Io(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Lv("runSync", "run", i), a;
    function o(s, l) {
      Rv(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = Io(r), a = this.compiler || this.Compiler;
    return fu("stringify", a), Av(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (hu("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = cu(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...F] = u;
        const S = i[h][1];
        fm(S) && fm(v) && (v = cu(!0, S, v)), i[h] = [m, v, ...F];
      }
    }
  }
}
const $P = new Fp().freeze();
function pu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function fu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function hu(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Av(e) {
  if (!fm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Lv(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Io(e) {
  return DP(e) ? e : new Px(e);
}
function DP(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function RP(e) {
  return typeof e == "string" || OP(e);
}
function OP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const PP = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Vv = [], zv = { allowDangerousHtml: !0 }, AP = /^(https?|ircs?|mailto|xmpp)$/i, LP = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function VP(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Vv, d = e.remarkPlugins || Vv, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...zv } : zv, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || zP, v = $P().use(kO).use(d).use(fP, m).use(l), F = new Px();
  typeof i == "string" && (F.value = i);
  for (const y of LP)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + PP + y.id, void 0);
  const S = v.parse(F);
  let N = v.runSync(S, F);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), Ox(N, C), Q$(N, {
    Fragment: ze.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: ze.jsx,
    jsxs: ze.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function C(y, H, T) {
    if (y.type === "raw" && T && typeof H == "number")
      return u ? T.children.splice(H, 1) : T.children[H] = { type: "text", value: y.value }, H;
    if (y.type === "element") {
      let E;
      for (E in au)
        if (Object.hasOwn(au, E) && Object.hasOwn(y.properties, E)) {
          const D = y.properties[E], U = au[E];
          (U === null || U.includes(y.tagName)) && (y.properties[E] = h(String(D || ""), E, y));
        }
    }
    if (y.type === "element") {
      let E = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!E && r && typeof H == "number" && (E = !r(y, H, T)), E && T && typeof H == "number")
        return f && y.children ? T.children.splice(H, 1, ...y.children) : T.children.splice(H, 1), H;
    }
  }
}
function zP(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    AP.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yu = { exports: {} }, ha = {}, Uv;
function UP() {
  if (Uv) return ha;
  Uv = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ha.Fragment = r, ha.jsx = s, ha.jsxs = s, ha;
}
var Eo = {}, Mv;
function MP() {
  return Mv || (Mv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Eo.Fragment = i, Eo.jsx = Rn, Eo.jsxs = Bn;
  })()), Eo;
}
var Bv;
function BP() {
  return Bv || (Bv = 1, process.env.NODE_ENV === "production" ? yu.exports = UP() : yu.exports = MP()), yu.exports;
}
var oe = BP();
const qP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, HP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, WP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, KP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, GP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, YP = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": qP,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": HP,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": WP,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": KP,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": GP
};
function fo(e) {
  return YP[e] ?? {};
}
const JP = fo(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), QP = fo(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), To = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), XP = "_issueAvatar_kc0sw_1", ZP = "_issueField_kc0sw_9", eA = "_issueDescription_kc0sw_12", $o = {
  issueAvatar: XP,
  issueField: ZP,
  issueDescription: eA
}, Ax = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(To, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: $o.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          $m,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(To, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: $o.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(To, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: $o.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(To, { title: "Description", children: /* @__PURE__ */ oe.jsx(VP, { className: $o.issueDescription, children: e.description }) })
] }), nA = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), tA = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), rA = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), iA = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), aA = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), Lx = {
  0: nA,
  1: aA,
  2: iA,
  3: rA,
  4: tA
}, oA = (e) => e in Lx, xs = ({ priority: e }) => oA(e) ? Lx[e] : /* @__PURE__ */ oe.jsx(An, { "data-testid": "defaultPriorityTag", children: e }), sA = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), lA = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), cA = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), dA = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), uA = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), mA = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), ym = {
  backlog: (e, n) => sA(e, n),
  unstarted: (e, n) => lA(e, n),
  started: (e, n) => cA(e, n),
  done: (e, n) => dA(e, n),
  canceled: (e, n) => uA(e, n),
  completed: (e, n) => mA(e, n)
}, pA = (e) => e in ym, Ss = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => pA(e) ? ym[e](n, r) : ym.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), fA = "_wrapper_e0qj3_1", hA = "_resultTitle_e0qj3_21", yA = "_resultTooltipTitle_e0qj3_28", gA = "_resultLinkIcon_e0qj3_31", ya = {
  wrapper: fA,
  resultTitle: hA,
  resultTooltipTitle: yA,
  resultLinkIcon: gA
}, vA = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Em(l0()), o = tt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ke,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: ya.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              Ss,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(xs, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(An, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ya.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(Ax, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        ot.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ya.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    Ss,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(xs, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", className: ya.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  ue,
                  {
                    className: ya.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, kA = "_loader_13xpk_1", bA = "_dropdown_13xpk_8", _A = "_loadMore_13xpk_13", gu = {
  loader: kA,
  dropdown: bA,
  loadMore: _A
}, xA = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = mn(), [f, { data: h, loading: v, networkStatus: F }] = u(
    JP,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  yi(
    () => {
      !v && s !== "" && F === Gt.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), qe(() => {
    v || o([]);
  }, [s]), qe(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: T }) => T
      ), C = a.filter(
        (T) => !n.find((E) => E.id === T.id)
      ), y = C.filter(
        (T) => !N.find(
          (E) => E.id === T.id
        )
      ), H = N.filter(
        (T) => !n.find((E) => E.id === T.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...H] : H
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...C, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !v && s !== "" && F === Gt.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    Yr,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: gu.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const C = N.target.value;
          l(C);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ oe.jsx(vA, { issue: N }, N.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: gu.loadMore,
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: gu.loader, children: /* @__PURE__ */ oe.jsx(sn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, SA = "_collapse_su0f9_1", NA = "_collapseHeader_su0f9_8", jA = "_collapseContent_su0f9_31", wA = "_url_su0f9_35", CA = "_externalLink_su0f9_51", FA = "_emptyState_su0f9_55", Gr = {
  collapse: SA,
  collapseHeader: NA,
  collapseContent: jA,
  url: wA,
  externalLink: CA,
  emptyState: FA
}, IA = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = bn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Gr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          St,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            sr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Gr.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(sr.Header, { className: Gr.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        Ss,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        A.ExternalLink,
                        {
                          className: Gr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(ue, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(xs, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(An, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(sr.Content, { className: Gr.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(An, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(Ax, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    Kn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    St,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
                      variant: "tertiary",
                      className: Gr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Kn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          St,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, EA = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, Vx = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Vx(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, TA = "_modalBody_iv3ua_1", $A = "_error_iv3ua_5", DA = "_dropdown_iv3ua_16", wi = {
  modalBody: TA,
  error: $A,
  dropdown: DA
}, RA = fo(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), OA = fo(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), PA = fo(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), AA = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = mn(), { control: m, handleSubmit: u, reset: f } = tr(), [h, v] = se([]), [F, S] = se(), [N, C] = se([]), [y, H] = se(), [T, E] = se([]), [D, U] = se(), [Z, Q] = se([]), [ie, Y] = se(), [M, O] = se([]), [q, ee] = se(), [ge, de] = se(!1), { useMutation: le } = mn(), { track: pe } = bn(), [W, { loading: be }] = le(
    RA,
    {
      onError: () => {
        de(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ce) => {
        const He = {
          identifier: Ce.Linear?.issueCreate?.issue?.identifier,
          url: Ce.Linear?.issueCreate?.issue?.url
        };
        Ce.Linear && Ce.Linear?.issueCreate?.issue?.id && (a(Ce.Linear?.issueCreate?.issue?.id), Ae(He), de(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ce.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), pe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Fe,
    { data: K, loading: Be, error: Me }
  ] = l(OA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const He = Ce.Linear.teams.edges.map(
        ({ node: Ze }) => Ze
      );
      v(He), Q(Ce.Linear.issuePriorityValues), s(`${WA}${Ce.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Ue, loading: we }] = l(PA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const He = Ce?.Linear?.team?.projects?.edges?.map(
        ({ node: he }) => he
      );
      C(He);
      const Ze = Ce?.Linear?.team?.states?.edges?.map(
        ({ node: he }) => he
      );
      E(Ze);
      const me = Ce?.Linear?.team?.templates?.edges?.map(
        ({ node: he }) => he
      );
      O(
        me.filter(
          (he) => he.type === "issue"
        )
      );
    }
  }), Ae = (Ce) => {
    r(!1), H(void 0), S(void 0), U(void 0), Y(void 0), ee(void 0), Ce && (e(Ce), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, $e = (Ce) => {
    K && !Be && (W({
      variables: {
        issueTitle: Ce.title,
        issueDescription: Ce?.description,
        teamId: Ce.team.id,
        projectId: Ce?.project?.id,
        statusId: Ce?.status?.id,
        priority: Ce?.priority?.priority
      }
    }), de(!0));
  };
  qe(() => {
    n && Fe();
  }, [n]);
  const tn = () => {
    pe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    Nt,
    {
      isOpen: n,
      onClose: () => {
        tn(), Ae();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          jt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              tn(), Ae();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            className: wi.modalBody,
            "data-testid": "createIssueModalBody",
            children: Me ? /* @__PURE__ */ oe.jsx(Fn, { error: Me }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u($e), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(Et, { children: [
              /* @__PURE__ */ oe.jsx(Qe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ce, onChange: He },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ oe.jsx(
                    Pn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Ze?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        Yr,
                        {
                          dropdownProps: { className: wi.dropdown },
                          placeholder: "Select Linear team",
                          className: ut({ [wi.error]: Ze }),
                          getItemTitleByValue: (me) => me?.name,
                          onChange: (me) => {
                            H(void 0), U(void 0), Y(void 0), ee(void 0), S(me.selectedValues[0]), Pe({
                              variables: { teamId: me.selectedValues[0].id }
                            }), He(me.selectedValues[0]);
                          },
                          value: F ? [Ce] : void 0,
                          children: h?.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Qe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ce, onChange: He } }) => {
                    const Ze = we ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(Pn, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Linear project" : "Select a Team first",
                        onChange: (me) => {
                          H(me.selectedValues[0]), He(me.selectedValues[0]);
                        },
                        value: y ? [Ce] : Ze,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          we && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
                            }
                          ),
                          Ue && !we && N.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Qe, { span: 6, children: /* @__PURE__ */ oe.jsx(Pn, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                Yr,
                {
                  clearable: !0,
                  dropdownProps: { className: wi.dropdown },
                  disabled: !F || we,
                  placeholder: F ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ce) => Ce?.name,
                  onChange: (Ce) => {
                    if (Ce.selectedValues.length > 0) {
                      ee(Ce.selectedValues[0]);
                      const He = JSON.parse(
                        Ce.selectedValues[0].templateData
                      ), Ze = Z.filter(
                        (Le) => Le.priority === He.priority
                      );
                      Y(
                        Ze ? Ze[0] : void 0
                      );
                      const me = T.filter(
                        (Le) => Le.id === He.stateId
                      );
                      U(
                        me ? me[0] : void 0
                      );
                      const he = N.filter(
                        (Le) => Le.id === He.projectId
                      );
                      H(
                        he ? he[0] : void 0
                      );
                      const Ee = He.description;
                      f({
                        title: He?.title,
                        priority: Ze[0],
                        status: me[0],
                        project: he[0],
                        description: Ee ? Vx(Ee, EA) : "",
                        team: F
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: F
                      }), H(void 0), Y(void 0), U(void 0), ee(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: M?.map((Ce) => /* @__PURE__ */ oe.jsx(
                    ot.Item,
                    {
                      value: Ce,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: Ce.name })
                    },
                    Ce.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(Qe, { span: 6, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ce, value: He },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ oe.jsx(
                    lr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: He || "",
                        onChange: Ce
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Qe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ce, onChange: He } }) => {
                    const Ze = we ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Pn, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue status" : "Select a Team first",
                        onChange: (me) => {
                          U(me.selectedValues[0]), He(me.selectedValues[0]);
                        },
                        value: D ? [Ce] : Ze,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          we && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
                            }
                          ),
                          Ue && !we && T.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      Ss,
                                      {
                                        type: me.type,
                                        color: me.color,
                                        name: me.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                                  ]
                                }
                              )
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Qe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ce, onChange: He } }) => {
                    const Ze = Be ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Pn, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.label,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue priority" : "Select a Team first",
                        onChange: (me) => {
                          Y(me.selectedValues[0]), He(me.selectedValues[0]);
                        },
                        value: ie ? [Ce] : Ze,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          we && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
                            }
                          ),
                          K && !Be && Z.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      xs,
                                      {
                                        priority: me.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.label })
                                  ]
                                }
                              )
                            },
                            me.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Qe, { children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ce, value: He },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ oe.jsx(
                    o0,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: He || "",
                        onChange: Ce
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Tt,
          {
            confirmOnClick: u($e),
            confirmProps: {
              disabled: be || !K,
              isLoading: ge || Be || we,
              loadingIndicator: /* @__PURE__ */ oe.jsx(sn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              tn(), Ae();
            }
          }
        )
      ]
    }
  );
}, LA = "_modalWrapper_4kh9u_1", VA = "_copyButton_4kh9u_6", zA = "_copyWrapper_4kh9u_15", UA = "_copyField_4kh9u_24", MA = "_externalLink_4kh9u_47", BA = "_externalLinkIcon_4kh9u_52", qA = "_textWrapper_4kh9u_56", ni = {
  modalWrapper: LA,
  copyButton: VA,
  copyWrapper: zA,
  copyField: UA,
  externalLink: MA,
  externalLinkIcon: BA,
  textWrapper: qA
}, HA = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  Nt,
  {
    isOpen: !!n && e,
    className: ni.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        jt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(wt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(A.Paragraph, { className: ni.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ni.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(ue, { name: "external-link", className: ni.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(Pn, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ni.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    br,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ni.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    s0,
                    {
                      className: ni.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        Tt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), WA = "https://linear.app/", KA = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: F } = mn(), [S, N] = se(""), C = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: H } = bn(), {
    loading: T,
    data: E,
    error: D,
    store: U
  } = Im(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: ie,
      networkStatus: Y,
      error: M
    }
  ] = F(QP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    !T && !D && E && E?.linear?.issues?.length > 0 ? (o(E.linear.issues), Z({
      variables: {
        linkedIssues: E.linear.issues
      }
    })) : !T && !D && (i([]), o([]));
  }, [E, T, D]), qe(() => {
    Q && Q?.Linear && !ie && Y === Gt.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: de }) => de));
  }, [Q, ie, Y]);
  const O = (de) => {
    de && de?.team?.organization?.urlKey && H("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de.id
    });
    const le = (pe) => pe.id === de?.id;
    r.some((pe) => pe && le(pe)) || (E && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, de.id]
      }
    }));
  }, q = (de) => {
    const le = E?.linear.issues.filter((pe) => pe !== de) || [];
    H("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de
    }), i(r.filter(({ id: pe }) => pe !== de)), o(le), U({
      linear: {
        issues: le
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ge = T || ie || !E && !D || (E?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !T && !ie && (M || D) ? /* @__PURE__ */ oe.jsx(Fn, { error: M || D }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      Nt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            jt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(wt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            Tt,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      AA,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (de) => m(de),
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        addToLinkedIssueIds: (de) => {
          U({
            linear: {
              issues: [...a, de]
            }
          });
        },
        setCreatedIssue: (de) => v(de),
        organizationUrl: S,
        setOrganizationUrl: (de) => N(de)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      HA,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          C && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Kn,
              {
                variant: "primary",
                onClick: () => {
                  H("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(xA, { handleSelect: O, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      IA,
      {
        linkedIssues: r,
        isLoading: ge,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (de) => l(de),
        showUnlinkAllButton: y,
        organizationUrl: S
      }
    )
  ] });
}, GA = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vu = { exports: {} }, ga = {}, qv;
function YA() {
  if (qv) return ga;
  qv = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ga.Fragment = r, ga.jsx = s, ga.jsxs = s, ga;
}
var Do = {}, Hv;
function JA() {
  return Hv || (Hv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Do.Fragment = i, Do.jsx = Rn, Do.jsxs = Bn;
  })()), Do;
}
var Wv;
function QA() {
  return Wv || (Wv = 1, process.env.NODE_ENV === "production" ? vu.exports = YA() : vu.exports = JA()), vu.exports;
}
var De = QA();
const XA = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, ZA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, e2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, n2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, t2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, r2 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": XA,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": ZA,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": e2,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": n2,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": t2
};
function Zs(e) {
  return r2[e] ?? {};
}
const i2 = Zs(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), a2 = Zs(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), o2 = Zs(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), s2 = Zs(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function ku(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const l2 = "_wrapper_27vny_1", c2 = "_copyIcon_27vny_12", va = {
  wrapper: l2,
  copyIcon: c2
}, d2 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = ku(), { isCopied: i, copy: a } = ku(), { isCopied: o, copy: s } = ku();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: F,
    referral_url: S
  } = e, N = f ? Ln(f).isSame(Date.now(), "day") : !1, { name: C, first_name: y, last_name: H } = m ?? {}, T = C ?? (`${y} ${H}`.trim() || "A customer has no name"), E = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ De.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ De.jsxs(b, { className: va.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: va.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-2", children: T }),
          N && /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Ln(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ De.jsx(b, { gap: "200", children: /* @__PURE__ */ De.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Ln(F).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "mail" }),
        /* @__PURE__ */ De.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ De.jsx(Ke, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: va.copyIcon
        }
      ) })
    ] }),
    E && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "link" }),
        /* @__PURE__ */ De.jsx(Ke, { content: "Shopify shop", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: E,
            target: "_blank",
            rel: "noreferrer",
            children: E.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ke, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(E),
          className: va.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "external-link" }),
        /* @__PURE__ */ De.jsx(Ke, { content: "Referral link", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ke, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: va.copyIcon
        }
      ) })
    ] })
  ] }) });
}, u2 = "_list_1q5b5_5", m2 = "_listItem_1q5b5_8", p2 = "_listItemEdit_1q5b5_15", f2 = "_notificationText_1q5b5_19", Ui = {
  list: u2,
  listItem: m2,
  listItemEdit: p2,
  notificationText: f2
}, h2 = "_modalBody_1clhs_1", y2 = {
  modalBody: h2
}, g2 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [F, { loading: S }] = o(
    o2,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), Y();
      }
    }
  ), [N, { loading: C }] = o(s2), y = S || C, H = !!h, T = n === d ? "Change the value to update the points" : "", E = isNaN(d), D = E ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Z = U ? "Points can not exceed 1,000,000" : "", Q = () => {
    if (!r) {
      v(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && F({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((M) => {
      const O = M?.networkError;
      (O ? O?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Y()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && N({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((M) => {
      M.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Y()) : "errors" in M && (l("loyaltylion:remove:points:failed"), v(
        M.errors?.map((O) => O.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ie = () => {
    E && m(n), f(""), i();
  }, Y = () => {
    a(), ie();
  };
  return /* @__PURE__ */ De.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: ie,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ De.jsx(jt, { title: "Change points", onClose: ie }),
        /* @__PURE__ */ De.jsxs(wt, { className: y2.modalBody, children: [
          /* @__PURE__ */ De.jsxs(Et, { children: [
            /* @__PURE__ */ De.jsx(Qe, { span: 6, children: /* @__PURE__ */ De.jsx(
              lr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || D,
                  warning: T
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (M) => m(M?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ De.jsx(Qe, { span: 6, children: /* @__PURE__ */ De.jsx(
              lr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (M) => f(M?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && H && /* @__PURE__ */ De.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ De.jsx(We, { children: h?.map((M, O) => /* @__PURE__ */ De.jsx(
            We.Item,
            {
              variant: "dense",
              title: M,
              contentLeft: /* @__PURE__ */ De.jsx(
                ue,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            O
          )) }) })
        ] }),
        /* @__PURE__ */ De.jsx(
          Tt,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: y,
              disabled: E || U || n === d,
              loadingIndicator: /* @__PURE__ */ De.jsx(sn, { size: 16 })
            },
            cancelOnClick: ie
          }
        )
      ]
    }
  );
}, v2 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ De.jsx(We.Text, { variant: "dense", className: Ui.listItem, children: /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ De.jsx(Ke, { content: "Edit points", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Ui.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ De.jsx(Un, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, k2 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ De.jsx(We, { className: Ui.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ De.jsx(
      v2,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ De.jsx(
      g2,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, b2 = "_reward_1wxia_1", _2 = {
  reward: b2
}, x2 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ De.jsx(b, { gap: "100", flexDirection: "column", className: _2.reward, children: /* @__PURE__ */ De.jsx(Ke, { content: a ?? "No description", children: /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ De.jsx(ue, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ De.jsxs(Un, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: 14, name: "external-link" }),
      /* @__PURE__ */ De.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, S2 = ({ customer: e }) => {
  const { useQuery: n } = mn(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(a2, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return no({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ui.notificationText,
        children: "No rewards found"
      }
    ) : Sb({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ui.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ De.jsx(Fn, { error: s });
  }
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(sn, {}) }) : /* @__PURE__ */ De.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ De.jsx(x2, { reward: d }, d.id)) })
  ] });
}, N2 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(An, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(
        ue,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(An, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Ke, { content: "Insights segment", children: /* @__PURE__ */ De.jsx(An, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, j2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = bn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: F,
    refetch: S
  } = r(i2, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return qe(() => {
    if (F && !h) {
      const N = (F?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [F, h]), s?.email ? v ? no({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ De.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ui.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ De.jsx(Fn, { error: v }) : h ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(sn, {}) }) : f ? /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ De.jsxs(De.Fragment, { children: [
        l && /* @__PURE__ */ De.jsx(d2, { customer: a }),
        d && /* @__PURE__ */ De.jsx(N2, { customer: a }),
        m && /* @__PURE__ */ De.jsx(
          k2,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        u && /* @__PURE__ */ De.jsx(S2, { customer: a })
      ] }) : /* @__PURE__ */ De.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, w2 = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var bu = { exports: {} }, ka = {}, Kv;
function C2() {
  if (Kv) return ka;
  Kv = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ka.Fragment = r, ka.jsx = s, ka.jsxs = s, ka;
}
var Ro = {}, Gv;
function F2() {
  return Gv || (Gv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Ro.Fragment = i, Ro.jsx = Rn, Ro.jsxs = Bn;
  })()), Ro;
}
var Yv;
function I2() {
  return Yv || (Yv = 1, process.env.NODE_ENV === "production" ? bu.exports = C2() : bu.exports = F2()), bu.exports;
}
var Cn = I2();
const E2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, T2 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": E2
};
function $2(e) {
  return T2[e] ?? {};
}
const {
  entries: zx,
  setPrototypeOf: Jv,
  isFrozen: D2,
  getPrototypeOf: R2,
  getOwnPropertyDescriptor: O2
} = Object;
let {
  freeze: Ut,
  seal: cr,
  create: La
} = Object, {
  apply: gm,
  construct: vm
} = typeof Reflect < "u" && Reflect;
Ut || (Ut = function(e) {
  return e;
});
cr || (cr = function(e) {
  return e;
});
gm || (gm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
vm || (vm = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const ba = Mt(Array.prototype.forEach), P2 = Mt(Array.prototype.lastIndexOf), Qv = Mt(Array.prototype.pop), _a = Mt(Array.prototype.push), A2 = Mt(Array.prototype.splice), is = Mt(String.prototype.toLowerCase), _u = Mt(String.prototype.toString), xu = Mt(String.prototype.match), Ci = Mt(String.prototype.replace), L2 = Mt(String.prototype.indexOf), V2 = Mt(String.prototype.trim), pr = Mt(Object.prototype.hasOwnProperty), Dt = Mt(RegExp.prototype.test), xa = z2(TypeError);
function Mt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return gm(e, n, i);
  };
}
function z2(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return vm(e, r);
  };
}
function Tn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : is;
  Jv && Jv(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (D2(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function U2(e) {
  for (let n = 0; n < e.length; n++)
    pr(e, n) || (e[n] = null);
  return e;
}
function jr(e) {
  const n = La(null);
  for (const [r, i] of zx(e))
    pr(e, r) && (Array.isArray(i) ? n[r] = U2(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = jr(i) : n[r] = i);
  return n;
}
function Sa(e, n) {
  for (; e !== null; ) {
    const i = O2(e, n);
    if (i) {
      if (i.get)
        return Mt(i.get);
      if (typeof i.value == "function")
        return Mt(i.value);
    }
    e = R2(e);
  }
  function r() {
    return null;
  }
  return r;
}
const Xv = Ut(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Su = Ut(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Nu = Ut(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), M2 = Ut(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ju = Ut(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), B2 = Ut(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Zv = Ut(["#text"]), ek = Ut(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), wu = Ut(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), nk = Ut(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Oo = Ut(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), q2 = cr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), H2 = cr(/<%[\w\W]*|[\w\W]*%>/gm), W2 = cr(/\$\{[\w\W]*/gm), K2 = cr(/^data-[\-\w.\u00B7-\uFFFF]+$/), G2 = cr(/^aria-[\-\w]+$/), Ux = cr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Y2 = cr(/^(?:\w+script|data):/i), J2 = cr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Mx = cr(/^html$/i), Q2 = cr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var tk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: G2,
  ATTR_WHITESPACE: J2,
  CUSTOM_ELEMENT: Q2,
  DATA_ATTR: K2,
  DOCTYPE_NAME: Mx,
  ERB_EXPR: H2,
  IS_ALLOWED_URI: Ux,
  IS_SCRIPT_OR_DATA: Y2,
  MUSTACHE_EXPR: q2,
  TMPLIT_EXPR: W2
});
const Na = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, X2 = function() {
  return typeof window > "u" ? null : window;
}, Z2 = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, rk = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Bx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : X2();
  const n = (x) => Bx(x);
  if (n.version = "3.4.0", n.removed = [], !e || !e.document || e.document.nodeType !== Na.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, F = d.prototype, S = Sa(F, "cloneNode"), N = Sa(F, "remove"), C = Sa(F, "nextSibling"), y = Sa(F, "childNodes"), H = Sa(F, "parentNode");
  if (typeof s == "function") {
    const x = r.createElement("template");
    x.content && x.content.ownerDocument && (r = x.content.ownerDocument);
  }
  let T, E = "";
  const {
    implementation: D,
    createNodeIterator: U,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = r, {
    importNode: ie
  } = i;
  let Y = rk();
  n.isSupported = typeof zx == "function" && typeof H == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: M,
    ERB_EXPR: O,
    TMPLIT_EXPR: q,
    DATA_ATTR: ee,
    ARIA_ATTR: ge,
    IS_SCRIPT_OR_DATA: de,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: pe
  } = tk;
  let {
    IS_ALLOWED_URI: W
  } = tk, be = null;
  const Fe = Tn({}, [...Xv, ...Su, ...Nu, ...ju, ...Zv]);
  let K = null;
  const Be = Tn({}, [...ek, ...wu, ...nk, ...Oo]);
  let Me = Object.seal(La(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Ue = null;
  const we = Object.seal(La(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ae = !0, $e = !0, tn = !1, Ce = !0, He = !1, Ze = !0, me = !1, he = !1, Ee = !1, Le = !1, Re = !1, ln = !1, w = !0, _ = !1;
  const $ = "user-content-";
  let G = !0, J = !1, R = {}, z = null;
  const re = Tn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let fe = null;
  const _e = Tn({}, ["audio", "video", "img", "source", "image", "track"]);
  let en = null;
  const un = Tn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", dn = "http://www.w3.org/2000/svg", pn = "http://www.w3.org/1999/xhtml";
  let cn = pn, kn = !1, Xe = null;
  const Sn = Tn({}, [rn, dn, pn], _u);
  let Oe = Tn({}, ["mi", "mo", "mn", "ms", "mtext"]), an = Tn({}, ["annotation-xml"]);
  const on = Tn({}, ["title", "style", "font", "a", "script"]);
  let yn = null;
  const Hn = ["application/xhtml+xml", "text/html"], Nn = "text/html";
  let gn = null, hn = null;
  const jn = r.createElement("form"), Mn = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, Vn = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(hn && hn === x)) {
      if ((!x || typeof x != "object") && (x = {}), x = jr(x), yn = // eslint-disable-next-line unicorn/prefer-includes
      Hn.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? Nn : x.PARSER_MEDIA_TYPE, gn = yn === "application/xhtml+xml" ? _u : is, be = pr(x, "ALLOWED_TAGS") ? Tn({}, x.ALLOWED_TAGS, gn) : Fe, K = pr(x, "ALLOWED_ATTR") ? Tn({}, x.ALLOWED_ATTR, gn) : Be, Xe = pr(x, "ALLOWED_NAMESPACES") ? Tn({}, x.ALLOWED_NAMESPACES, _u) : Sn, en = pr(x, "ADD_URI_SAFE_ATTR") ? Tn(jr(un), x.ADD_URI_SAFE_ATTR, gn) : un, fe = pr(x, "ADD_DATA_URI_TAGS") ? Tn(jr(_e), x.ADD_DATA_URI_TAGS, gn) : _e, z = pr(x, "FORBID_CONTENTS") ? Tn({}, x.FORBID_CONTENTS, gn) : re, Pe = pr(x, "FORBID_TAGS") ? Tn({}, x.FORBID_TAGS, gn) : jr({}), Ue = pr(x, "FORBID_ATTR") ? Tn({}, x.FORBID_ATTR, gn) : jr({}), R = pr(x, "USE_PROFILES") ? x.USE_PROFILES : !1, Ae = x.ALLOW_ARIA_ATTR !== !1, $e = x.ALLOW_DATA_ATTR !== !1, tn = x.ALLOW_UNKNOWN_PROTOCOLS || !1, Ce = x.ALLOW_SELF_CLOSE_IN_ATTR !== !1, He = x.SAFE_FOR_TEMPLATES || !1, Ze = x.SAFE_FOR_XML !== !1, me = x.WHOLE_DOCUMENT || !1, Le = x.RETURN_DOM || !1, Re = x.RETURN_DOM_FRAGMENT || !1, ln = x.RETURN_TRUSTED_TYPE || !1, Ee = x.FORCE_BODY || !1, w = x.SANITIZE_DOM !== !1, _ = x.SANITIZE_NAMED_PROPS || !1, G = x.KEEP_CONTENT !== !1, J = x.IN_PLACE || !1, W = x.ALLOWED_URI_REGEXP || Ux, cn = x.NAMESPACE || pn, Oe = x.MATHML_TEXT_INTEGRATION_POINTS || Oe, an = x.HTML_INTEGRATION_POINTS || an, Me = x.CUSTOM_ELEMENT_HANDLING || La(null), x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Me.tagNameCheck = x.CUSTOM_ELEMENT_HANDLING.tagNameCheck), x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Me.attributeNameCheck = x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Me.allowCustomizedBuiltInElements = x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), He && ($e = !1), Re && (Le = !0), R && (be = Tn({}, Zv), K = La(null), R.html === !0 && (Tn(be, Xv), Tn(K, ek)), R.svg === !0 && (Tn(be, Su), Tn(K, wu), Tn(K, Oo)), R.svgFilters === !0 && (Tn(be, Nu), Tn(K, wu), Tn(K, Oo)), R.mathMl === !0 && (Tn(be, ju), Tn(K, nk), Tn(K, Oo))), we.tagCheck = null, we.attributeCheck = null, x.ADD_TAGS && (typeof x.ADD_TAGS == "function" ? we.tagCheck = x.ADD_TAGS : (be === Fe && (be = jr(be)), Tn(be, x.ADD_TAGS, gn))), x.ADD_ATTR && (typeof x.ADD_ATTR == "function" ? we.attributeCheck = x.ADD_ATTR : (K === Be && (K = jr(K)), Tn(K, x.ADD_ATTR, gn))), x.ADD_URI_SAFE_ATTR && Tn(en, x.ADD_URI_SAFE_ATTR, gn), x.FORBID_CONTENTS && (z === re && (z = jr(z)), Tn(z, x.FORBID_CONTENTS, gn)), x.ADD_FORBID_CONTENTS && (z === re && (z = jr(z)), Tn(z, x.ADD_FORBID_CONTENTS, gn)), G && (be["#text"] = !0), me && Tn(be, ["html", "head", "body"]), be.table && (Tn(be, ["tbody"]), delete Pe.tbody), x.TRUSTED_TYPES_POLICY) {
        if (typeof x.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw xa('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof x.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw xa('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        T = x.TRUSTED_TYPES_POLICY, E = T.createHTML("");
      } else
        T === void 0 && (T = Z2(v, a)), T !== null && typeof E == "string" && (E = T.createHTML(""));
      Ut && Ut(x), hn = x;
    }
  }, _n = Tn({}, [...Su, ...Nu, ...M2]), xn = Tn({}, [...ju, ...B2]), Wn = function(x) {
    let V = H(x);
    (!V || !V.tagName) && (V = {
      namespaceURI: cn,
      tagName: "template"
    });
    const X = is(x.tagName), je = is(V.tagName);
    return Xe[x.namespaceURI] ? x.namespaceURI === dn ? V.namespaceURI === pn ? X === "svg" : V.namespaceURI === rn ? X === "svg" && (je === "annotation-xml" || Oe[je]) : !!_n[X] : x.namespaceURI === rn ? V.namespaceURI === pn ? X === "math" : V.namespaceURI === dn ? X === "math" && an[je] : !!xn[X] : x.namespaceURI === pn ? V.namespaceURI === dn && !an[je] || V.namespaceURI === rn && !Oe[je] ? !1 : !xn[X] && (on[X] || !_n[X]) : !!(yn === "application/xhtml+xml" && Xe[x.namespaceURI]) : !1;
  }, Dn = function(x) {
    _a(n.removed, {
      element: x
    });
    try {
      H(x).removeChild(x);
    } catch {
      N(x);
    }
  }, Rn = function(x, V) {
    try {
      _a(n.removed, {
        attribute: V.getAttributeNode(x),
        from: V
      });
    } catch {
      _a(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(x), x === "is")
      if (Le || Re)
        try {
          Dn(V);
        } catch {
        }
      else
        try {
          V.setAttribute(x, "");
        } catch {
        }
  }, Bn = function(x) {
    let V = null, X = null;
    if (Ee)
      x = "<remove></remove>" + x;
    else {
      const ne = xu(x, /^[\r\n\t ]+/);
      X = ne && ne[0];
    }
    yn === "application/xhtml+xml" && cn === pn && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    const je = T ? T.createHTML(x) : x;
    if (cn === pn)
      try {
        V = new h().parseFromString(je, yn);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = D.createDocument(cn, "template", null);
      try {
        V.documentElement.innerHTML = kn ? E : je;
      } catch {
      }
    }
    const Se = V.body || V.documentElement;
    return x && X && Se.insertBefore(r.createTextNode(X), Se.childNodes[0] || null), cn === pn ? Q.call(V, me ? "html" : "body")[0] : me ? V.documentElement : Se;
  }, t = function(x) {
    return U.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(x) {
    return x instanceof f && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof u) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, p = function(x) {
    return typeof l == "function" && x instanceof l;
  };
  function g(x, V, X) {
    ba(x, (je) => {
      je.call(n, V, X, hn);
    });
  }
  const P = function(x) {
    let V = null;
    if (g(Y.beforeSanitizeElements, x, null), c(x))
      return Dn(x), !0;
    const X = gn(x.nodeName);
    if (g(Y.uponSanitizeElement, x, {
      tagName: X,
      allowedTags: be
    }), Ze && x.hasChildNodes() && !p(x.firstElementChild) && Dt(/<[/\w!]/g, x.innerHTML) && Dt(/<[/\w!]/g, x.textContent) || Ze && x.namespaceURI === pn && X === "style" && p(x.firstElementChild) || x.nodeType === Na.progressingInstruction || Ze && x.nodeType === Na.comment && Dt(/<[/\w]/g, x.data))
      return Dn(x), !0;
    if (Pe[X] || !(we.tagCheck instanceof Function && we.tagCheck(X)) && !be[X]) {
      if (!Pe[X] && I(X) && (Me.tagNameCheck instanceof RegExp && Dt(Me.tagNameCheck, X) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(X)))
        return !1;
      if (G && !z[X]) {
        const je = H(x) || x.parentNode, Se = y(x) || x.childNodes;
        if (Se && je) {
          const ne = Se.length;
          for (let nn = ne - 1; nn >= 0; --nn) {
            const En = S(Se[nn], !0);
            En.__removalCount = (x.__removalCount || 0) + 1, je.insertBefore(En, C(x));
          }
        }
      }
      return Dn(x), !0;
    }
    return x instanceof d && !Wn(x) || (X === "noscript" || X === "noembed" || X === "noframes") && Dt(/<\/no(script|embed|frames)/i, x.innerHTML) ? (Dn(x), !0) : (He && x.nodeType === Na.text && (V = x.textContent, ba([M, O, q], (je) => {
      V = Ci(V, je, " ");
    }), x.textContent !== V && (_a(n.removed, {
      element: x.cloneNode()
    }), x.textContent = V)), g(Y.afterSanitizeElements, x, null), !1);
  }, L = function(x, V, X) {
    if (Ue[V] || w && (V === "id" || V === "name") && (X in r || X in jn))
      return !1;
    if (!($e && !Ue[V] && Dt(ee, V)) && !(Ae && Dt(ge, V)) && !(we.attributeCheck instanceof Function && we.attributeCheck(V, x))) {
      if (!K[V] || Ue[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(I(x) && (Me.tagNameCheck instanceof RegExp && Dt(Me.tagNameCheck, x) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(x)) && (Me.attributeNameCheck instanceof RegExp && Dt(Me.attributeNameCheck, V) || Me.attributeNameCheck instanceof Function && Me.attributeNameCheck(V, x)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Me.allowCustomizedBuiltInElements && (Me.tagNameCheck instanceof RegExp && Dt(Me.tagNameCheck, X) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(X)))
        ) return !1;
      } else if (!en[V] && !Dt(W, Ci(X, le, "")) && !((V === "src" || V === "xlink:href" || V === "href") && x !== "script" && L2(X, "data:") === 0 && fe[x]) && !(tn && !Dt(de, Ci(X, le, ""))) && X)
        return !1;
    }
    return !0;
  }, I = function(x) {
    return x !== "annotation-xml" && xu(x, pe);
  }, j = function(x) {
    g(Y.beforeSanitizeAttributes, x, null);
    const {
      attributes: V
    } = x;
    if (!V || c(x))
      return;
    const X = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let je = V.length;
    for (; je--; ) {
      const Se = V[je], {
        name: ne,
        namespaceURI: nn,
        value: En
      } = Se, wn = gn(ne), Qi = En;
      let gt = ne === "value" ? Qi : V2(Qi);
      if (X.attrName = wn, X.attrValue = gt, X.keepAttr = !0, X.forceKeepAttr = void 0, g(Y.uponSanitizeAttribute, x, X), gt = X.attrValue, _ && (wn === "id" || wn === "name") && (Rn(ne, x), gt = $ + gt), Ze && Dt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, gt)) {
        Rn(ne, x);
        continue;
      }
      if (wn === "attributename" && xu(gt, "href")) {
        Rn(ne, x);
        continue;
      }
      if (X.forceKeepAttr)
        continue;
      if (!X.keepAttr) {
        Rn(ne, x);
        continue;
      }
      if (!Ce && Dt(/\/>/i, gt)) {
        Rn(ne, x);
        continue;
      }
      He && ba([M, O, q], ($S) => {
        gt = Ci(gt, $S, " ");
      });
      const Kp = gn(x.nodeName);
      if (!L(Kp, wn, gt)) {
        Rn(ne, x);
        continue;
      }
      if (T && typeof v == "object" && typeof v.getAttributeType == "function" && !nn)
        switch (v.getAttributeType(Kp, wn)) {
          case "TrustedHTML": {
            gt = T.createHTML(gt);
            break;
          }
          case "TrustedScriptURL": {
            gt = T.createScriptURL(gt);
            break;
          }
        }
      if (gt !== Qi)
        try {
          nn ? x.setAttributeNS(nn, ne, gt) : x.setAttribute(ne, gt), c(x) ? Dn(x) : Qv(n.removed);
        } catch {
          Rn(ne, x);
        }
    }
    g(Y.afterSanitizeAttributes, x, null);
  }, te = function(x) {
    let V = null;
    const X = t(x);
    for (g(Y.beforeSanitizeShadowDOM, x, null); V = X.nextNode(); )
      g(Y.uponSanitizeShadowNode, V, null), P(V), j(V), V.content instanceof o && te(V.content);
    g(Y.afterSanitizeShadowDOM, x, null);
  };
  return n.sanitize = function(x) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = null, je = null, Se = null, ne = null;
    if (kn = !x, kn && (x = "<!-->"), typeof x != "string" && !p(x))
      if (typeof x.toString == "function") {
        if (x = x.toString(), typeof x != "string")
          throw xa("dirty is not a string, aborting");
      } else
        throw xa("toString is not a function");
    if (!n.isSupported)
      return x;
    if (he || Vn(V), n.removed = [], typeof x == "string" && (J = !1), J) {
      if (x.nodeName) {
        const wn = gn(x.nodeName);
        if (!be[wn] || Pe[wn])
          throw xa("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (x instanceof l)
      X = Bn("<!---->"), je = X.ownerDocument.importNode(x, !0), je.nodeType === Na.element && je.nodeName === "BODY" || je.nodeName === "HTML" ? X = je : X.appendChild(je);
    else {
      if (!Le && !He && !me && // eslint-disable-next-line unicorn/prefer-includes
      x.indexOf("<") === -1)
        return T && ln ? T.createHTML(x) : x;
      if (X = Bn(x), !X)
        return Le ? null : ln ? E : "";
    }
    X && Ee && Dn(X.firstChild);
    const nn = t(J ? x : X);
    for (; Se = nn.nextNode(); )
      P(Se), j(Se), Se.content instanceof o && te(Se.content);
    if (J)
      return x;
    if (Le) {
      if (He) {
        X.normalize();
        let wn = X.innerHTML;
        ba([M, O, q], (Qi) => {
          wn = Ci(wn, Qi, " ");
        }), X.innerHTML = wn;
      }
      if (Re)
        for (ne = Z.call(X.ownerDocument); X.firstChild; )
          ne.appendChild(X.firstChild);
      else
        ne = X;
      return (K.shadowroot || K.shadowrootmode) && (ne = ie.call(i, ne, !0)), ne;
    }
    let En = me ? X.outerHTML : X.innerHTML;
    return me && be["!doctype"] && X.ownerDocument && X.ownerDocument.doctype && X.ownerDocument.doctype.name && Dt(Mx, X.ownerDocument.doctype.name) && (En = "<!DOCTYPE " + X.ownerDocument.doctype.name + `>
` + En), He && ba([M, O, q], (wn) => {
      En = Ci(En, wn, " ");
    }), T && ln ? T.createHTML(En) : En;
  }, n.setConfig = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(x), he = !0;
  }, n.clearConfig = function() {
    hn = null, he = !1;
  }, n.isValidAttribute = function(x, V, X) {
    hn || Vn({});
    const je = gn(x), Se = gn(V);
    return L(je, Se, X);
  }, n.addHook = function(x, V) {
    typeof V == "function" && _a(Y[x], V);
  }, n.removeHook = function(x, V) {
    if (V !== void 0) {
      const X = P2(Y[x], V);
      return X === -1 ? void 0 : A2(Y[x], X, 1)[0];
    }
    return Qv(Y[x]);
  }, n.removeHooks = function(x) {
    Y[x] = [];
  }, n.removeAllHooks = function() {
    Y = rk();
  }, n;
}
var eL = Bx();
const nL = "_messageContainer_1rxr4_1", tL = "_chip_1rxr4_7", rL = "_chipLabel_1rxr4_10", iL = "_chipValue_1rxr4_13", Po = {
  messageContainer: nL,
  chip: tL,
  chipLabel: rL,
  chipValue: iL
}, ik = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, aL = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ Cn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ Cn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ Cn.jsx(Ke, { content: "Conversation Attributes", children: /* @__PURE__ */ Cn.jsx(
        $m,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ Cn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Cn.jsx(An, { className: Po.chip, children: /* @__PURE__ */ Cn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ Cn.jsxs(Qn, { className: Po.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ Cn.jsx(Qn, { className: Po.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ Cn.jsx(
      b,
      {
        className: Po.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? ik[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? ik[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ Cn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ Cn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ Cn.jsx(c0, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ Cn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: eL.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ Cn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ Cn.jsx(
      d0,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ Cn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, oL = "_conversation_1draa_1", sL = "_conversationSubLine_1draa_9", lL = "_modal_1draa_14", Cu = {
  conversation: oL,
  conversationSubLine: sL,
  modal: lL
}, cL = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), dL = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), uL = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ Cn.jsxs(b, { className: Cu.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ Cn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ Cn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ Cn.jsx(Un, { size: "small", variant: "info", children: Ln(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ Cn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Cu.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ Cn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ Cn.jsx(An, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ Cn.jsx(Ke, { content: "Show conversation preview", children: /* @__PURE__ */ Cn.jsx(
        Yt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ Cn.jsxs(
      Nt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Cu.modal,
        children: [
          /* @__PURE__ */ Cn.jsx(
            jt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ Cn.jsx(wt, { children: /* @__PURE__ */ Cn.jsx(
            aL,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: cL(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: dL(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, mL = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = qn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ Cn.jsx(
      uL,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ Cn.jsxs(
      Kn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, pL = $2(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), fL = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = mn(), { data: l, loading: d, error: m } = s(pL, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ Cn.jsx(Fn, { error: m }) : d ? /* @__PURE__ */ Cn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Cn.jsx(sn, {}) }) : r?.length === 0 ? /* @__PURE__ */ Cn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ Cn.jsx(
    mL,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, hL = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Fu = { exports: {} }, ja = {}, ak;
function yL() {
  if (ak) return ja;
  ak = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ja.Fragment = r, ja.jsx = s, ja.jsxs = s, ja;
}
var Ao = {}, ok;
function gL() {
  return ok || (ok = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Ao.Fragment = i, Ao.jsx = Rn, Ao.jsxs = Bn;
  })()), Ao;
}
var sk;
function vL() {
  return sk || (sk = 1, process.env.NODE_ENV === "production" ? Fu.exports = yL() : Fu.exports = gL()), Fu.exports;
}
var Ie = vL();
const kL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, bL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, _L = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, xL = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": kL,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": bL,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": _L
};
function Ip(e) {
  return xL[e] ?? {};
}
const SL = Ip(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), NL = Ip(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), jL = Ip(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function km(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const wL = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, qx = "DD MMM YYYY @ HH:mm", CL = "_list_2c4dq_1", FL = "_listItem_2c4dq_4", IL = "_copyIcon_2c4dq_12", pi = {
  list: CL,
  listItem: FL,
  copyIcon: IL
}, bm = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = km(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: F
  } = e ?? {}, S = `${d} ${m}`.trim() || void 0, N = `${h} ${v}`.trim() || void 0, C = [S, u, f, N, F].filter(
    Boolean
  );
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ie.jsx(ue, { size: l, name: n }),
      i ? /* @__PURE__ */ Ie.jsx(sn, { size: l }) : /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: C.map((y, H) => /* @__PURE__ */ Ie.jsx(Qn, { children: y }, H)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ie.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ie.jsx(Ke, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ie.jsx(
        ue,
        {
          size: l,
          name: "exclamation",
          className: pi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ie.jsx(Ke, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ie.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(C.join(", ")),
          className: pi.copyIcon
        }
      ) })
    ] })
  ] });
}, EL = "_wrapper_1nher_1", TL = {
  wrapper: EL
}, $L = ({
  customer: e,
  store: n
}) => {
  const { track: r } = bn(), { isCopied: i, copy: a } = km(), { isCopied: o, copy: s } = km(), { useQuery: l } = mn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(NL, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, F = (h?.addresses?.length ?? 0) > 1;
  if (qe(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ Ie.jsx(Fn, { error: u });
  if (!e)
    return null;
  const {
    id: S,
    phone: N,
    email: C,
    first_name: y,
    last_name: H,
    created_at: T,
    has_valid_payment_method: E
  } = e, D = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, Z = `${y || ""} ${H || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ie.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ie.jsxs(b, { className: TL.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx(A.Heading, { variant: "heading-2", children: Z }),
    T && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(qx) })
    ] }),
    C && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ue, { size: D, name: "mail" }),
        /* @__PURE__ */ Ie.jsx(A.ExternalLink, { href: `mailto:${C}`, children: C })
      ] }),
      /* @__PURE__ */ Ie.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ Ie.jsx(
        ue,
        {
          size: D,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: pi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ue, { size: D, name: "phone" }),
        /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ Ie.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ Ie.jsx(
        ue,
        {
          size: D,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: pi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ie.jsx(
      bm,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: F
      }
    ),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ue, { size: D, name: "credit-card" }),
        /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ie.jsx(
        ue,
        {
          size: D,
          name: E ? "check-circle" : "close-circle-filled",
          color: E ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ie.jsx(ue, { size: D, name: "external-link" }),
      /* @__PURE__ */ Ie.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, DL = "_order_1dlaa_1", RL = "_orderIsOpen_1dlaa_9", OL = "_orderHeader_1dlaa_12", PL = "_note_1dlaa_16", Lo = {
  order: DL,
  orderIsOpen: RL,
  orderHeader: OL,
  note: PL
}, AL = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = bn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: F,
    is_prepaid: S
  } = e, N = 14, C = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ie.jsxs(
    b,
    {
      className: ut(Lo.order, {
        [Lo.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ie.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Lo.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ie.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ie.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: Ln(f).format(qx) }) }),
                /* @__PURE__ */ Ie.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ie.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Ie.jsx(Ke, { content: "Note", children: /* @__PURE__ */ Ie.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Lo.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ue, { size: N, name: "activity" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: wL(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ue, { size: N, name: "credit-card" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ue, { size: N, name: "cog" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ue, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ie.jsxs(A.Paragraph, { variant: "4", children: [
                F,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsx(
            bm,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ie.jsx(
            bm,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          C && /* @__PURE__ */ Ie.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(C, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ie.jsx(ue, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, LL = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = bn(), { useQuery: i } = mn(), {
    loading: a,
    error: o,
    data: s
  } = i(jL, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ie.jsx(Fn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ie.jsx(Un, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ie.jsx(sn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Ie.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ie.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Ie.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Ie.jsx(
        AL,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Ie.jsx(
        St,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ie.jsx(ue, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, VL = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ie.jsxs(We, { className: pi.list, children: [
      /* @__PURE__ */ Ie.jsx(We.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ie.jsx(We.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ie.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, zL = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(SL, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return Cm({ errors: v }) ? /* @__PURE__ */ Ie.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Fm({ errors: v }) ? /* @__PURE__ */ Ie.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ie.jsx(Fn, { error: m });
  }
  return d ? /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ie.jsx(sn, {}) }) : f ? l ? /* @__PURE__ */ Ie.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ie.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ie.jsx($L, { customer: f, store: h }),
        o && /* @__PURE__ */ Ie.jsx(VL, { customer: f }),
        s && /* @__PURE__ */ Ie.jsx(LL, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ie.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, UL = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Iu = { exports: {} }, wa = {}, lk;
function ML() {
  if (lk) return wa;
  lk = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return wa.Fragment = r, wa.jsx = s, wa.jsxs = s, wa;
}
var Vo = {}, ck;
function BL() {
  return ck || (ck = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Vo.Fragment = i, Vo.jsx = Rn, Vo.jsxs = Bn;
  })()), Vo;
}
var dk;
function qL() {
  return dk || (dk = 1, process.env.NODE_ENV === "production" ? Iu.exports = ML() : Iu.exports = BL()), Iu.exports;
}
var k = qL();
const uk = "__PairingContext__", HL = () => globalThis[uk] ?? (() => {
  const e = jb({});
  return globalThis[uk] = e, e;
})(), WL = HL(), KL = () => Em(WL), GL = "_banner_d9pot_1", YL = "_list_d9pot_8", mk = {
  banner: GL,
  list: YL
}, pk = "https://apps.shopify.com/dixa-dashboard", JL = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, Hx = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = KL(), [i, a] = se(!1), [o, s] = se(null), l = JL[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? pk,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(pk, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: mk.banner, children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(ue, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: mk.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Kn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(sn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, QL = (e) => /* @__PURE__ */ k.jsx(Hx, { ...e, bannerVariant: "install" }), XL = (e) => /* @__PURE__ */ k.jsx(Hx, { ...e, bannerVariant: "migration" }), ZL = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], eV = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], nV = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: QL
  }
], tV = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], fk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: XL,
    additionalProperties: { renderAboveForm: !0 }
  }
], Wx = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], hk = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => kb(e)
  },
  ...Wx
];
var Ti = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ti || {}), fi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(fi || {}), Ir = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ir || {}), Kx = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(Kx || {}), ai = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(ai || {}), Br = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Br || {}), as = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(as || {}), Gx = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(Gx || {});
const rV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, iV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, aV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, oV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, sV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, lV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, cV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, dV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, uV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, mV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, pV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, fV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, hV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, yV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, gV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, vV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, kV = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": rV,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": iV,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": aV,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": oV,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": sV,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": lV,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": cV,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": dV,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": uV,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": mV,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": pV,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": fV,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": hV,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": yV,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": gV,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": vV
};
function ur(e) {
  return kV[e] ?? {};
}
const bV = ur(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), _V = ur(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), xV = ur(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), SV = ur(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Ep = ur(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), NV = ur(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), jV = ur(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), wV = ur(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), CV = ur(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), FV = ur(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), IV = ur(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), EV = ur(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), Yx = Rs`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, TV = Rs`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, $V = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(bV, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, DV = () => {
  const { useLazyQuery: e } = mn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(_V);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function eo(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const RV = "_list_alvh6_1", OV = "_listItem_alvh6_4", PV = "_fullWidth_alvh6_15", AV = "_boxWrapper_alvh6_19", It = {
  list: RV,
  listItem: OV,
  fullWidth: PV,
  boxWrapper: AV
}, LV = "_modal_1vkwz_1", VV = "_disabled_1vkwz_5", Eu = {
  modal: LV,
  disabled: VV
}, yk = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: fi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: fi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: fi.Unknown
  }
], gk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Ir.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Ir.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Ir.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Ir.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Ir.Unsubscribed
  }
], zV = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = bn(), { useMutation: l, showNotification: d } = mn(), [m, u] = se(), [f, h] = se(), [v, F] = Ef(!0), [S, N] = Ef(!0), C = !!m, y = e.customer?.email, H = e.customer?.phone_number, T = e.customer?.given_name, E = e.customer?.family_name, D = {
    email: y ?? "",
    phone: H ?? "",
    firstName: T ?? "",
    lastName: E ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = tr({
    defaultValues: D
  });
  qe(() => {
    f?.forEach((O) => {
      const q = O?.field?.[0];
      q && (U.setError(q, {
        type: "server",
        message: O.message
      }), U.setFocus(q));
    });
  }, [f, U]);
  const [Z, { error: Q, reset: ie }] = l(IV, {
    onError: (O) => {
      u(O.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (O) => {
      const q = O?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), Y = tt(
    (O) => {
      a(!0), u(void 0), Z({
        variables: {
          input: {
            firstName: O.firstName,
            lastName: O.lastName,
            ...v && { email: O.email },
            ...S && { phone: O.phone },
            ...O.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: O.smsMarketingState,
                marketingOptInLevel: O.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Z, a, S, v]
  ), M = () => {
    r(!1), ie(), u(void 0), U.reset(D);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: M, className: Eu.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Create new customer", onClose: M }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Et, { children: [
      /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
        Ft,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
        Ft,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
        Ft,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: ut({
              [Eu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Gu,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => F()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
        Ft,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: ut({
              [Eu.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Gu,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
        _r,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = gk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: gk.map((O) => /* @__PURE__ */ k.jsx(ot.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
        _r,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = yk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: yk.map((O) => /* @__PURE__ */ k.jsx(ot.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      C && /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(Y),
        cancelOnClick: M,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, UV = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "user-plus", color: "green.500" }),
        className: It.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      zV,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Tp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, _m = "DD MMM YYYY @ HH:mm", MV = "_wrapper_10fld_1", BV = "_copyIcon_10fld_7", zo = {
  wrapper: MV,
  copyIcon: BV
}, qV = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = eo(), { isCopied: l, copy: d } = eo(), { track: m } = bn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: F = [],
    verifiedEmail: S
  } = e, N = h?.emailAddress, C = v?.phoneNumber, y = Tp(u), H = `https://${n}/admin/customers/${y ?? ""}`, T = i && a === Gt.refetch, E = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: zo.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        T ? /* @__PURE__ */ k.jsx(sn, { size: E }) : /* @__PURE__ */ k.jsx(Ke, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: zo.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: E, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ k.jsx(
            Ke,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                ue,
                {
                  size: E,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: zo.copyIcon
          }
        ) })
      ] }),
      C && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: E, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${C}`, children: C })
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: l ? "done" : "copy",
            onClick: () => d(C),
            className: zo.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(ue, { size: E, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: H,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    F.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: F.map((D) => /* @__PURE__ */ k.jsx(An, { children: D }, `${u}-${D}`)) })
    ] })
  ] });
}, HV = "_creationModal_pbe64_1", WV = "_detailsModal_pbe64_5", KV = "_percentageSuffix_pbe64_9", Tu = {
  creationModal: HV,
  detailsModal: WV,
  percentageSuffix: KV
}, GV = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, YV = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: Kx.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, vk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], kk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], bk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], JV = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = er(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(We, { children: [
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            ue,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Ln(e?.startsAt).format(dt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(Pn, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      br,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, QV = "shopify-discount-code-form", _k = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, XV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = bn(), { useMutation: i, showNotification: a } = mn(), [o, s] = se(
    []
  ), [l, d] = se(), m = tr({
    mode: "all",
    defaultValues: _k
  });
  qe(() => {
    o?.forEach((E) => {
      const D = E?.field?.[1];
      D && m.setError(D, {
        type: "server",
        message: E.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = qn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    F,
    {
      loading: S,
      error: N,
      reset: C
    }
  ] = i(EV, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (E) => {
      const D = E?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (D && D.length > 0)
        s(D);
      else {
        const U = E?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", GV(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, H = (E) => {
    F({
      variables: {
        input: YV(E)
      }
    });
  }, T = () => {
    m.reset(_k), s([]), C(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: T,
      className: ut({
        [Tu.creationModal]: !u,
        [Tu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          jt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: T
          }
        ),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          u && /* @__PURE__ */ k.jsx(JV, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: QV, onSubmit: m.handleSubmit(H), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              to,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(Et, { children: [
              /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
                Ft,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
                _r,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (E) => {
                      const D = vk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: vk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
                Ft,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (E) => {
                      if (E) {
                        if (h === "percentage" && (E < 0 || E > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && E < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Tu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
                Ft,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
                _r,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (E) => {
                      const D = kk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: kk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
                Ft,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (E) => {
                      if (E && f !== "none" && E < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
                _r,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (E, D) => E === D,
                    getItemTitleByValue: (E) => {
                      const D = bk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: bk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ k.jsx(Fn, { error: N })
        ] }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? T : m.handleSubmit(H),
            cancelOnClick: u ? void 0 : T
          }
        )
      ]
    }
  );
}, ZV = ({ code: e }) => {
  const { isCopied: n, copy: r } = eo();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(ue, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          Yt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, ez = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(We, { children: i.map((a) => /* @__PURE__ */ k.jsx(We.Item, { className: It.listItem, children: /* @__PURE__ */ k.jsx(ZV, { code: a.code }, a.id) }, a.id)) })
  ] });
}, nz = "_modal_11d6e_1", tz = "_modalBody_11d6e_4", rz = "_codeContainer_11d6e_9", $u = {
  modal: nz,
  modalBody: tz,
  codeContainer: rz
}, iz = [50, 100, 250], Jx = 50, az = {
  maxNumberOfCodesToDisplay: Jx
}, oz = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    Jx
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = tr({
    mode: "all",
    defaultValues: az
  }), { loading: u, error: f } = r(NV, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const F = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      F && F.length > 0 && s(F);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: e, onClose: h, className: $u.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(wt, { className: $u.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(Et, { children: /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
        _r,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: iz.map((v) => /* @__PURE__ */ k.jsx(ot.Item, { value: v, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        cs,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: $u.codeContainer, children: /* @__PURE__ */ k.jsx(ez, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(Tt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, sz = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      oz,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      XV,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, lz = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? $s(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Ti.Invalid:
      case Ti.NotSubscribed:
      case Ir.NotSubscribed:
        return "red.500";
      case Ti.Pending:
      case Ir.Pending:
      case Ti.Unsubscribed:
      case Ir.Unsubscribed:
        return "orange.500";
      case Ti.Subscribed:
      case Ir.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case fi.SingleOptIn:
      case fi.ConfirmedOptIn:
        return "green.500";
      case fi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: Ln(l).format(_m) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: Ln(u).format(_m) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, cz = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: Gx.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, xk = [
  {
    value: Br.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Br.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Br.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Br.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Br.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Br.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Br.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Sk = [
  {
    value: as.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: as.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: as.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], Qx = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), $i = (e) => dz(uz(e)), dz = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), uz = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ti = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  zt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      lr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), mz = "_modal_1wlra_1", pz = {
  modal: mz
};
function Nk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const jk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], wk = "shopify-shiping-address-form", fz = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = mn(), { track: f } = bn(), [h, v] = se(!1), [F, S] = se({}), N = !l, [
    C,
    { error: y, reset: H }
  ] = m(jV, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (Y) => {
      v(!1);
      const M = Y?.Shopify?.orderUpdate?.userErrors;
      if (M != null && M.length > 0) {
        const O = M.reduce(
          (q, ee) => {
            const ge = ee.field;
            if (ge == null || ge.length === 0)
              return q;
            const de = ge[ge.length - 1];
            return de != null && (q[de] = ee.message), q;
          },
          {}
        );
        S(O);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ie();
    }
  }), T = tt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: jk.find(
        (Y) => Y === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: E, handleSubmit: D, formState: U, reset: Z } = tr({
    mode: "all",
    defaultValues: T()
  }), Q = D((Y) => {
    if (N) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: M, ...O } = Y, q = {
        ...O,
        countryCode: M
      };
      C({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(Y), ie();
  });
  qe(() => {
    r && Z(T());
  }, [r, n, Z, T]);
  const ie = () => {
    Z(T()), S({}), H(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: r,
      onClose: ie,
      className: pz.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: e, onClose: () => ie() }),
        /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: wk, onSubmit: Q, children: [
          y && /* @__PURE__ */ k.jsx(Fn, { error: y }),
          /* @__PURE__ */ k.jsxs(Et, { children: [
            /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
              ti,
              {
                required: !0,
                control: E,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
              ti,
              {
                required: !0,
                control: E,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 6, children: /* @__PURE__ */ k.jsx(
              ti,
              {
                control: E,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 6, children: /* @__PURE__ */ k.jsx(
              ti,
              {
                required: !0,
                control: E,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 6, children: /* @__PURE__ */ k.jsx(
              ti,
              {
                control: E,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
              ti,
              {
                required: !0,
                control: E,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 3, children: /* @__PURE__ */ k.jsx(
              ti,
              {
                required: !0,
                control: E,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 6, children: /* @__PURE__ */ k.jsx(
              _r,
              {
                name: "countryCodeV2",
                control: E,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (Y) => Y ? Nk(Y) : ""
                },
                children: jk.filter((Y) => s.includes(Y)).map((Y) => /* @__PURE__ */ k.jsx(ot.Item, { value: Y, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: Nk(Y) }) }, Y))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: wk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
            },
            confirmOnClick: () => {
              y && ie();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ie();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, hz = "_clickableIcon_33mqm_1", Du = {
  clickableIcon: hz
}, Ck = ({
  formFieldName: e,
  ...n
}) => {
  const r = Or(), { field: i } = Km({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    xm,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, xm = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: F, copy: S } = eo(), { track: N } = bn(), C = 14, y = o && (!!r || !!l), H = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), T = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), E = n?.countryCodeV2 && YS(n.countryCodeV2), D = tt(() => [
    T,
    n?.company,
    n?.address1,
    n?.address2,
    H,
    n?.province,
    E
  ].filter(Boolean).join(`
`), [n, T, H, E]);
  if (!n)
    return null;
  const U = () => {
    i && r && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: C, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Du.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  ue,
                  {
                    size: C,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            T && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: T }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            H && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: H }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            E && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(Ke, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: C,
            name: "pen",
            onClick: () => U(),
            className: Du.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: C,
            name: F ? "done" : "copy",
            onClick: () => S(D()),
            className: Du.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      fz,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, $p = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Or(), i = Xo({ control: r.control, name: "lineItems" }), a = Xo({
    control: r.control,
    name: "billingAddress"
  }), o = Xo({
    control: r.control,
    name: "shippingAddress"
  }), s = qn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = qn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        Ck,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        Ck,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, yz = "_productTableHeader_6h6pl_1", gz = "_productImage_6h6pl_5", Ha = {
  productTableHeader: yz,
  productImage: gz
}, Dp = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, vz = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Or(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Dp(e);
  return /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Bi,
        {
          src: d,
          alt: e.title,
          className: Ha.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
      Ft,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(Yt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, kz = 300, Ca = 2, bz = 25, _z = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = mn(), [i, a] = se(""), [o, s] = se([]), l = Or(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Ep, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (S) => {
      const N = S?.Shopify?.products?.nodes || [];
      s(
        N.filter((C) => !!C).sort((C, y) => C.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  yi(
    () => {
      i.trim().length >= Ca && !u && f === Gt.ready ? m({
        variables: {
          query: i.trim(),
          productCount: bz,
          mediaCount: 1
        }
      }) : i.trim().length < Ca && s([]);
    },
    kz,
    [i]
  ), qe(() => {
    if (!d) return;
    const S = o.find(
      (N) => N.id === d
    );
    S && e(S), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== Gt.ready, v = i.trim().length >= Ca, F = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    _r,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Ca} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (S) => {
          const N = o.find(
            (C) => C.id === S
          );
          return N ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (S) => {
            a(S.target.value);
          }
        },
        onToggleDropdown: (S) => {
          !S && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }) }),
        !h && o.map((S) => {
          const N = S.totalInventory <= 0, C = Dp(S);
          return /* @__PURE__ */ k.jsx(
            ot.Item,
            {
              value: S.id,
              isDisabled: N,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  C && /* @__PURE__ */ k.jsx(
                    Bi,
                    {
                      src: C,
                      alt: S.title,
                      className: Ha.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    u0,
                    {
                      text: S.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: S.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: N ? "Out of stock" : `${S.totalInventory} in stock` })
              ] })
            },
            S.id
          );
        }),
        F && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          cs,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          cs,
          {
            title: "Search for products",
            description: `Type at least ${Ca} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Rp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Or(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (N) => !o.includes(N?.id)
  ) : [], v = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), F = h.some(
    (N) => a.includes(N?.id)
  ) && !v, S = tt(
    (N) => {
      const C = m.getValues("lineItems"), y = C.findIndex(
        (H) => H?.id === N.id
      );
      if (y > -1) {
        const H = m.getValues(`lineItems.${y}.quantity`) || 0, T = [...C];
        T[y] = {
          ...T[y],
          quantity: H + 1
        }, m.setValue("lineItems", T);
      } else
        m.setValue("lineItems", [
          ...C,
          { ...N, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(_z, { onProductSelected: S }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: It.boxWrapper,
        children: /* @__PURE__ */ k.jsx(sn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: It.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          cs,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Xn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Ha.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Xn.Thead, { className: Ha.productTableHeader, children: /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Xn.Th, { children: /* @__PURE__ */ k.jsx(
              Gp,
              {
                checked: v,
                indeterminate: F,
                onChange: () => d?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(Xn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Xn.Tbody, { children: u?.map((N, C) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                vz,
                {
                  product: N,
                  index: C,
                  onRemove: () => {
                    const M = u.filter(
                      (O, q) => q !== C
                    );
                    m.setValue("lineItems", M);
                  }
                },
                `${N?.id}-${C}`
              );
            const y = N, H = y.priceRangeV2.minVariantPrice.amount, T = y.priceRangeV2.minVariantPrice.currencyCode, E = `lineItems.${C}.quantity`, D = m.watch(E) || 0, U = H * D, Z = Dp(y), Q = a.includes(y.id), ie = o.includes(y.id), Y = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Xn.Tr,
              {
                style: ie ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    Gp,
                    {
                      checked: Q,
                      disabled: ie,
                      onChange: () => l?.(y.id, !Q)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Z && /* @__PURE__ */ k.jsx(
                      Bi,
                      {
                        src: Z,
                        alt: y.title,
                        className: Ha.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.title }),
                      ie && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${H} ${T}` }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    Ft,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ie || Y <= 1,
                      name: E,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: Y,
                        tabIndex: 0
                      }
                    },
                    `${E}-${m.watch(E)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${U} ${T}` }) }),
                  !r && /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    Yt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const M = u.filter(
                          (O, q) => q !== C
                        );
                        m.setValue("lineItems", M), Q && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${C}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, Xx = ({
  previousOrderStatus: e
} = {}) => {
  const n = Or();
  return /* @__PURE__ */ k.jsx(
    _r,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = xk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: xk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(ot.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, Zx = () => {
  const e = Or();
  return /* @__PURE__ */ k.jsx(
    _r,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Sk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Sk.map((n) => /* @__PURE__ */ k.jsx(ot.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, xz = "_modal_1mprq_1", Sz = {
  modal: xz
}, Ru = "create-shopify-order-form", Nz = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Br.Pending,
    fulfillmentStatus: void 0
  }, [F, S] = se([]), N = tr({
    mode: "all",
    defaultValues: v
  }), C = N.watch("lineItems").length > 0, y = () => {
    N.reset(v), S([]), i(!1);
  };
  qe(() => {
    F.length > 0 && N.setValue("tags", F, { shouldDirty: !0 });
  }, [F, N]);
  const [H, { error: T }] = o(
    Yx,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [E, { error: D }] = o(
    TV,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), U = (Q) => {
    const ie = Q.lineItems.map((O) => ({
      productId: O.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: O.priceRangeV2.maxVariantPrice.amount,
          currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: O.quantity
    }));
    m(!0);
    const Y = $i(Q?.billingAddress), M = $i(
      Q?.shippingAddress
    );
    H({
      variables: {
        order: {
          lineItems: ie,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: M,
          billingAddress: Y
        }
      }
    });
  }, Z = (Q) => {
    const ie = Q.lineItems.map((O) => ({
      title: O.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: O.priceRangeV2.maxVariantPrice.amount,
        currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: O.quantity
    }));
    f(!0);
    const Y = $i(Q?.billingAddress), M = $i(
      Q?.shippingAddress
    );
    E({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: ie,
          shippingAddress: M,
          billingAddress: Y
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: y,
      className: Sz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(Bs, { ...N, children: /* @__PURE__ */ k.jsx("form", { id: Ru, children: /* @__PURE__ */ k.jsxs(Et, { children: [
            /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(Rp, {}) }),
            /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ k.jsx(
                  Pn,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ie) => {
                          ie.key === "Enter" && (ie.preventDefault(), ie.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ds,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: F,
                            onChange: (ie) => {
                              S(ie);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(Xx, {}),
              /* @__PURE__ */ k.jsx(Zx, {}),
              /* @__PURE__ */ k.jsx(
                Ft,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 2, children: /* @__PURE__ */ k.jsx(Pn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: It.boxWrapper,
                children: /* @__PURE__ */ k.jsx($p, {})
              }
            ) }) })
          ] }) }) }),
          (T || D) && /* @__PURE__ */ k.jsx(Fn, { error: T || D })
        ] }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              type: "submit",
              form: Ru,
              disabled: !C || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Ru,
                disabled: !C || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, jz = "_modal_al73g_1", wz = {
  modal: jz
}, Fk = [
  {
    label: "Customer",
    value: ai.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: ai.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: ai.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: ai.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: ai.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: ai.Staff,
    description: "Staff made an error."
  }
], Cz = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = bn(), { useMutation: d, showNotification: m } = mn(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, F = tr({
    defaultValues: v
  }), [S, { error: N, reset: C }] = d(CV, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (T) => {
      const E = T.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (E.length > 0)
        o(!1), f(E), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const D = T.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, D ? 0 : 4e3), m({
          title: "Success",
          text: `${D ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = tt(
    (T) => {
      T.reason != null && (o(!0), S({
        variables: {
          orderId: T.orderId,
          reason: T.reason,
          refundMethod: T.refundMethod,
          restock: T.restock,
          notifyCustomer: T.notifyCustomer,
          staffNote: T.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), H = () => {
    i(!1), C(), f([]), F.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: H, className: wz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Cancel order ${r}`, onClose: H }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Et, { children: [
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
        _r,
        {
          control: F.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (T, E) => T === E,
            getItemTitleByValue: (T) => {
              if (!T)
                return "";
              const E = Fk.find(
                (D) => D.value === T
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
              ] });
            }
          },
          children: Fk.map((T) => /* @__PURE__ */ k.jsx(ot.Item, { value: T.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: T.description })
          ] }) }, T.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(Pn, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Ma,
        {
          control: F.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(Pn, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Ma, { control: F.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(Pn, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Ma, { control: F.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
        Ft,
        {
          name: "staffNote",
          label: "Staff note",
          control: F.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map((T) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              T.field?.join(","),
              ") ",
              T.message
            ] })
          ]
        },
        T.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(F.formState.isValid && F.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
        },
        confirmOnClick: F.handleSubmit(y),
        cancelOnClick: H,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, Fz = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: It.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      Cz,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, Iz = "_modal_1mprq_1", Ez = {
  modal: Iz
}, Tz = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = mn(), { track: m } = bn(), [u, f] = se(!1), [h, v] = se(e?.tags || []), F = "duplicate-shopify-order-form", S = (M) => ({
    firstName: M?.firstName,
    lastName: M?.lastName,
    company: M?.company,
    address1: M?.address1,
    address2: M?.address2,
    city: M?.city,
    provinceCode: M?.provinceCode,
    zip: M?.zip,
    countryCode: M?.countryCodeV2,
    phone: M?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, C = tr({
    mode: "all",
    defaultValues: N
  }), y = C.watch("lineItems").length > 0, H = qn(
    () => (e?.lineItems || []).map((M) => M.product?.id).filter((M) => !!M),
    [e]
  ), T = qn(
    () => Qx(H),
    [H]
  ), {
    data: E,
    loading: D,
    error: U
  } = d(Ep, {
    skip: !T,
    variables: {
      query: T,
      productCount: H.length,
      mediaCount: 1
    }
  });
  qe(() => {
    U && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [U, l]), qe(() => {
    if (!r || D || !E || C.getValues("lineItems")?.length)
      return;
    const M = E?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = M.find(
        (ge) => ge.id === q.product?.id
      );
      ee && O.push({
        ...ee,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), O.length > 0 && C.setValue("lineItems", O, { shouldDirty: !0 });
  }, [r, E, D, e, C]), qe(() => {
    (h.length > 0 || (C.getValues("tags") || []).length > 0) && C.setValue("tags", h, { shouldDirty: !0 });
  }, [h, C]);
  const [Z, { error: Q }] = s(
    Yx,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Y();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Y();
      }
    }
  ), ie = (M) => {
    const O = M.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), q = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Z({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: O,
          shippingLines: q,
          note: M.customNote,
          tags: M.tags,
          financialStatus: M.financialStatus,
          fulfillmentStatus: M.fulfillmentStatus,
          shippingAddress: $i(M?.shippingAddress),
          billingAddress: $i(M?.billingAddress)
        }
      }
    });
  }, Y = () => {
    C.reset(N), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: r,
      onClose: Y,
      className: Ez.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: `Duplicate order ${n}`, onClose: Y }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(Bs, { ...C, children: /* @__PURE__ */ k.jsx("form", { id: F, children: /* @__PURE__ */ k.jsxs(Et, { children: [
            /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(Rp, { loading: D }) }),
            /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: M } }) => /* @__PURE__ */ k.jsx(
                  Pn,
                  {
                    label: "Tags",
                    meta: {
                      error: M?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (O) => {
                          O.key === "Enter" && (O.preventDefault(), O.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ds,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (O) => {
                              v(O);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                Xx,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(Zx, {}),
              /* @__PURE__ */ k.jsx(
                Ft,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(Qe, { span: 2, children: /* @__PURE__ */ k.jsx(Pn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: It.boxWrapper,
                children: /* @__PURE__ */ k.jsx($p, {})
              }
            ) }) })
          ] }) }) }),
          Q && /* @__PURE__ */ k.jsx(Fn, { error: Q })
        ] }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              type: "submit",
              form: F,
              disabled: !y || u || D,
              isLoading: u || D,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: C.handleSubmit(ie)
          }
        )
      ]
    }
  );
}, $z = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(ue, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(An, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(We, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ k.jsx(Bi, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, Dz = Rs`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, Rz = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, eS = (e) => {
  const n = {}, r = Rz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, Oz = "_modal_21e62_1", Pz = {
  modal: Oz
}, Ik = "partial-refund-shopify-order-form", Az = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), { useQuery: d } = mn(), [m, u] = se(!1), [f, h] = se([]), v = qn(
    () => e?.refunds ? eS(e) : {},
    [e]
  ), F = qn(
    () => (e?.lineItems || []).filter((M) => (v[M.id] || 0) >= (M.quantity || 0)).map((M) => M.product?.id).filter((M) => !!M),
    [e, v]
  ), S = qn(() => {
    const M = {};
    return (e?.lineItems || []).forEach((O) => {
      if (O.product?.id) {
        const q = v[O.id] || 0, ee = Math.max(
          0,
          (O.quantity || 0) - q
        );
        M[O.product.id] = ee;
      }
    }), M;
  }, [e, v]), N = qn(
    () => (e?.lineItems || []).map((M) => M.product?.id).filter((M) => !!M),
    [e]
  ), C = qn(
    () => Qx(N),
    [N]
  ), {
    data: y,
    loading: H,
    error: T
  } = d(Ep, {
    skip: !C,
    variables: {
      query: C,
      productCount: N.length,
      mediaCount: 1
    }
  });
  qe(() => {
    T && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [T, s]);
  const E = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, D = tr({
    mode: "all",
    defaultValues: E
  }), U = f.length > 0, [Z, { error: Q }] = o(
    Dz,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), Y();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), Y();
      }
    }
  );
  qe(() => {
    if (!r || H || !y || D.getValues("lineItems")?.length)
      return;
    const M = y?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = M.find(
        (ge) => ge.id === q.product?.id
      );
      if (ee) {
        const ge = v[q.id] || 0, de = (q.quantity || 1) - ge;
        O.push({
          ...ee,
          quantity: de > 0 ? de : q.quantity || 1
        });
      }
    }), O.length > 0 && (D.setValue("lineItems", O, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    H,
    e,
    D,
    v
  ]);
  const ie = (M) => {
    u(!0);
    const O = (M.lineItems || []).filter(
      (q) => f.includes(q.id)
    ).map((q) => {
      const ee = e?.lineItems?.find(
        (pe) => pe.product?.id === q.id
      ), ge = v[ee?.id || ""] || 0, de = (ee?.quantity || 0) - ge, le = Math.max(
        0,
        Math.min(de, q.quantity || 0)
      );
      return ee && le > 0 ? { lineItemId: ee.id, quantity: le } : void 0;
    }).filter((q) => !!q);
    Z({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: O,
          note: M.customNote || void 0,
          notify: !0
        }
      }
    });
  }, Y = () => {
    D.reset(E), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: r, onClose: Y, className: Pz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Refund order ${n}`, onClose: Y }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(Bs, { ...D, children: /* @__PURE__ */ k.jsx("form", { id: Ik, children: /* @__PURE__ */ k.jsxs(Et, { children: [
        /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
          Rp,
          {
            loading: H,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: F,
            maxQuantities: S,
            onToggleSelect: (M, O) => {
              h((q) => O ? Array.from(/* @__PURE__ */ new Set([...q, M])) : q.filter((ee) => ee !== M));
            },
            onToggleSelectAll: (M) => {
              const O = (D.getValues("lineItems") || []).map((q) => q.id).filter((q) => !F.includes(q));
              h(M ? O : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(Qe, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Ft,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(Qe, { span: 2, children: /* @__PURE__ */ k.jsx(Pn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: It.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              $p,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      Q && /* @__PURE__ */ k.jsx(Fn, { error: Q })
    ] }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          type: "submit",
          form: Ik,
          disabled: !U || m || H,
          isLoading: m || H,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: D.handleSubmit(ie)
      }
    )
  ] });
}, Lz = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = mn(), { track: l } = bn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), v = !isNaN(h) && h > 0, [F] = a(wV, {
    onError: (C) => {
      setTimeout(() => N(C), 500);
    },
    onCompleted: (C) => {
      const y = C.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? N(
        new v0({
          graphQLErrors: y.map((H) => ({
            message: H.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), S = tt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: C, ...y } = d;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        C,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), F({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    v,
    s,
    F,
    l
  ]), N = tt(
    (C) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Fn, { error: C }),
          /* @__PURE__ */ k.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Kn,
    {
      variant: "secondary",
      onClick: S,
      disabled: d?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "undo" }),
      className: It.fullWidth,
      children: "Full refund"
    }
  ) });
}, Vz = "_modal_al73g_1", zz = {
  modal: Vz
}, Uz = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = bn(), { useMutation: s, showNotification: l } = mn(), [d, m] = se(n), [u, f] = se(!1), h = tr({
    defaultValues: {
      tags: n
    }
  });
  qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: F, reset: S }] = s(FV, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = tt(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((H) => {
        const T = H.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: T });
      });
    },
    [e, h, v]
  ), C = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: r, onClose: C, className: zz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Manage tags for order", onClose: C }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(Et, { children: /* @__PURE__ */ k.jsx(Qe, { children: /* @__PURE__ */ k.jsx(
        zt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            Pn,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Ds,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (H) => m(H)
                }
              )
            }
          )
        }
      ) }) }),
      F && /* @__PURE__ */ k.jsx(Fn, { error: F })
    ] }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: C,
        confirmName: F ? "Close" : "Save",
        cancelName: F ? void 0 : "Cancel"
      }
    )
  ] });
}, Mz = "_editIcon_1dntr_1", Bz = {
  editIcon: Mz
}, qz = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Ke, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: o,
          name: "pen",
          className: Bz.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      Uz,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, Hz = "_icon_cddi1_1", Wz = "_link_cddi1_6", Ek = {
  icon: Hz,
  link: Wz
}, Kz = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = eo(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Ek.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Ek.icon
        }
      ) })
    }
  );
}, Gz = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(ue, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(We, { children: e.map((n) => /* @__PURE__ */ k.jsx(Kz, { trackingInfo: n }, n.number)) })
] }), Yz = "_order_135ze_1", Jz = "_orderIsOpen_135ze_9", Qz = "_orderHeader_135ze_12", Ou = {
  order: Yz,
  orderIsOpen: Jz,
  orderHeader: Qz
}, Xz = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = bn(), [h, v] = se(!1), [F, S] = se(!1), [N, C] = se(r), {
    id: y,
    name: H,
    createdAt: T,
    status: E,
    currentTotalPriceSet: D,
    currencyCode: U,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: ie,
    trackingInfos: Y,
    tags: M
  } = e, O = !!ie, q = Tp(y), ee = `https://${l}/admin/orders/${q ?? ""}`, ge = D?.shopMoney?.amount ?? 0, de = E.includes("cancelled"), le = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: U
  }).format(ge), pe = e?.refunds ? eS(e) : {}, W = !!Z?.length && Z.every((be) => (pe[be.id] || 0) >= (be.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: ut(Ou.order, {
        [Ou.orderIsOpen]: N
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ou.orderHeader,
            onClick: () => C(!N),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                T && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(_m) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  H
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: N ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        N && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: le })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            qz,
            {
              orderId: y,
              tags: M,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            xm,
            {
              openByDefault: !O,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            xm,
            {
              openByDefault: O,
              shopifyId: n,
              orderId: y,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ie,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            $z,
            {
              orderId: y,
              lineItems: Z,
              refundedQuantities: pe
            }
          ),
          /* @__PURE__ */ k.jsx(Gz, { trackingInfos: Y }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              Lz,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: ee
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => S(!0),
                className: It.fullWidth,
                disabled: de || W,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: It.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              Fz,
              {
                orderId: y,
                orderName: H,
                disabled: de,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ee, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: y
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          Tz,
          {
            order: e,
            shopifyId: n,
            orderName: H,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: u
          }
        ),
        F && /* @__PURE__ */ k.jsx(
          Az,
          {
            order: e,
            orderName: H,
            isOpen: F,
            setIsOpen: S,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, Zz = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = bn(), [f, h] = se([]), [v, F] = se(!1), S = Tp(m?.id), N = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: C,
    isCustomerOrdersLoading: y,
    customerOrdersError: H,
    customerOrders: T,
    refetchCustomerOrders: E
  } = DV();
  return qe(() => {
    !y && S && C({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), qe(() => {
    const D = T?.Shopify?.orders?.edges;
    D && h(cz({ ordersData: D }));
  }, [T]), m ? H ? /* @__PURE__ */ k.jsx(Fn, { error: H }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => F(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((D, U) => /* @__PURE__ */ k.jsx(
        Xz,
        {
          order: D,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: E,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${D.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        St,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Nz,
      {
        isOpen: v,
        setIsOpen: F,
        shopifyCustomer: m,
        refetchCustomerOrders: E,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, e3 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(We, { className: It.list, children: [
      /* @__PURE__ */ k.jsx(We.Text, { variant: "dense", className: It.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { variant: "dense", className: It.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, n3 = "_segmentName_1dkhk_1", t3 = {
  segmentName: n3
}, r3 = 100, Uo = 10, i3 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = mn(), [i, a] = se([]), [o, s] = se(Uo), [l, d] = se(!1), m = qn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    xV,
    {
      skip: !e,
      variables: {
        first: r3
      },
      onCompleted: (S) => {
        const N = S?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const C = N.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, H) => y.name.localeCompare(H.name));
          a(C), h({
            variables: {
              customerId: e,
              segmentIds: C.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: F }
  ] = r(SV, {
    onCompleted: (S) => {
      const N = S?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const C = i.map((y) => {
          const H = N.find(
            (T) => T.segmentId === y.id
          );
          return {
            ...y,
            ...H?.isMember && { isMember: H.isMember }
          };
        }).sort(
          (y, H) => y.isMember === H.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(C);
      }
    }
  });
  return qe(() => {
    s(l ? i.length : Uo);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Fn, { error: f }),
    F && /* @__PURE__ */ k.jsx(Fn, { error: F }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(We, { className: It.list, children: [
      i.slice(0, o).map(({ id: S, name: N, isMember: C }) => /* @__PURE__ */ k.jsx(We.Text, { className: It.listItem, children: /* @__PURE__ */ k.jsx(
        Ke,
        {
          content: `${C ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: t3.segmentName, children: N }),
            v && /* @__PURE__ */ k.jsx(sn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              ue,
              {
                color: C ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > Uo && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Kn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Uo} more`
        }
      ) })
    ] })
  ] }) : null;
}, a3 = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = $V({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, F = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, N = n.displayOrdersOverview ?? !1, C = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, H = n.displayDiscountCodes ?? !1, T = n.displayCreateOrder ?? !1, E = n.displayDuplicateOrder ?? !1, D = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (qe(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Z)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(Fn, { error: i, retry: o });
  if (!r && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              UV,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              St,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== Gt.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(sn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          qV,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        N && /* @__PURE__ */ k.jsx(
          e3,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        C && /* @__PURE__ */ k.jsx(i3, { shopifyId: l?.id }),
        S && /* @__PURE__ */ k.jsx(lz, { customer: l }),
        H && /* @__PURE__ */ k.jsx(
          sz,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          Zz,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: T,
            displayCreateDraftOrder: D,
            enableEditShippingAddress: F,
            customerCountryCodes: m,
            displayDuplicateOrder: E,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, kt = [];
for (let e = 0; e < 256; ++e)
  kt.push((e + 256).toString(16).slice(1));
function o3(e, n = 0) {
  return (kt[e[n + 0]] + kt[e[n + 1]] + kt[e[n + 2]] + kt[e[n + 3]] + "-" + kt[e[n + 4]] + kt[e[n + 5]] + "-" + kt[e[n + 6]] + kt[e[n + 7]] + "-" + kt[e[n + 8]] + kt[e[n + 9]] + "-" + kt[e[n + 10]] + kt[e[n + 11]] + kt[e[n + 12]] + kt[e[n + 13]] + kt[e[n + 14]] + kt[e[n + 15]]).toLowerCase();
}
let Pu;
const s3 = new Uint8Array(16);
function l3() {
  if (!Pu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Pu = crypto.getRandomValues.bind(crypto);
  }
  return Pu(s3);
}
const c3 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Tk = { randomUUID: c3 };
function d3(e, n, r) {
  if (Tk.randomUUID && !e)
    return Tk.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? l3();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, o3(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Au = { exports: {} }, Fa = {}, $k;
function u3() {
  if ($k) return Fa;
  $k = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Fa.Fragment = r, Fa.jsx = s, Fa.jsxs = s, Fa;
}
var Mo = {}, Dk;
function m3() {
  return Dk || (Dk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Mo.Fragment = i, Mo.jsx = Rn, Mo.jsxs = Bn;
  })()), Mo;
}
var Rk;
function p3() {
  return Rk || (Rk = 1, process.env.NODE_ENV === "production" ? Au.exports = u3() : Au.exports = m3()), Au.exports;
}
var B = p3(), nS = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(nS || {}), Sm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Sm || {});
const f3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, h3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, y3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, g3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, v3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, k3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, b3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, _3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, x3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, S3 = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": f3,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": h3,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": y3,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": g3,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": v3,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": k3,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": b3,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": _3,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": x3
};
function Wr(e) {
  return S3[e] ?? {};
}
const N3 = Wr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), j3 = Wr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), w3 = Wr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), C3 = Wr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), F3 = Wr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), I3 = Wr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), E3 = Wr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), T3 = Wr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), $3 = Wr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), D3 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = bn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(N3, {
    skip: !e,
    variables: { contactId: e }
  });
  return qe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (F) => F !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), qn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function os(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const R3 = {
  count: 0,
  items: []
}, O3 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = bn(), [i, a] = se(R3), {
    loading: o,
    error: s,
    data: l
  } = n(C3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, P3 = {
  count: 0,
  totalCount: 0,
  items: []
}, A3 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = bn(), [i, a] = se(
    P3
  ), {
    loading: o,
    error: s,
    data: l
  } = n(F3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, L3 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(w3, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, V3 = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(j3, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), qn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, z3 = "_pointer_ls8kj_48", U3 = "_list_ls8kj_53", M3 = "_listItem_ls8kj_63", nt = {
  pointer: z3,
  list: U3,
  listItem: M3
};
var ho = (e) => e.type === "checkbox", li = (e) => e instanceof Date, Lt = (e) => e == null;
const tS = (e) => typeof e == "object";
var lt = (e) => !Lt(e) && !Array.isArray(e) && tS(e) && !li(e), rS = (e) => lt(e) && e.target ? ho(e.target) ? e.target.checked : e.target.value : e, B3 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, iS = (e, n) => e.has(B3(n)), q3 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return lt(n) && n.hasOwnProperty("isPrototypeOf");
}, Op = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function _t(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Op && (e instanceof Blob || i)) && (r || lt(e)))
    if (n = r ? [] : {}, !r && !q3(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = _t(e[a]));
  else
    return e;
  return n;
}
var el = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Ye = (e, n, r) => {
  if (!n || !lt(e))
    return r;
  const i = el(n.split(/[,[\].]+?/)).reduce((a, o) => Lt(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? r : e[n] : i;
}, Xt = (e) => typeof e == "boolean", Pp = (e) => /^\w*$/.test(e), aS = (e) => el(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Pp(n) ? [n] : aS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = lt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Ns = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, yr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, H3 = Ne.createContext(null), Ap = () => Ne.useContext(H3);
var oS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== yr.all && (n._proxyFormState[s] = !i || yr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function W3(e) {
  const n = Ap(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ne.useState(r._formState), d = Ne.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Ne.useRef(a);
  return m.current = a, Ne.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Ne.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Ne.useMemo(() => oS(s, r, d.current, !1), [s, r]);
}
var Tr = (e) => typeof e == "string", sS = (e, n, r, i, a) => Tr(e) ? (i && n.watch.add(e), Ye(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(r, o))) : (i && (n.watchAll = !0), r);
function lS(e) {
  const n = Ap(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ne.useRef(i), d = Ne.useRef(a);
  l.current = i, Ne.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(sS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Ne.useState(r._getWatch(i, a));
  return Ne.useEffect(() => r._removeUnmounted()), m;
}
function K3(e) {
  const n = Ap(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = iS(a._names.array, r), l = lS({
    control: a,
    name: r,
    defaultValue: Ye(a._formValues, r, Ye(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = W3({
    control: a,
    name: r,
    exact: !0
  }), m = Ne.useRef(e), u = Ne.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Xt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ne.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ye(d.errors, r)
    }
  }), [d, r]), h = Ne.useCallback((N) => u.current.onChange({
    target: {
      value: rS(N),
      name: r
    },
    type: Ns.CHANGE
  }), [r]), v = Ne.useCallback(() => u.current.onBlur({
    target: {
      value: Ye(a._formValues, r),
      name: r
    },
    type: Ns.BLUR
  }), [r, a._formValues]), F = Ne.useCallback((N) => {
    const C = Ye(a._fields, r);
    C && N && (C._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Ne.useMemo(() => ({
    name: r,
    value: l,
    ...Xt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: F
  }), [r, i, d.disabled, h, v, F, l]);
  return Ne.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Xt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const C = (y, H) => {
      const T = Ye(a._fields, y);
      T && T._f && (T._f.mount = H);
    };
    if (C(r, !0), N) {
      const y = _t(Ye(a._options.defaultValues, r));
      Yn(a._defaultValues, r, y), it(Ye(a._formValues, r)) && Yn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Ne.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ne.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Ok = (e) => e.render(K3(e));
var G3 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Wa = (e) => Array.isArray(e) ? e : [e], Pk = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Nm = (e) => Lt(e) || !tS(e);
function Qr(e, n) {
  if (Nm(e) || Nm(n))
    return e === n;
  if (li(e) && li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (li(o) && li(s) || lt(o) && lt(s) || Array.isArray(o) && Array.isArray(s) ? !Qr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ot = (e) => lt(e) && !Object.keys(e).length, Lp = (e) => e.type === "file", gr = (e) => typeof e == "function", js = (e) => {
  if (!Op)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, cS = (e) => e.type === "select-multiple", Vp = (e) => e.type === "radio", Y3 = (e) => Vp(e) || ho(e), Lu = (e) => js(e) && e.isConnected;
function J3(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function Q3(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : Pp(n) ? [n] : aS(n), i = r.length === 1 ? e : J3(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (lt(i) && Ot(i) || Array.isArray(i) && Q3(i)) && ht(e, r.slice(0, -1)), e;
}
var dS = (e) => {
  for (const n in e)
    if (gr(e[n]))
      return !0;
  return !1;
};
function ws(e, n = {}) {
  const r = Array.isArray(e);
  if (lt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || lt(e[i]) && !dS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ws(e[i], n[i])) : Lt(e[i]) || (n[i] = !0);
  return n;
}
function uS(e, n, r) {
  const i = Array.isArray(e);
  if (lt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || lt(e[a]) && !dS(e[a]) ? it(n) || Nm(r[a]) ? r[a] = Array.isArray(e[a]) ? ws(e[a], []) : { ...ws(e[a]) } : uS(e[a], Lt(n) ? {} : n[a], r[a]) : r[a] = !Qr(e[a], n[a]);
  return r;
}
var Ia = (e, n) => uS(e, n, ws(n));
const Ak = {
  value: !1,
  isValid: !1
}, Lk = { value: !0, isValid: !0 };
var mS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? Lk : { value: e[0].value, isValid: !0 } : Lk
    ) : Ak;
  }
  return Ak;
}, pS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : r && Tr(e) ? new Date(e) : i ? i(e) : e;
const Vk = {
  isValid: !1,
  value: null
};
var fS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Vk) : Vk;
function zk(e) {
  const n = e.ref;
  return Lp(n) ? n.files : Vp(n) ? fS(e.refs).value : cS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : ho(n) ? mS(e.refs).value : pS(it(n.value) ? e.ref.value : n.value, e);
}
var X3 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Cs = (e) => e instanceof RegExp, Ea = (e) => it(e) ? e : Cs(e) ? e.source : lt(e) ? Cs(e.value) ? e.value.source : e.value : e, Uk = (e) => ({
  isOnSubmit: !e || e === yr.onSubmit,
  isOnBlur: e === yr.onBlur,
  isOnChange: e === yr.onChange,
  isOnAll: e === yr.all,
  isOnTouch: e === yr.onTouched
});
const Mk = "AsyncFunction";
var Z3 = (e) => !!e && !!e.validate && !!(gr(e.validate) && e.validate.constructor.name === Mk || lt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Mk)), eU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Bk = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ka = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ka(l, n))
          break;
      } else if (lt(l) && Ka(l, n))
        break;
    }
  }
};
function qk(e, n, r) {
  const i = Ye(e, r);
  if (i || Pp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var nU = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Ot(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || yr.all));
}, tU = (e, n, r) => !e || !n || e === n || Wa(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), rU = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, iU = (e, n) => !el(Ye(e, n)).length && ht(e, n), aU = (e, n, r) => {
  const i = Wa(Ye(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, ss = (e) => Tr(e);
function Hk(e, n, r = "validate") {
  if (ss(e) || Array.isArray(e) && e.every(ss) || Xt(e) && !e)
    return {
      type: r,
      message: ss(e) ? e : "",
      ref: n
    };
}
var Fi = (e) => lt(e) && !Cs(e) ? e : {
  value: e,
  message: ""
}, Wk = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: F, name: S, valueAsNumber: N, mount: C } = e._f, y = Ye(r, S);
  if (!C || n.has(S))
    return {};
  const H = l ? l[0] : s, T = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Xt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, D = Vp(s), U = ho(s), Z = D || U, Q = (N || Lp(s)) && it(s.value) && it(y) || js(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = G3.bind(null, S, i, E), Y = (M, O, q, ee = Ur.maxLength, ge = Ur.minLength) => {
    const de = M ? O : q;
    E[S] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || Lt(y)) || Xt(y) && !y || U && !mS(l).isValid || D && !fS(l).isValid)) {
    const { value: M, message: O } = ss(d) ? { value: !!d, message: d } : Fi(d);
    if (M && (E[S] = {
      type: Ur.required,
      message: O,
      ref: H,
      ...ie(Ur.required, O)
    }, !i))
      return T(O), E;
  }
  if (!Q && (!Lt(f) || !Lt(h))) {
    let M, O;
    const q = Fi(h), ee = Fi(f);
    if (!Lt(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      Lt(q.value) || (M = ge > q.value), Lt(ee.value) || (O = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Tr(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), Tr(ee.value) && y && (O = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || O) && (Y(!!M, q.message, ee.message, Ur.max, Ur.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !Q && (Tr(y) || o && Array.isArray(y))) {
    const M = Fi(m), O = Fi(u), q = !Lt(M.value) && y.length > +M.value, ee = !Lt(O.value) && y.length < +O.value;
    if ((q || ee) && (Y(q, M.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !Q && Tr(y)) {
    const { value: M, message: O } = Fi(v);
    if (Cs(M) && !y.match(M) && (E[S] = {
      type: Ur.pattern,
      message: O,
      ref: s,
      ...ie(Ur.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (F) {
    if (gr(F)) {
      const M = await F(y, r), O = Hk(M, H);
      if (O && (E[S] = {
        ...O,
        ...ie(Ur.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (lt(F)) {
      let M = {};
      for (const O in F) {
        if (!Ot(M) && !i)
          break;
        const q = Hk(await F[O](y, r), H, O);
        q && (M = {
          ...q,
          ...ie(O, q.message)
        }, T(q.message), i && (E[S] = M));
      }
      if (!Ot(M) && (E[S] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const oU = {
  mode: yr.onSubmit,
  reValidateMode: yr.onChange,
  shouldFocusError: !0
};
function sU(e = {}) {
  let n = {
    ...oU,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: gr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = lt(n.defaultValues) || lt(n.values) ? _t(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : _t(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Pk(),
    state: Pk()
  }, v = Uk(n.mode), F = Uk(n.reValidateMode), S = n.criteriaMode === yr.all, N = (w) => (_) => {
    clearTimeout(m), m = setTimeout(w, _);
  }, C = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const _ = n.resolver ? Ot((await Q()).errors) : await Y(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (w, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach(($) => {
      $ && (_ ? Yn(r.validatingFields, $, _) : ht(r.validatingFields, $));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Ot(r.validatingFields)
    }));
  }, H = (w, _ = [], $, G, J = !0, R = !0) => {
    if (G && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Ye(i, w))) {
        const z = $(Ye(i, w), G.argA, G.argB);
        J && Yn(i, w, z);
      }
      if (R && Array.isArray(Ye(r.errors, w))) {
        const z = $(Ye(r.errors, w), G.argA, G.argB);
        J && Yn(r.errors, w, z), iU(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Ye(r.touchedFields, w))) {
        const z = $(Ye(r.touchedFields, w), G.argA, G.argB);
        J && Yn(r.touchedFields, w, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ia(a, o)), h.state.next({
        name: w,
        isDirty: O(w, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, w, _);
  }, T = (w, _) => {
    Yn(r.errors, w, _), h.state.next({
      errors: r.errors
    });
  }, E = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (w, _, $, G) => {
    const J = Ye(i, w);
    if (J) {
      const R = Ye(o, w, it($) ? Ye(a, w) : $);
      it(R) || G && G.defaultChecked || _ ? Yn(o, w, _ ? R : zk(J._f)) : ge(w, R), s.mount && C();
    }
  }, U = (w, _, $, G, J) => {
    let R = !1, z = !1;
    const re = {
      name: w
    };
    if (!n.disabled) {
      if (!$ || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = re.isDirty = O(), R = z !== re.isDirty);
        const fe = Qr(Ye(a, w), _);
        z = !!Ye(r.dirtyFields, w), fe ? ht(r.dirtyFields, w) : Yn(r.dirtyFields, w, !0), re.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && z !== !fe;
      }
      if ($) {
        const fe = Ye(r.touchedFields, w);
        fe || (Yn(r.touchedFields, w, $), re.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && fe !== $);
      }
      R && J && h.state.next(re);
    }
    return R ? re : {};
  }, Z = (w, _, $, G) => {
    const J = Ye(r.errors, w), R = (u.isValid || f.isValid) && Xt(_) && r.isValid !== _;
    if (n.delayError && $ ? (d = N(() => T(w, $)), d(n.delayError)) : (clearTimeout(m), d = null, $ ? Yn(r.errors, w, $) : ht(r.errors, w)), ($ ? !Qr(J, $) : J) || !Ot(G) || R) {
      const z = {
        ...G,
        ...R && Xt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, Q = async (w) => {
    y(w, !0);
    const _ = await n.resolver(o, n.context, X3(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(w), _;
  }, ie = async (w) => {
    const { errors: _ } = await Q(w);
    if (w)
      for (const $ of w) {
        const G = Ye(_, $);
        G ? Yn(r.errors, $, G) : ht(r.errors, $);
      }
    else
      r.errors = _;
    return _;
  }, Y = async (w, _, $ = {
    valid: !0
  }) => {
    for (const G in w) {
      const J = w[G];
      if (J) {
        const { _f: R, ...z } = J;
        if (R) {
          const re = l.array.has(R.name), fe = J._f && Z3(J._f);
          fe && u.validatingFields && y([G], !0);
          const _e = await Wk(J, l.disabled, o, S, n.shouldUseNativeValidation && !_, re);
          if (fe && u.validatingFields && y([G]), _e[R.name] && ($.valid = !1, _))
            break;
          !_ && (Ye(_e, R.name) ? re ? aU(r.errors, _e, R.name) : Yn(r.errors, R.name, _e[R.name]) : ht(r.errors, R.name));
        }
        !Ot(z) && await Y(z, _, $);
      }
    }
    return $.valid;
  }, M = () => {
    for (const w of l.unMount) {
      const _ = Ye(i, w);
      _ && (_._f.refs ? _._f.refs.every(($) => !Lu($)) : !Lu(_._f.ref)) && Ae(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (w, _) => !n.disabled && (w && _ && Yn(o, w, _), !Qr(Fe(), a)), q = (w, _, $) => sS(w, l, {
    ...s.mount ? o : it(_) ? a : Tr(w) ? { [w]: _ } : _
  }, $, _), ee = (w) => el(Ye(s.mount ? o : a, w, n.shouldUnregister ? Ye(a, w, []) : [])), ge = (w, _, $ = {}) => {
    const G = Ye(i, w);
    let J = _;
    if (G) {
      const R = G._f;
      R && (!R.disabled && Yn(o, w, pS(_, R)), J = js(R.ref) && Lt(_) ? "" : _, cS(R.ref) ? [...R.ref.options].forEach((z) => z.selected = J.includes(z.value)) : R.refs ? ho(R.ref) ? R.refs.length > 1 ? R.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(J) ? !!J.find((re) => re === z.value) : J === z.value)) : R.refs[0] && (R.refs[0].checked = !!J) : R.refs.forEach((z) => z.checked = z.value === J) : Lp(R.ref) ? R.ref.value = "" : (R.ref.value = J, R.ref.type || h.state.next({
        name: w,
        values: _t(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && U(w, J, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && be(w);
  }, de = (w, _, $) => {
    for (const G in _) {
      const J = _[G], R = `${w}.${G}`, z = Ye(i, R);
      (l.array.has(w) || lt(J) || z && !z._f) && !li(J) ? de(R, J, $) : ge(R, J, $);
    }
  }, le = (w, _, $ = {}) => {
    const G = Ye(i, w), J = l.array.has(w), R = _t(_);
    Yn(o, w, R), J ? (h.array.next({
      name: w,
      values: _t(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: w,
      dirtyFields: Ia(a, o),
      isDirty: O(w, R)
    })) : G && !G._f && !Lt(R) ? de(w, R, $) : ge(w, R, $), Bk(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: _t(o)
    });
  }, pe = async (w) => {
    s.mount = !0;
    const _ = w.target;
    let $ = _.name, G = !0;
    const J = Ye(i, $), R = (z) => {
      G = Number.isNaN(z) || li(z) && isNaN(z.getTime()) || Qr(z, Ye(o, $, z));
    };
    if (J) {
      let z, re;
      const fe = _.type ? zk(J._f) : rS(w), _e = w.type === Ns.BLUR || w.type === Ns.FOCUS_OUT, en = !eU(J._f) && !n.resolver && !Ye(r.errors, $) && !J._f.deps || rU(_e, Ye(r.touchedFields, $), r.isSubmitted, F, v), un = Bk($, l, _e);
      Yn(o, $, fe), _e ? (J._f.onBlur && J._f.onBlur(w), d && d(0)) : J._f.onChange && J._f.onChange(w);
      const rn = U($, fe, _e), dn = !Ot(rn) || un;
      if (!_e && h.state.next({
        name: $,
        type: w.type,
        values: _t(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && C() : _e || C()), dn && h.state.next({ name: $, ...un ? {} : rn });
      if (!_e && un && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([$]);
        if (R(fe), G) {
          const cn = qk(r.errors, i, $), kn = qk(pn, i, cn.name || $);
          z = kn.error, $ = kn.name, re = Ot(pn);
        }
      } else
        y([$], !0), z = (await Wk(J, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(fe), G && (z ? re = !1 : (u.isValid || f.isValid) && (re = await Y(i, !0)));
      G && (J._f.deps && be(J._f.deps), Z($, re, z, rn));
    }
  }, W = (w, _) => {
    if (Ye(r.errors, _) && w.focus)
      return w.focus(), 1;
  }, be = async (w, _ = {}) => {
    let $, G;
    const J = Wa(w);
    if (n.resolver) {
      const R = await ie(it(w) ? w : J);
      $ = Ot(R), G = w ? !J.some((z) => Ye(R, z)) : $;
    } else w ? (G = (await Promise.all(J.map(async (R) => {
      const z = Ye(i, R);
      return await Y(z && z._f ? { [R]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && C()) : G = $ = await Y(i);
    return h.state.next({
      ...!Tr(w) || (u.isValid || f.isValid) && $ !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: $ } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Ka(i, W, w ? J : l.mount), G;
  }, Fe = (w) => {
    const _ = {
      ...s.mount ? o : a
    };
    return it(w) ? _ : Tr(w) ? Ye(_, w) : w.map(($) => Ye(_, $));
  }, K = (w, _) => ({
    invalid: !!Ye((_ || r).errors, w),
    isDirty: !!Ye((_ || r).dirtyFields, w),
    error: Ye((_ || r).errors, w),
    isValidating: !!Ye(r.validatingFields, w),
    isTouched: !!Ye((_ || r).touchedFields, w)
  }), Be = (w) => {
    w && Wa(w).forEach((_) => ht(r.errors, _)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Me = (w, _, $) => {
    const G = (Ye(i, w, { _f: {} })._f || {}).ref, J = Ye(r.errors, w) || {}, { ref: R, message: z, type: re, ...fe } = J;
    Yn(r.errors, w, {
      ...fe,
      ..._,
      ref: G
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), $ && $.shouldFocus && G && G.focus && G.focus();
  }, Pe = (w, _) => gr(w) ? h.state.subscribe({
    next: ($) => w(q(void 0, _), $)
  }) : q(w, _, !0), Ue = (w) => h.state.subscribe({
    next: (_) => {
      tU(w.name, _.name, w.exact) && nU(_, w.formState || u, Re, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, we = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Ue({
    ...w,
    formState: f
  })), Ae = (w, _ = {}) => {
    for (const $ of w ? Wa(w) : l.mount)
      l.mount.delete($), l.array.delete($), _.keepValue || (ht(i, $), ht(o, $)), !_.keepError && ht(r.errors, $), !_.keepDirty && ht(r.dirtyFields, $), !_.keepTouched && ht(r.touchedFields, $), !_.keepIsValidating && ht(r.validatingFields, $), !n.shouldUnregister && !_.keepDefaultValue && ht(a, $);
    h.state.next({
      values: _t(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: O() } : {}
    }), !_.keepIsValid && C();
  }, $e = ({ disabled: w, name: _ }) => {
    (Xt(w) && s.mount || w || l.disabled.has(_)) && (w ? l.disabled.add(_) : l.disabled.delete(_));
  }, tn = (w, _ = {}) => {
    let $ = Ye(i, w);
    const G = Xt(_.disabled) || Xt(n.disabled);
    return Yn(i, w, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ..._
      }
    }), l.mount.add(w), $ ? $e({
      disabled: Xt(_.disabled) ? _.disabled : n.disabled,
      name: w
    }) : D(w, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ea(_.min),
        max: Ea(_.max),
        minLength: Ea(_.minLength),
        maxLength: Ea(_.maxLength),
        pattern: Ea(_.pattern)
      } : {},
      name: w,
      onChange: pe,
      onBlur: pe,
      ref: (J) => {
        if (J) {
          tn(w, _), $ = Ye(i, w);
          const R = it(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, z = Y3(R), re = $._f.refs || [];
          if (z ? re.find((fe) => fe === R) : R === $._f.ref)
            return;
          Yn(i, w, {
            _f: {
              ...$._f,
              ...z ? {
                refs: [
                  ...re.filter(Lu),
                  R,
                  ...Array.isArray(Ye(a, w)) ? [{}] : []
                ],
                ref: { type: R.type, name: w }
              } : { ref: R }
            }
          }), D(w, !1, void 0, R);
        } else
          $ = Ye(i, w, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(iS(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, Ce = () => n.shouldFocusError && Ka(i, W, l.mount), He = (w) => {
    Xt(w) && (h.state.next({ disabled: w }), Ka(i, (_, $) => {
      const G = Ye(i, $);
      G && (_.disabled = G._f.disabled || w, Array.isArray(G._f.refs) && G._f.refs.forEach((J) => {
        J.disabled = G._f.disabled || w;
      }));
    }, 0, !1));
  }, Ze = (w, _) => async ($) => {
    let G;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let J = _t(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: z } = await Q();
      r.errors = R, J = z;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Yn(J, R, void 0);
    if (ht(r.errors, "root"), Ot(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(J, $);
      } catch (R) {
        G = R;
      }
    } else
      _ && await _({ ...r.errors }, $), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ot(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (w, _ = {}) => {
    Ye(i, w) && (it(_.defaultValue) ? le(w, _t(Ye(a, w))) : (le(w, _.defaultValue), Yn(a, w, _t(_.defaultValue))), _.keepTouched || ht(r.touchedFields, w), _.keepDirty || (ht(r.dirtyFields, w), r.isDirty = _.defaultValue ? O(w, _t(Ye(a, w))) : O()), _.keepError || (ht(r.errors, w), u.isValid && C()), h.state.next({ ...r }));
  }, he = (w, _ = {}) => {
    const $ = w ? _t(w) : a, G = _t($), J = Ot(w), R = J ? a : G;
    if (_.keepDefaultValues || (a = $), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ia(a, o))
        ]);
        for (const re of Array.from(z))
          Ye(r.dirtyFields, re) ? Yn(R, re, Ye(o, re)) : le(re, Ye(R, re));
      } else {
        if (Op && it(w))
          for (const z of l.mount) {
            const re = Ye(i, z);
            if (re && re._f) {
              const fe = Array.isArray(re._f.refs) ? re._f.refs[0] : re._f.ref;
              if (js(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Ye(R, z));
      }
      o = _t(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Qr(w, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Ia(a, o) : r.dirtyFields : _.keepDefaultValues && w ? Ia(a, w) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ee = (w, _) => he(gr(w) ? w(o) : w, _), Le = (w, _ = {}) => {
    const $ = Ye(i, w), G = $ && $._f;
    if (G) {
      const J = G.refs ? G.refs[0] : G.ref;
      J.focus && (J.focus(), _.shouldSelect && gr(J.select) && J.select());
    }
  }, Re = (w) => {
    r = {
      ...r,
      ...w
    };
  }, ln = {
    control: {
      register: tn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Me,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: O,
      _setValid: C,
      _setFieldArray: H,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => gr(n.defaultValues) && n.defaultValues().then((w) => {
        Ee(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: He,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: we,
    trigger: be,
    register: tn,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Fe,
    reset: Ee,
    resetField: me,
    clearErrors: Be,
    unregister: Ae,
    setError: Me,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...ln,
    formControl: ln
  };
}
function lU(e = {}) {
  const n = Ne.useRef(void 0), r = Ne.useRef(void 0), [i, a] = Ne.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: gr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: gr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : sU(e),
    formState: i
  }, e.formControl && e.defaultValues && !gr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ne.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ne.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ne.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ne.useEffect(() => {
    e.values && !Qr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ne.useEffect(() => {
    e.errors && !Ot(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ne.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ne.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = oS(i, o), n.current;
}
const cU = "_modalBody_1clhs_1", dU = {
  modalBody: cU
}, uU = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = lU({
    defaultValues: u,
    mode: "onChange"
  }), F = lS({ control: f }), S = parseInt(F?.balance ?? "0", 10), N = m === S, C = N ? "Change the value to update the points" : "", y = S < 0, H = y ? "Points can not be negative" : "", T = F.description === "", E = T ? "Description can not be empty" : "";
  qe(() => {
    S > m ? h(
      "transactionType",
      Sm.Addition
    ) : S < m && h(
      "transactionType",
      Sm.Deduction
    );
  }, [m, S, h]);
  const [D, { loading: U, error: Z, reset: Q }] = o($3, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ie = () => {
    if (d) {
      const M = d3();
      D({
        variables: {
          input: {
            accountId: d,
            transactionId: M,
            amount: Math.abs(S - m),
            transactionType: F.transactionType,
            description: F.description,
            source: nS.UpdateBalance
          }
        }
      }).then(async (O) => {
        O?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), Y());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, Y = () => {
    v(u), Q(), n();
  };
  return /* @__PURE__ */ B.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: Y,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ B.jsx(jt, { title: "Update points balance", onClose: Y }),
        /* @__PURE__ */ B.jsxs(wt, { className: dU.modalBody, children: [
          /* @__PURE__ */ B.jsxs(Et, { children: [
            /* @__PURE__ */ B.jsx(Qe, { span: 6, children: /* @__PURE__ */ B.jsx(
              Ok,
              {
                name: "balance",
                control: f,
                render: ({ field: M }) => /* @__PURE__ */ B.jsx(
                  lr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: C || H
                    },
                    input: {
                      ...M,
                      value: M.value.toString(),
                      onChange: (O) => M.onChange(O)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ B.jsx(Qe, { span: 6, children: /* @__PURE__ */ B.jsx(
              Ok,
              {
                name: "description",
                control: f,
                render: ({ field: M }) => /* @__PURE__ */ B.jsx(
                  lr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: M,
                    meta: {
                      warning: E
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ B.jsx(Fn, { error: Z })
        ] }),
        /* @__PURE__ */ B.jsx(
          Tt,
          {
            confirmName: "Save",
            confirmOnClick: () => ie(),
            confirmProps: {
              isLoading: U,
              disabled: N || y || T,
              loadingIndicator: /* @__PURE__ */ B.jsx(sn, { size: 16 })
            },
            cancelOnClick: Y
          }
        )
      ]
    }
  );
}, mU = "_wrapper_1ge6c_1", pU = "_block_1ge6c_12", Kk = {
  wrapper: mU,
  block: pU
}, fU = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = mn(), { isCopied: i, copy: a } = os(), { isCopied: o, copy: s } = os(), { isCopied: l, copy: d } = os(), [m, u] = se(!1), [f, h] = se(), [v, F] = se(!1), {
    loading: S,
    data: N,
    refetch: C
  } = r(E3, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  qe(() => {
    if (N) {
      const ee = N?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [N]);
  const y = !!f?.id, H = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: T,
    lastName: E,
    street: D,
    zipCode: U,
    city: Z,
    country: Q,
    isRegistrationCompleted: ie,
    email: Y,
    mobilePhone: M
  } = e, O = 14, q = `${T || ""} ${E || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", className: Kk.wrapper, children: [
    /* @__PURE__ */ B.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Kk.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-2", children: q }),
          S && /* @__PURE__ */ B.jsx(sn, { size: 12 }),
          y && !S && /* @__PURE__ */ B.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ B.jsxs(Un, { size: "small", variant: "warning", children: [
              H,
              " points"
            ] }),
            /* @__PURE__ */ B.jsx(Ke, { content: "Update points balance", children: /* @__PURE__ */ B.jsx(
              ue,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ B.jsx(Ke, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ B.jsx(
              ue,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (D || Z || U || Q || M || Y) && /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
      M && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: O, name: "phone" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: M })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: O,
            name: o ? "done" : "copy",
            onClick: () => s(M),
            className: nt.pointer
          }
        )
      ] }),
      Y && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: O, name: "mail" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Y })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: O,
            name: i ? "done" : "copy",
            onClick: () => a(Y),
            className: nt.pointer
          }
        )
      ] }),
      (D || Z || U || Q) && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ B.jsx(ue, { size: O, name: "home" }),
          /* @__PURE__ */ B.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ B.jsx(Qn, { children: D }),
            /* @__PURE__ */ B.jsxs(Qn, { children: [
              U,
              " ",
              Z
            ] }),
            /* @__PURE__ */ B.jsx(Qn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: O,
            name: l ? "done" : "copy",
            onClick: () => d(`${D}, ${U} ${Z}, ${Q}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: O, name: "sign-in" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            name: ie ? "check-circle-filled" : "close-circle-filled",
            color: ie ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ B.jsx(
      uU,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: F,
        refetchPointsQuery: C
      }
    )
  ] });
}, hU = "_list_yud4a_7", yU = "_listItem_yud4a_11", gU = "_listItemTooltip_yud4a_15", vU = "_listItemTimestamp_yud4a_18", Bo = {
  list: hU,
  listItem: yU,
  listItemTooltip: gU,
  listItemTimestamp: vU
}, kU = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ B.jsx(We, { className: Bo.list, children: e.map((n, r) => /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: Bo.listItem, children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ B.jsx(Ke, { content: n?.comment, children: /* @__PURE__ */ B.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ut({
          [Bo.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { className: Bo.listItemTimestamp, children: Ln(n.date).format(dt) }),
          n?.comment && /* @__PURE__ */ B.jsx(ue, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ B.jsx(
      ue,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), bU = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Ln(e.latestChange).format(dt) : null, o = e?.expires ? `${Ln(e.expires).fromNow()} (${Ln(e.expires).format(dt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ B.jsx(Ke, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ B.jsx(
        ue,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ B.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ B.jsxs(We, { className: nt.list, children: [
      s && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, _U = "_tagHover_kzbzk_1", xU = "_channelUnsubscribed_kzbzk_6", Gk = {
  tagHover: _U,
  channelUnsubscribed: xU
}, Vu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = bn(), { useMutation: l } = mn(), [d, m] = se(!1), [u, { loading: f }] = l(T3), h = async ({
    newPreference: F,
    isSubscribed: S,
    channelType: N
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...F
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : S ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ B.jsx(Ke, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ B.jsx(
    An,
    {
      className: Gk.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ B.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ut({
            [Gk.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ B.jsx(sn, { size: 16 }) : /* @__PURE__ */ B.jsx(ue, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, SU = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        Vu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        Vu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        Vu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, NU = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = D3({ contactId: e }), {
    isLoading: v,
    error: F,
    memberLevel: S
  } = V3({ contactId: e, skip: !s }), N = v || l, C = qn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || F ? no({
    errors: d?.graphQLErrors || F?.graphQLErrors || []
  }) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ B.jsx(Fn, { error: d || F }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(sn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
    r && /* @__PURE__ */ B.jsx(
      fU,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ B.jsx(bU, { memberLevel: S }),
    i && /* @__PURE__ */ B.jsx(
      SU,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ B.jsx(kU, { contactConsents: C })
  ] });
}, jm = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, jU = "_list_zu4s7_1", wU = "_listItem_zu4s7_4", CU = "_listSum_zu4s7_7", qo = {
  list: jU,
  listItem: wU,
  listSum: CU
}, FU = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ B.jsxs(We, { className: qo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: qo.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: s, children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ B.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ B.jsx(b, { flex: "auto", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ B.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: jm(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ B.jsx(
    We.Text,
    {
      variant: "dense",
      className: ut(qo.listItem, qo.listSum),
      children: /* @__PURE__ */ B.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: jm(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), IU = "_transaction_1kr8d_1", EU = "_transactionIsOpen_1kr8d_9", TU = "_transactionHeader_1kr8d_12", $U = "_transactionHeaderSubLine_1kr8d_15", DU = "_transactionHeaderAlignItemRight_1kr8d_19", Ii = {
  transaction: IU,
  transactionIsOpen: EU,
  transactionHeader: TU,
  transactionHeaderSubLine: $U,
  transactionHeaderAlignItemRight: DU
}, RU = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, F = m?.length ? m : [];
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Ii.transaction, {
        [Ii.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ii.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ B.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: Ln(o).format(dt) }),
                  /* @__PURE__ */ B.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: Ii.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ B.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Ii.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-4", children: jm(v, h) }),
                      /* @__PURE__ */ B.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: Ii.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ B.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ B.jsx(Tm, {}),
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ B.jsx(An, { children: /* @__PURE__ */ B.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ B.jsx(
                  FU,
                  {
                    lineItems: F,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, OU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = A3({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ B.jsx(Fn, { error: r }) : /* @__PURE__ */ B.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(sn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
          s === 0 && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ B.jsx(
            RU,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, PU = "_message_unsvt_48", AU = "_messageIsOpen_unsvt_56", LU = "_messageHeader_unsvt_60", VU = "_messageText_unsvt_64", zU = "_buttonLink_unsvt_86", Ta = {
  message: PU,
  messageIsOpen: AU,
  messageHeader: LU,
  messageText: VU,
  buttonLink: zU
}, zu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Uu = (e, n) => n && e in zu && n in zu[e] ? zu[e][n] : null, UU = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = bn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Uu("type", l) : null, F = d ? Uu("source", d) : null, S = u ? Uu("status", u) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Ta.message, {
        [Ta.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ta.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
                    /* @__PURE__ */ B.jsx(ue, { name: v, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: Ln(s).format(dt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ B.jsx(Tm, {}),
          /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ B.jsx(An, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: S }),
              " ",
              u
            ] }) }),
            F && /* @__PURE__ */ B.jsx(An, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: F }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ B.jsx(An, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", className: Ta.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ B.jsx(
            St,
            {
              slotEnd: /* @__PURE__ */ B.jsx(ue, { name: "external-link" }),
              variant: "tertiary",
              className: Ta.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, MU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = O3({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ B.jsx(Fn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(sn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ B.jsx(
        UU,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, nl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Yk = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = os(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = tt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(ue, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ B.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, BU = "_order_19t4p_1", qU = "_orderIsOpen_19t4p_9", HU = "_orderHeader_19t4p_12", WU = "_orderIconColor_19t4p_15", Cr = {
  order: BU,
  orderIsOpen: qU,
  orderHeader: HU,
  orderIconColor: WU
}, KU = "_delivery_1m9nb_1", GU = "_deliveryCode_1m9nb_4", Mu = {
  delivery: KU,
  deliveryCode: GU
}, YU = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = er();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: "eye",
        className: Cr.orderIconColor
      }
    ),
    /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ B.jsx(
        Ke,
        {
          content: /* @__PURE__ */ B.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Ln(s).format(dt)
          ] }),
          children: /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ B.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ B.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Mu.delivery,
                    children: [
                      /* @__PURE__ */ B.jsx(ue, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ B.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: ut(Mu.delivery, Mu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ B.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, JU = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "file-text",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ B.jsx(We, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ B.jsx(We.Item, { className: nt.listItem, children: /* @__PURE__ */ B.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ B.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ B.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: nl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, QU = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "tag",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ B.jsx(We, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ B.jsx(
      We.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ B.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ B.jsx(
          Ke,
          {
            content: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ B.jsx(b, { children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: nl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ B.jsx(
          Bi,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, XU = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "credit-card",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ B.jsx(We, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ B.jsx(
      We.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ B.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: Ln(i?.paidAt).format(dt) }),
                    /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: nl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, ZU = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: F
  } = e, S = 14;
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Cr.order, {
        [Cr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Cr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ B.jsx(b, { alignItems: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Ln(m).format(dt) }) }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: S,
                name: "activity",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ B.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ B.jsx(Ke, { content: "Internal status", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ B.jsx(Ke, { content: "External status", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: s }) }) }),
                /* @__PURE__ */ B.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ B.jsx(A.Paragraph, { as: "span", variant: "5", children: Ln(u).format(dt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: S,
                name: "chart-bar",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: nl({
                value: F,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: S,
                name: "channels",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ B.jsx(Yk, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ B.jsx(
            Yk,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ B.jsx(YU, { delivery: e.delivery }),
          /* @__PURE__ */ B.jsx(QU, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ B.jsx(JU, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ B.jsx(
            XU,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, eM = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || no({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ B.jsx(Fn, { error: e }) : /* @__PURE__ */ B.jsx(B.Fragment, { children: r }), nM = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), { track: a } = bn(), {
    loading: o,
    error: s,
    data: l
  } = n(I3, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(sn, {}) }) : /* @__PURE__ */ B.jsx(eM, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ B.jsx(
      ZU,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, tM = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = L3({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: F
  } = n;
  return s ? /* @__PURE__ */ B.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ B.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? no({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ B.jsx(Fn, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(sn, {}) }) : /* @__PURE__ */ B.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ B.jsx(NU, { contactId: i, settings: n }),
        h && /* @__PURE__ */ B.jsx(MU, { contactId: i }),
        v && /* @__PURE__ */ B.jsx(OU, { contactId: i }),
        F && /* @__PURE__ */ B.jsx(nM, { contactId: i }),
        !l && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, rM = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bu = { exports: {} }, $a = {}, Jk;
function iM() {
  if (Jk) return $a;
  Jk = 1;
  var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return $a.Fragment = r, $a.jsx = s, $a.jsxs = s, $a;
}
var Ho = {}, Qk;
function aM() {
  return Qk || (Qk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ne, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = C.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, be, Fe;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Fe
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Ue;
    function we(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ce(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), x = j.length - 1, V = te.length - 1; x >= 1 && V >= 0 && j[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== te[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var je = t ? t.displayName || t.name : "", Se = je ? we(je) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function He(t, c, p) {
      return Ce(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, Ze(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case m:
          return we("Suspense");
        case u:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ee = {}, Le = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ee) && (Ee[j.message] = !0, Re(P), y("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), J(t);
    }
    var z = C.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), un(c) && (R(c.key), j = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), te && pn(I, V);
        }
        return cn(t, j, te, P, g, z.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, Sn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? j += te : j += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var je = 0; je < X.length; je++)
                  jn(X[je], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (he.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, En, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Ho.Fragment = i, Ho.jsx = Rn, Ho.jsxs = Bn;
  })()), Ho;
}
var Xk;
function oM() {
  return Xk || (Xk = 1, process.env.NODE_ENV === "production" ? Bu.exports = iM() : Bu.exports = aM()), Bu.exports;
}
var ce = oM();
const sM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, lM = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": sM
};
function cM(e) {
  return lM[e] ?? {};
}
const dM = cM(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), uM = "_copyIcon_nr4rl_48", mM = "_list_nr4rl_53", pM = "_listItem_nr4rl_63", Dr = {
  copyIcon: uM,
  list: mM,
  listItem: pM
}, $n = ({
  description: e,
  content: n,
  tooltip: r
}) => {
  if (n == null)
    return null;
  const i = t0(n);
  return /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsx(Ke, { content: r, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : bb(n)
  ] }) }) });
}, Zk = ({
  channel: e
}) => {
  const n = (a) => $s(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: r } = e, i = "suppressions" in r && !!r.suppressions;
  return /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
    /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(r?.timestamp).format(dt) }),
        r?.consent && /* @__PURE__ */ ce.jsx(Un, { variant: "primary", size: "small", children: n(r?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r.suppressions?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(r.suppressions?.timestamp).format(
          dt
        ) }),
        r.suppressions?.suppression_reason && /* @__PURE__ */ ce.jsx(Un, { variant: "warning", size: "small", children: r.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, fM = "_channelHeadline_yeqqp_1", eb = {
  channelHeadline: fM
}, hM = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: r, yotpo_sms: i } = e;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: eb.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "mail" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Zk, { channel: n?.email }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: r?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: r?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: r?.last_delivered
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: r?.last_opened
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: r?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: r?.last_converted
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: r?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: eb.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Zk, { channel: n?.sms }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, yM = "_wrapper_1xucg_1", gM = "_externalLink_1xucg_7", qu = {
  wrapper: yM,
  externalLink: gM
}, vM = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = er(), { isCopied: i, copy: a } = er(), { isCopied: o, copy: s } = er();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: d,
    address: m,
    email: u,
    phone_number: f,
    account_created_at: h,
    account_status: v,
    accepts_sms_marketing: F,
    accepts_email_marketing: S
  } = e, N = 14, C = `${l || ""} ${d || ""}`.trim() || "A customer has no name", {
    address1: y,
    address2: H,
    city: T,
    company: E,
    state: D,
    zip: U,
    province_code: Z,
    country_code: Q
  } = m || {}, ie = [
    y,
    H,
    [U, T].filter(Boolean).join(", "),
    [Q, D, Z].filter(Boolean).join(", "),
    E
  ].filter(Boolean);
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { className: qu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: qu.block,
        alignItems: "center",
        children: /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-2", children: C })
      }
    ),
    h && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: Ln(h).format(dt) })
    ] }),
    u && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: N, name: "mail" }),
        /* @__PURE__ */ ce.jsx("span", { className: qu.externalLink, children: u })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: N,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: N, name: "phone" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: N,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    (y || T || E || D || U || Q) && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: N, name: "home" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: ie.map((Y) => /* @__PURE__ */ ce.jsx(Qn, { children: Y }, Y)) })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy address", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: N,
          name: o ? "done" : "copy",
          onClick: () => s(ie.join(", ")),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: N, name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: F ? "check-circle-filled" : "close-circle-filled",
          color: F ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: N, name: "paper-plane" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: S ? "check-circle-filled" : "close-circle-filled",
          color: S ? "green.500" : "red.500"
        }
      )
    ] }),
    v && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: N, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ ce.jsx(An, { children: $s(v) })
    ] })
  ] }) });
}, kM = ({
  loyalty: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), bM = ({ tags: e }) => {
  const n = e?.split(","), r = n && n.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !r && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    r && /* @__PURE__ */ ce.jsx(b, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ ce.jsx(An, { children: i }, a)) })
  ] });
}, _M = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Ln(e.last_review_date).format(
          dt
        )
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ ce.jsx(Un, { variant: "info", size: "small", children: /* @__PURE__ */ ce.jsx(ce.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), xM = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = bn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showTags ?? !1, F = n?.showChannels ?? !1, S = n?.showUserGeneratedContent ?? !1, N = n?.displayLoyalty ?? !1, C = n?.displayEmailData ?? !1, y = n?.displaySmsData ?? !1, H = n?.displaySubscriptions ?? !1, T = !h && !v && !F && !S && !N && !C && !y && !H, {
    loading: E,
    error: D,
    data: U
  } = r(dM, {
    skip: !d || !f,
    variables: {
      ...d && { email: d },
      // eslint-disable-next-line camelcase
      ...!d && m && { phone_number: m },
      storeId: f,
      expand: "all"
    }
  });
  if (qe(() => {
    const Z = U?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [U?.Yotpo, E]), u)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (s)
    return /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (T)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (D) {
    const Z = D.graphQLErrors;
    return Cm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Fm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ce.jsx(Fn, { error: D });
  }
  return E ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ce.jsx(sn, {}) }) : /* @__PURE__ */ ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ce.jsx(vM, { customerDetails: a }),
        v && /* @__PURE__ */ ce.jsx(bM, { tags: a?.tags }),
        F && /* @__PURE__ */ ce.jsx(hM, { customerDetails: a }),
        S && /* @__PURE__ */ ce.jsx(
          _M,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        N && /* @__PURE__ */ ce.jsx(kM, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var yo = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, Vt = (e) => e == null;
const hS = (e) => typeof e == "object";
var ct = (e) => !Vt(e) && !Array.isArray(e) && hS(e) && !ci(e), yS = (e) => ct(e) && e.target ? yo(e.target) ? e.target.checked : e.target.value : e, SM = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, gS = (e, n) => e.has(SM(n)), NM = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ct(n) && n.hasOwnProperty("isPrototypeOf");
}, zp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(zp && (e instanceof Blob || i)) && (r || ct(e)))
    if (n = r ? [] : {}, !r && !NM(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = xt(e[a]));
  else
    return e;
  return n;
}
var tl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], at = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !ct(e))
    return r;
  const i = tl(n.split(/[,[\].]+?/)).reduce((a, o) => Vt(a) ? a : a[o], e);
  return at(i) || i === e ? at(e[n]) ? r : e[n] : i;
}, Zt = (e) => typeof e == "boolean", Up = (e) => /^\w*$/.test(e), vS = (e) => tl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Jn = (e, n, r) => {
  let i = -1;
  const a = Up(n) ? [n] : vS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ct(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Fs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, vr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, jM = Ne.createContext(null), Mp = () => Ne.useContext(jM);
var kS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== vr.all && (n._proxyFormState[s] = !i || vr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function wM(e) {
  const n = Mp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ne.useState(r._formState), d = Ne.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Ne.useRef(a);
  return m.current = a, Ne.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Ne.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Ne.useMemo(() => kS(s, r, d.current, !1), [s, r]);
}
var $r = (e) => typeof e == "string", bS = (e, n, r, i, a) => $r(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function _S(e) {
  const n = Mp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ne.useRef(i), d = Ne.useRef(a);
  l.current = i, Ne.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(bS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Ne.useState(r._getWatch(i, a));
  return Ne.useEffect(() => r._removeUnmounted()), m;
}
function CM(e) {
  const n = Mp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = gS(a._names.array, r), l = _S({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = wM({
    control: a,
    name: r,
    exact: !0
  }), m = Ne.useRef(e), u = Ne.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Zt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ne.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Ne.useCallback((N) => u.current.onChange({
    target: {
      value: yS(N),
      name: r
    },
    type: Fs.CHANGE
  }), [r]), v = Ne.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: Fs.BLUR
  }), [r, a._formValues]), F = Ne.useCallback((N) => {
    const C = Je(a._fields, r);
    C && N && (C._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Ne.useMemo(() => ({
    name: r,
    value: l,
    ...Zt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: F
  }), [r, i, d.disabled, h, v, F, l]);
  return Ne.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Zt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const C = (y, H) => {
      const T = Je(a._fields, y);
      T && T._f && (T._f.mount = H);
    };
    if (C(r, !0), N) {
      const y = xt(Je(a._options.defaultValues, r));
      Jn(a._defaultValues, r, y), at(Je(a._formValues, r)) && Jn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Ne.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ne.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const nb = (e) => e.render(CM(e));
var FM = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ga = (e) => Array.isArray(e) ? e : [e], tb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, wm = (e) => Vt(e) || !hS(e);
function Xr(e, n) {
  if (wm(e) || wm(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || ct(o) && ct(s) || Array.isArray(o) && Array.isArray(s) ? !Xr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Pt = (e) => ct(e) && !Object.keys(e).length, Bp = (e) => e.type === "file", kr = (e) => typeof e == "function", Is = (e) => {
  if (!zp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, xS = (e) => e.type === "select-multiple", qp = (e) => e.type === "radio", IM = (e) => qp(e) || yo(e), Hu = (e) => Is(e) && e.isConnected;
function EM(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = at(e) ? i++ : e[n[i++]];
  return e;
}
function TM(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !at(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const r = Array.isArray(n) ? n : Up(n) ? [n] : vS(n), i = r.length === 1 ? e : EM(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ct(i) && Pt(i) || Array.isArray(i) && TM(i)) && yt(e, r.slice(0, -1)), e;
}
var SS = (e) => {
  for (const n in e)
    if (kr(e[n]))
      return !0;
  return !1;
};
function Es(e, n = {}) {
  const r = Array.isArray(e);
  if (ct(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ct(e[i]) && !SS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Es(e[i], n[i])) : Vt(e[i]) || (n[i] = !0);
  return n;
}
function NS(e, n, r) {
  const i = Array.isArray(e);
  if (ct(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ct(e[a]) && !SS(e[a]) ? at(n) || wm(r[a]) ? r[a] = Array.isArray(e[a]) ? Es(e[a], []) : { ...Es(e[a]) } : NS(e[a], Vt(n) ? {} : n[a], r[a]) : r[a] = !Xr(e[a], n[a]);
  return r;
}
var Da = (e, n) => NS(e, n, Es(n));
const rb = {
  value: !1,
  isValid: !1
}, ib = { value: !0, isValid: !0 };
var jS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !at(e[0].attributes.value) ? at(e[0].value) || e[0].value === "" ? ib : { value: e[0].value, isValid: !0 } : ib
    ) : rb;
  }
  return rb;
}, wS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => at(e) ? e : n ? e === "" ? NaN : e && +e : r && $r(e) ? new Date(e) : i ? i(e) : e;
const ab = {
  isValid: !1,
  value: null
};
var CS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ab) : ab;
function ob(e) {
  const n = e.ref;
  return Bp(n) ? n.files : qp(n) ? CS(e.refs).value : xS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : yo(n) ? jS(e.refs).value : wS(at(n.value) ? e.ref.value : n.value, e);
}
var $M = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Jn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Ts = (e) => e instanceof RegExp, Ra = (e) => at(e) ? e : Ts(e) ? e.source : ct(e) ? Ts(e.value) ? e.value.source : e.value : e, sb = (e) => ({
  isOnSubmit: !e || e === vr.onSubmit,
  isOnBlur: e === vr.onBlur,
  isOnChange: e === vr.onChange,
  isOnAll: e === vr.all,
  isOnTouch: e === vr.onTouched
});
const lb = "AsyncFunction";
var DM = (e) => !!e && !!e.validate && !!(kr(e.validate) && e.validate.constructor.name === lb || ct(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === lb)), RM = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), cb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ya = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ya(l, n))
          break;
      } else if (ct(l) && Ya(l, n))
        break;
    }
  }
};
function db(e, n, r) {
  const i = Je(e, r);
  if (i || Up(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var OM = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Pt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || vr.all));
}, PM = (e, n, r) => !e || !n || e === n || Ga(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), AM = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, LM = (e, n) => !tl(Je(e, n)).length && yt(e, n), VM = (e, n, r) => {
  const i = Ga(Je(e, r));
  return Jn(i, "root", n[r]), Jn(e, r, i), e;
}, ls = (e) => $r(e);
function ub(e, n, r = "validate") {
  if (ls(e) || Array.isArray(e) && e.every(ls) || Zt(e) && !e)
    return {
      type: r,
      message: ls(e) ? e : "",
      ref: n
    };
}
var Ei = (e) => ct(e) && !Ts(e) ? e : {
  value: e,
  message: ""
}, mb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: F, name: S, valueAsNumber: N, mount: C } = e._f, y = Je(r, S);
  if (!C || n.has(S))
    return {};
  const H = l ? l[0] : s, T = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Zt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, D = qp(s), U = yo(s), Z = D || U, Q = (N || Bp(s)) && at(s.value) && at(y) || Is(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = FM.bind(null, S, i, E), Y = (M, O, q, ee = Mr.maxLength, ge = Mr.minLength) => {
    const de = M ? O : q;
    E[S] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || Vt(y)) || Zt(y) && !y || U && !jS(l).isValid || D && !CS(l).isValid)) {
    const { value: M, message: O } = ls(d) ? { value: !!d, message: d } : Ei(d);
    if (M && (E[S] = {
      type: Mr.required,
      message: O,
      ref: H,
      ...ie(Mr.required, O)
    }, !i))
      return T(O), E;
  }
  if (!Q && (!Vt(f) || !Vt(h))) {
    let M, O;
    const q = Ei(h), ee = Ei(f);
    if (!Vt(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      Vt(q.value) || (M = ge > q.value), Vt(ee.value) || (O = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      $r(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), $r(ee.value) && y && (O = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || O) && (Y(!!M, q.message, ee.message, Mr.max, Mr.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !Q && ($r(y) || o && Array.isArray(y))) {
    const M = Ei(m), O = Ei(u), q = !Vt(M.value) && y.length > +M.value, ee = !Vt(O.value) && y.length < +O.value;
    if ((q || ee) && (Y(q, M.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !Q && $r(y)) {
    const { value: M, message: O } = Ei(v);
    if (Ts(M) && !y.match(M) && (E[S] = {
      type: Mr.pattern,
      message: O,
      ref: s,
      ...ie(Mr.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (F) {
    if (kr(F)) {
      const M = await F(y, r), O = ub(M, H);
      if (O && (E[S] = {
        ...O,
        ...ie(Mr.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (ct(F)) {
      let M = {};
      for (const O in F) {
        if (!Pt(M) && !i)
          break;
        const q = ub(await F[O](y, r), H, O);
        q && (M = {
          ...q,
          ...ie(O, q.message)
        }, T(q.message), i && (E[S] = M));
      }
      if (!Pt(M) && (E[S] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const zM = {
  mode: vr.onSubmit,
  reValidateMode: vr.onChange,
  shouldFocusError: !0
};
function UM(e = {}) {
  let n = {
    ...zM,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: kr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ct(n.defaultValues) || ct(n.values) ? xt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : xt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: tb(),
    state: tb()
  }, v = sb(n.mode), F = sb(n.reValidateMode), S = n.criteriaMode === vr.all, N = (w) => (_) => {
    clearTimeout(m), m = setTimeout(w, _);
  }, C = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const _ = n.resolver ? Pt((await Q()).errors) : await Y(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (w, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach(($) => {
      $ && (_ ? Jn(r.validatingFields, $, _) : yt(r.validatingFields, $));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Pt(r.validatingFields)
    }));
  }, H = (w, _ = [], $, G, J = !0, R = !0) => {
    if (G && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Je(i, w))) {
        const z = $(Je(i, w), G.argA, G.argB);
        J && Jn(i, w, z);
      }
      if (R && Array.isArray(Je(r.errors, w))) {
        const z = $(Je(r.errors, w), G.argA, G.argB);
        J && Jn(r.errors, w, z), LM(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Je(r.touchedFields, w))) {
        const z = $(Je(r.touchedFields, w), G.argA, G.argB);
        J && Jn(r.touchedFields, w, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Da(a, o)), h.state.next({
        name: w,
        isDirty: O(w, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Jn(o, w, _);
  }, T = (w, _) => {
    Jn(r.errors, w, _), h.state.next({
      errors: r.errors
    });
  }, E = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (w, _, $, G) => {
    const J = Je(i, w);
    if (J) {
      const R = Je(o, w, at($) ? Je(a, w) : $);
      at(R) || G && G.defaultChecked || _ ? Jn(o, w, _ ? R : ob(J._f)) : ge(w, R), s.mount && C();
    }
  }, U = (w, _, $, G, J) => {
    let R = !1, z = !1;
    const re = {
      name: w
    };
    if (!n.disabled) {
      if (!$ || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = re.isDirty = O(), R = z !== re.isDirty);
        const fe = Xr(Je(a, w), _);
        z = !!Je(r.dirtyFields, w), fe ? yt(r.dirtyFields, w) : Jn(r.dirtyFields, w, !0), re.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && z !== !fe;
      }
      if ($) {
        const fe = Je(r.touchedFields, w);
        fe || (Jn(r.touchedFields, w, $), re.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && fe !== $);
      }
      R && J && h.state.next(re);
    }
    return R ? re : {};
  }, Z = (w, _, $, G) => {
    const J = Je(r.errors, w), R = (u.isValid || f.isValid) && Zt(_) && r.isValid !== _;
    if (n.delayError && $ ? (d = N(() => T(w, $)), d(n.delayError)) : (clearTimeout(m), d = null, $ ? Jn(r.errors, w, $) : yt(r.errors, w)), ($ ? !Xr(J, $) : J) || !Pt(G) || R) {
      const z = {
        ...G,
        ...R && Zt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, Q = async (w) => {
    y(w, !0);
    const _ = await n.resolver(o, n.context, $M(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(w), _;
  }, ie = async (w) => {
    const { errors: _ } = await Q(w);
    if (w)
      for (const $ of w) {
        const G = Je(_, $);
        G ? Jn(r.errors, $, G) : yt(r.errors, $);
      }
    else
      r.errors = _;
    return _;
  }, Y = async (w, _, $ = {
    valid: !0
  }) => {
    for (const G in w) {
      const J = w[G];
      if (J) {
        const { _f: R, ...z } = J;
        if (R) {
          const re = l.array.has(R.name), fe = J._f && DM(J._f);
          fe && u.validatingFields && y([G], !0);
          const _e = await mb(J, l.disabled, o, S, n.shouldUseNativeValidation && !_, re);
          if (fe && u.validatingFields && y([G]), _e[R.name] && ($.valid = !1, _))
            break;
          !_ && (Je(_e, R.name) ? re ? VM(r.errors, _e, R.name) : Jn(r.errors, R.name, _e[R.name]) : yt(r.errors, R.name));
        }
        !Pt(z) && await Y(z, _, $);
      }
    }
    return $.valid;
  }, M = () => {
    for (const w of l.unMount) {
      const _ = Je(i, w);
      _ && (_._f.refs ? _._f.refs.every(($) => !Hu($)) : !Hu(_._f.ref)) && Ae(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (w, _) => !n.disabled && (w && _ && Jn(o, w, _), !Xr(Fe(), a)), q = (w, _, $) => bS(w, l, {
    ...s.mount ? o : at(_) ? a : $r(w) ? { [w]: _ } : _
  }, $, _), ee = (w) => tl(Je(s.mount ? o : a, w, n.shouldUnregister ? Je(a, w, []) : [])), ge = (w, _, $ = {}) => {
    const G = Je(i, w);
    let J = _;
    if (G) {
      const R = G._f;
      R && (!R.disabled && Jn(o, w, wS(_, R)), J = Is(R.ref) && Vt(_) ? "" : _, xS(R.ref) ? [...R.ref.options].forEach((z) => z.selected = J.includes(z.value)) : R.refs ? yo(R.ref) ? R.refs.length > 1 ? R.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(J) ? !!J.find((re) => re === z.value) : J === z.value)) : R.refs[0] && (R.refs[0].checked = !!J) : R.refs.forEach((z) => z.checked = z.value === J) : Bp(R.ref) ? R.ref.value = "" : (R.ref.value = J, R.ref.type || h.state.next({
        name: w,
        values: xt(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && U(w, J, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && be(w);
  }, de = (w, _, $) => {
    for (const G in _) {
      const J = _[G], R = `${w}.${G}`, z = Je(i, R);
      (l.array.has(w) || ct(J) || z && !z._f) && !ci(J) ? de(R, J, $) : ge(R, J, $);
    }
  }, le = (w, _, $ = {}) => {
    const G = Je(i, w), J = l.array.has(w), R = xt(_);
    Jn(o, w, R), J ? (h.array.next({
      name: w,
      values: xt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: w,
      dirtyFields: Da(a, o),
      isDirty: O(w, R)
    })) : G && !G._f && !Vt(R) ? de(w, R, $) : ge(w, R, $), cb(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: xt(o)
    });
  }, pe = async (w) => {
    s.mount = !0;
    const _ = w.target;
    let $ = _.name, G = !0;
    const J = Je(i, $), R = (z) => {
      G = Number.isNaN(z) || ci(z) && isNaN(z.getTime()) || Xr(z, Je(o, $, z));
    };
    if (J) {
      let z, re;
      const fe = _.type ? ob(J._f) : yS(w), _e = w.type === Fs.BLUR || w.type === Fs.FOCUS_OUT, en = !RM(J._f) && !n.resolver && !Je(r.errors, $) && !J._f.deps || AM(_e, Je(r.touchedFields, $), r.isSubmitted, F, v), un = cb($, l, _e);
      Jn(o, $, fe), _e ? (J._f.onBlur && J._f.onBlur(w), d && d(0)) : J._f.onChange && J._f.onChange(w);
      const rn = U($, fe, _e), dn = !Pt(rn) || un;
      if (!_e && h.state.next({
        name: $,
        type: w.type,
        values: xt(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && C() : _e || C()), dn && h.state.next({ name: $, ...un ? {} : rn });
      if (!_e && un && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([$]);
        if (R(fe), G) {
          const cn = db(r.errors, i, $), kn = db(pn, i, cn.name || $);
          z = kn.error, $ = kn.name, re = Pt(pn);
        }
      } else
        y([$], !0), z = (await mb(J, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(fe), G && (z ? re = !1 : (u.isValid || f.isValid) && (re = await Y(i, !0)));
      G && (J._f.deps && be(J._f.deps), Z($, re, z, rn));
    }
  }, W = (w, _) => {
    if (Je(r.errors, _) && w.focus)
      return w.focus(), 1;
  }, be = async (w, _ = {}) => {
    let $, G;
    const J = Ga(w);
    if (n.resolver) {
      const R = await ie(at(w) ? w : J);
      $ = Pt(R), G = w ? !J.some((z) => Je(R, z)) : $;
    } else w ? (G = (await Promise.all(J.map(async (R) => {
      const z = Je(i, R);
      return await Y(z && z._f ? { [R]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && C()) : G = $ = await Y(i);
    return h.state.next({
      ...!$r(w) || (u.isValid || f.isValid) && $ !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: $ } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Ya(i, W, w ? J : l.mount), G;
  }, Fe = (w) => {
    const _ = {
      ...s.mount ? o : a
    };
    return at(w) ? _ : $r(w) ? Je(_, w) : w.map(($) => Je(_, $));
  }, K = (w, _) => ({
    invalid: !!Je((_ || r).errors, w),
    isDirty: !!Je((_ || r).dirtyFields, w),
    error: Je((_ || r).errors, w),
    isValidating: !!Je(r.validatingFields, w),
    isTouched: !!Je((_ || r).touchedFields, w)
  }), Be = (w) => {
    w && Ga(w).forEach((_) => yt(r.errors, _)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Me = (w, _, $) => {
    const G = (Je(i, w, { _f: {} })._f || {}).ref, J = Je(r.errors, w) || {}, { ref: R, message: z, type: re, ...fe } = J;
    Jn(r.errors, w, {
      ...fe,
      ..._,
      ref: G
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), $ && $.shouldFocus && G && G.focus && G.focus();
  }, Pe = (w, _) => kr(w) ? h.state.subscribe({
    next: ($) => w(q(void 0, _), $)
  }) : q(w, _, !0), Ue = (w) => h.state.subscribe({
    next: (_) => {
      PM(w.name, _.name, w.exact) && OM(_, w.formState || u, Re, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, we = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Ue({
    ...w,
    formState: f
  })), Ae = (w, _ = {}) => {
    for (const $ of w ? Ga(w) : l.mount)
      l.mount.delete($), l.array.delete($), _.keepValue || (yt(i, $), yt(o, $)), !_.keepError && yt(r.errors, $), !_.keepDirty && yt(r.dirtyFields, $), !_.keepTouched && yt(r.touchedFields, $), !_.keepIsValidating && yt(r.validatingFields, $), !n.shouldUnregister && !_.keepDefaultValue && yt(a, $);
    h.state.next({
      values: xt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: O() } : {}
    }), !_.keepIsValid && C();
  }, $e = ({ disabled: w, name: _ }) => {
    (Zt(w) && s.mount || w || l.disabled.has(_)) && (w ? l.disabled.add(_) : l.disabled.delete(_));
  }, tn = (w, _ = {}) => {
    let $ = Je(i, w);
    const G = Zt(_.disabled) || Zt(n.disabled);
    return Jn(i, w, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ..._
      }
    }), l.mount.add(w), $ ? $e({
      disabled: Zt(_.disabled) ? _.disabled : n.disabled,
      name: w
    }) : D(w, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ra(_.min),
        max: Ra(_.max),
        minLength: Ra(_.minLength),
        maxLength: Ra(_.maxLength),
        pattern: Ra(_.pattern)
      } : {},
      name: w,
      onChange: pe,
      onBlur: pe,
      ref: (J) => {
        if (J) {
          tn(w, _), $ = Je(i, w);
          const R = at(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, z = IM(R), re = $._f.refs || [];
          if (z ? re.find((fe) => fe === R) : R === $._f.ref)
            return;
          Jn(i, w, {
            _f: {
              ...$._f,
              ...z ? {
                refs: [
                  ...re.filter(Hu),
                  R,
                  ...Array.isArray(Je(a, w)) ? [{}] : []
                ],
                ref: { type: R.type, name: w }
              } : { ref: R }
            }
          }), D(w, !1, void 0, R);
        } else
          $ = Je(i, w, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(gS(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, Ce = () => n.shouldFocusError && Ya(i, W, l.mount), He = (w) => {
    Zt(w) && (h.state.next({ disabled: w }), Ya(i, (_, $) => {
      const G = Je(i, $);
      G && (_.disabled = G._f.disabled || w, Array.isArray(G._f.refs) && G._f.refs.forEach((J) => {
        J.disabled = G._f.disabled || w;
      }));
    }, 0, !1));
  }, Ze = (w, _) => async ($) => {
    let G;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let J = xt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: z } = await Q();
      r.errors = R, J = z;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Jn(J, R, void 0);
    if (yt(r.errors, "root"), Pt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(J, $);
      } catch (R) {
        G = R;
      }
    } else
      _ && await _({ ...r.errors }, $), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Pt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (w, _ = {}) => {
    Je(i, w) && (at(_.defaultValue) ? le(w, xt(Je(a, w))) : (le(w, _.defaultValue), Jn(a, w, xt(_.defaultValue))), _.keepTouched || yt(r.touchedFields, w), _.keepDirty || (yt(r.dirtyFields, w), r.isDirty = _.defaultValue ? O(w, xt(Je(a, w))) : O()), _.keepError || (yt(r.errors, w), u.isValid && C()), h.state.next({ ...r }));
  }, he = (w, _ = {}) => {
    const $ = w ? xt(w) : a, G = xt($), J = Pt(w), R = J ? a : G;
    if (_.keepDefaultValues || (a = $), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Da(a, o))
        ]);
        for (const re of Array.from(z))
          Je(r.dirtyFields, re) ? Jn(R, re, Je(o, re)) : le(re, Je(R, re));
      } else {
        if (zp && at(w))
          for (const z of l.mount) {
            const re = Je(i, z);
            if (re && re._f) {
              const fe = Array.isArray(re._f.refs) ? re._f.refs[0] : re._f.ref;
              if (Is(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Je(R, z));
      }
      o = xt(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Xr(w, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Da(a, o) : r.dirtyFields : _.keepDefaultValues && w ? Da(a, w) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ee = (w, _) => he(kr(w) ? w(o) : w, _), Le = (w, _ = {}) => {
    const $ = Je(i, w), G = $ && $._f;
    if (G) {
      const J = G.refs ? G.refs[0] : G.ref;
      J.focus && (J.focus(), _.shouldSelect && kr(J.select) && J.select());
    }
  }, Re = (w) => {
    r = {
      ...r,
      ...w
    };
  }, ln = {
    control: {
      register: tn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Me,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: O,
      _setValid: C,
      _setFieldArray: H,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => kr(n.defaultValues) && n.defaultValues().then((w) => {
        Ee(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: He,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: we,
    trigger: be,
    register: tn,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Fe,
    reset: Ee,
    resetField: me,
    clearErrors: Be,
    unregister: Ae,
    setError: Me,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...ln,
    formControl: ln
  };
}
function MM(e = {}) {
  const n = Ne.useRef(void 0), r = Ne.useRef(void 0), [i, a] = Ne.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: kr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: kr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : UM(e),
    formState: i
  }, e.formControl && e.defaultValues && !kr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ne.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ne.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ne.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ne.useEffect(() => {
    e.values && !Xr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ne.useEffect(() => {
    e.errors && !Pt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ne.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ne.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = kS(i, o), n.current;
}
const BM = "_settingsWrapper_1ycvy_1", qM = "_settingsWrapperHeader_1ycvy_6", HM = "_settingsWrapperContent_1ycvy_10", WM = "_settingsWrapperContentCode_1ycvy_18", KM = "_settingsWrapperContentCURL_1ycvy_26", Oa = {
  settingsWrapper: BM,
  settingsWrapperHeader: qM,
  settingsWrapperContent: HM,
  settingsWrapperContentCode: WM,
  settingsWrapperContentCURL: KM
}, GM = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = er(), { control: o } = MM({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = _S({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = tt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsx(Qe, { span: 6, children: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", className: Oa.settingsWrapper, children: [
    /* @__PURE__ */ ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Oa.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ ce.jsx(ue, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: Oa.settingsWrapperContent,
        children: [
          /* @__PURE__ */ ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ce.jsx(
            to,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ ce.jsxs("ol", { children: [
                /* @__PURE__ */ ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ ce.jsx("span", { className: Oa.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ ce.jsx(
            nb,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                lr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ ce.jsx(
            nb,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                lr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
            /* @__PURE__ */ ce.jsx(Pn, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Oa.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ ce.jsx(
              Ke,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ ce.jsx(
                  Kn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, YM = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], JM = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
], QM = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: GM
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], XM = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, ZM = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, e4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: nV,
  featureSettings: []
} : n ? {
  authSettings: tV,
  featureSettings: [...Wx]
} : e ? {
  authSettings: [
    ...fk,
    ...ZL
  ],
  featureSettings: [...hk]
} : {
  authSettings: [
    ...fk,
    ...eV
  ],
  featureSettings: [...hk]
}, FS = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, n4 = FS(
  JM,
  QM
), t4 = FS(
  _$,
  x$
), IS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = ZM(a?.value, r), s = i !== void 0 ? i : XM(
    r
  );
  return o !== void 0 ? o : s;
}, Hp = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = e4(n), s = n4(r), l = t4(i);
  return {
    SHOPIFY: {
      widget: a3,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: aT,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...Kg ? [...Kg] : []
      ]
    },
    GITHUB: {
      widget: p1,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...f1]
    },
    MIUROS: {
      widget: fL,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...hL]
    },
    KLAVIYO: {
      widget: k$,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...b$]
    },
    LINEAR: {
      widget: KA,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...GA]
    },
    VOYADO: {
      widget: tM,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...rM]
    },
    LOYALTYLION: {
      widget: j2,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...w2]
    },
    RECHARGE: {
      widget: zL,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...UL]
    },
    BRAZE: {
      widget: Nw,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...jw]
    },
    YOTPO: {
      widget: xM,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...YM]
    },
    INGRID: {
      widget: OI,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...PI],
      WidgetSettings: LI
    }
  };
}, r4 = (e) => {
  const n = Hp();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      integrationKey: l
    }) => {
      const m = n[i], { settingsConfiguration: u } = m, f = u?.filter(({ secret: h }) => !h)?.map(
        ({
          key: h,
          type: v,
          defaultValue: F
        }) => ({
          key: h,
          value: IS({
            key: h,
            configuration: o,
            settingType: v,
            settingDefault: F
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: f,
        misconfigured: s,
        icon: m.icon,
        iconColors: m.iconColors,
        widget: m.widget,
        integrationKey: l
      };
    }
  );
}, X4 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d
}) => {
  const m = di(
    {}
  ), u = (T) => (m.current[T] || (m.current[T] = { current: null }), m.current[T]), { track: f } = bn(), h = qn(
    () => r4(e),
    [e]
  ), v = {
    headline: "",
    text: "",
    onConfirm: () => H(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [F, S] = se(v), [N, C] = se(!1), y = (T) => {
    C(!0), S(T);
  }, H = () => {
    C(!1), S(v);
  };
  return /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    h.map(
      ({
        id: T,
        name: E,
        type: D,
        widget: U,
        settings: Z,
        misconfigured: Q,
        icon: ie,
        iconColors: Y,
        integrationKey: M
      }, O) => {
        const q = `partner-integration-${D}`, ee = /* @__PURE__ */ ze.jsx($m, { icon: ie, color: Y }), ge = Z?.reduce(
          (de, le) => (de[le.key] = le.value, de),
          {}
        );
        return s ? /* @__PURE__ */ ze.jsx("div", { className: "icon-holder", children: ee }, `partner-icon-${T}`) : /* @__PURE__ */ ze.jsxs(
          sr,
          {
            onToggle: () => {
              f(
                o(M) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: T,
                  widgetType: D.toLowerCase()
                }
              ), a(M);
            },
            isOpen: o(M),
            className: q,
            containerRef: (de) => {
              u(M).current = de;
            },
            children: [
              /* @__PURE__ */ ze.jsx(
                sr.Header,
                {
                  wrap: "normal",
                  avatar: ee,
                  slotBeforeTitle: d?.(
                    M,
                    O,
                    u(M)
                  ),
                  slotAfterTitle: l?.(M),
                  children: E
                }
              ),
              /* @__PURE__ */ ze.jsx(sr.Content, { children: Q ? /* @__PURE__ */ ze.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ ze.jsx(
                wb.Provider,
                {
                  value: {
                    onError: (de, le) => console.warn(
                      `Something went wrong with a partner widget of type '${D}' and id '${T}'`,
                      de,
                      le
                    )
                  },
                  children: /* @__PURE__ */ ze.jsx(
                    o_,
                    {
                      integrationId: T,
                      type: D,
                      configuration: n,
                      showNotification: i,
                      showModal: y,
                      children: r0(U, {
                        conversationContext: r,
                        settings: ge
                      })
                    }
                  )
                }
              ) })
            ]
          },
          M
        );
      }
    ),
    /* @__PURE__ */ ze.jsx(
      Nb,
      {
        isOpen: N,
        setIsOpen: C,
        headline: F.headline,
        text: F.text,
        confirmLabel: F.confirmLabel,
        confirmVariant: F.confirmVariant,
        cancelLabel: F.cancelLabel,
        cancelVariant: F.cancelVariant,
        onConfirm: F.onConfirm ? () => {
          try {
            F.onConfirm && F.onConfirm();
          } finally {
            C(!1), S(v);
          }
        } : void 0,
        onCancel: F.onCancel ? () => {
          try {
            F.onCancel && F.onCancel();
          } finally {
            C(!1), S(v);
          }
        } : void 0,
        children: F.children
      }
    )
  ] });
}, i4 = Rs`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function Z4(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return qe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), a_(e).query({
      query: i4
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const a4 = ({
  widgetConfiguration: e
}) => {
  const n = qn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = qn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, o4 = "FULL_ACCESS", s4 = "2", l4 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [o4],
        version: s4
      })
    }).then((l) => l.json())
  };
}, c4 = "dixaApiToken", Wp = "dixaApiTokenId", ES = "dixaApiTokenName", pb = (e) => [Wp, ES].every(
  (r) => e.find((i) => i?.key === r)
);
function d4({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = u4(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const u4 = (e) => [
  {
    key: c4,
    value: e.value,
    secret: !0
  },
  {
    key: Wp,
    value: e.id,
    secret: !1
  },
  {
    key: ES,
    value: e.name,
    secret: !1
  }
], m4 = "_wrapper_1lmim_1", p4 = "_wrapperBox_1lmim_4", f4 = "_wrapperBoxErrorBorder_1lmim_9", Wu = {
  wrapper: m4,
  wrapperBox: p4,
  wrapperBoxErrorBorder: f4
}, h4 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (H) => H.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, F = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${v.label.toLowerCase()}`, [N, C] = se({
    username: "",
    password: ""
  }), y = tt(
    (H) => {
      m({
        target: {
          name: s,
          value: H
        }
      });
    },
    [s, m]
  );
  return qe(() => {
    y(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ ze.jsx(
    Pn,
    {
      required: e,
      label: a,
      meta: l,
      className: Wu.wrapper,
      children: /* @__PURE__ */ ze.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: ut(Wu.wrapperBox, {
            [Wu.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ ze.jsx(
              lr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: F,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (H) => C({
                    username: H?.target.value ?? "",
                    password: N.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ ze.jsx(
              lr,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (H) => C({
                    username: N.username,
                    password: H?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function fb({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: F,
  prefix: S,
  integrationId: N,
  integrationType: C,
  configuration: y,
  settings: H,
  otherProps: T
}) {
  const E = v === "custom" && T?.component, D = u(n)?.value;
  return E ? /* @__PURE__ */ ze.jsx(
    E,
    {
      configuration: y,
      integrationId: N,
      integrationType: C,
      label: r,
      settings: H,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    /* @__PURE__ */ ze.jsx(Qe, { span: 3, children: /* @__PURE__ */ ze.jsx(
      y4,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: F,
        children: v === "input" ? /* @__PURE__ */ ze.jsx(
          lr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: D,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !F && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ ze.jsx(
          h4,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: F,
            label: r,
            widgetSettingsKey: n,
            settings: H,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ ze.jsx(Pn, { label: r, children: /* @__PURE__ */ ze.jsx(
          Cb,
          {
            input: {
              name: n,
              value: "",
              checked: D,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ ze.jsx(Pn, { label: r, children: /* @__PURE__ */ ze.jsx(
          Yr,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ ze.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {}),
            value: D ? [
              {
                label: (T?.selectItems || []).find(
                  (U) => U.value === D
                )?.label,
                value: D
              }
            ] : [],
            equalityFn: (U, Z) => U.value === Z.value,
            children: (T?.selectItems || []).map((U) => /* @__PURE__ */ ze.jsx(ot.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ ze.jsx(Qe, { span: 3 })
  ] });
}
function y4({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ ze.jsx(Pn, { label: n, children: /* @__PURE__ */ ze.jsxs(
    Kn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ja = "partner-integrations-widget-name-form-field", hb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: IS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), g4 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = (T) => i(T), l = (T) => !T || T === "", d = (T) => {
    const { [T]: E, ...D } = a;
    o(D);
  }, m = (T) => ({
    ...T,
    settings: T.settings.filter(({ isEditing: E }) => E).map(({ key: E, value: D, secret: U }) => ({
      key: E,
      value: D,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, value: D }
    } = T;
    a[E] && !l(D) && d(E), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === E ? { ...U, value: D } : U
      )
    });
  }, h = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, checked: D }
    } = T;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === E ? { ...U, value: D } : U
      )
    });
  }, v = (T, E) => {
    if (!E)
      return;
    const { selectedValues: D } = E, U = D?.[0];
    if (U) {
      const Z = r.settings.map(
        (Q) => Q.key === T ? { ...Q, value: U?.value } : Q
      );
      i({
        ...r,
        settings: Z
      });
    } else {
      const Z = r.settings.filter(
        (Q) => Q.key !== T
      );
      i({
        ...r,
        settings: Z
      });
    }
  }, F = (T) => {
    i({
      ...r,
      enabled: T
    });
  }, S = (T) => {
    if (!T)
      return;
    const {
      target: { value: E }
    } = T;
    a[Ja] && !l(E) && d(Ja), i({
      ...r,
      name: E
    });
  }, N = (T, E) => {
    const { settings: D } = r, U = D.map((Z) => Z.key === E ? {
      ...Z,
      isEditing: T,
      ...!T && { value: "" }
    } : Z);
    a[E] && !T && d(E), i({
      ...r,
      settings: U
    });
  }, C = (T) => r.settings.find(
    (E) => E.key === T
  ), y = async (T) => {
    T.preventDefault(), H() && n(m(r));
  }, H = () => {
    const T = {}, { name: E, settings: D } = r;
    return l(E) && (T[Ja] = u.input), D.forEach(
      ({ key: U, value: Z, required: Q, isEditing: ie, type: Y, customValidation: M }) => {
        if (Q && ie)
          if (M) {
            const O = M(Z);
            typeof O == "string" && (T[U] = O);
          } else
            typeof Z == "string" && l(Z) && (T[U] = u[Y]);
      }
    ), o(T), !Object.keys(T)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: F,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: N,
    handleChangeName: S,
    handleSubmit: y,
    getSettingValueByKey: C,
    initializeFormData: s,
    validate: H
  };
}, v4 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], yb = "The configuration of the integration is not correct. Please check the settings.", k4 = (e) => {
  const n = Hp()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ ze.jsx(n, { ...e }) : /* @__PURE__ */ ze.jsx(b4, { ...e });
}, b4 = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = bn(), { deleteDixaApiToken: l, createDixaApiToken: d } = l4({
    type: n,
    baseUrl: a.baseUrl
  }), u = _0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = v4.includes(n), [v, F] = se(), [S, N] = se(!1), [C, y] = se(!1), [H, T] = se(!1), [E, D] = se(null), [U, Z] = se(), { isInboundOAuth: Q } = JS(), ie = Q && f ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: Y,
    isShopifyMarketplaceApp: M,
    initialValuesForShopify: O
  } = a4({
    featureFlags: a.featureFlags,
    widgetConfiguration: U
  }), q = n === "YOTPO" && !!U?.additionalProperties?.isUsingOAuth, ee = n === "KLAVIYO" && !!U?.additionalProperties?.isUsingOAuth, ge = f && n === "SHOPIFY", pe = Hp({
    SHOPIFY: {
      hasShopifyOAuth: Y,
      isShopifyMarketplaceApp: M,
      isCreationMode: f
    },
    YOTPO: {
      hasOAuth: q,
      isCreationMode: f
    },
    KLAVIYO: {
      hasOAuth: ee,
      isCreationMode: f
    }
  })[n].settingsConfiguration, W = pe.filter(({ type: w }) => w !== "hidden").filter(({ hideOnCreate: w }) => f ? !w : !0), be = W.filter(
    ({ additionalProperties: w }) => w?.renderAboveForm === !0
  ), Fe = W.filter(
    ({ additionalProperties: w }) => w?.renderAboveForm !== !0
  ), {
    error: K,
    loading: Be,
    refetch: Me
  } = Ib(_b, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (w) => {
      if (Object.keys(w).length === 0)
        T(!0);
      else {
        T(!1);
        const _ = w?.Management?.widgetConfigurations?.[0];
        _ && Z({
          ..._,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${_.id}`,
          additionalProperties: _.additionalProperties ?? void 0
        });
      }
    }
  }), [Pe, { error: Ue }] = Yp(
    f ? QS : XS,
    {
      onError: (w) => {
        F(w), N(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (w) => {
        if (N(!1), Object.keys(w).length !== 0) {
          if (f && r(
            w.Management?.createWidgetConfiguration?.id
          ), !f) {
            const $ = w.Management?.updateWidgetConfiguration;
            $?.misconfigured ? D(
              $.misconfigurationCause ?? yb
            ) : D(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [we] = Yp(ZS, {
    onError: (w) => {
      F(w), N(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      N(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ae,
    handleIsEnabled: $e,
    errors: tn,
    handleChangeText: Ce,
    handleChangeBoolean: He,
    handleChangeSelect: Ze,
    handleEditSecret: me,
    handleChangeName: he,
    handleSubmit: Ee,
    getSettingValueByKey: Le,
    initializeFormData: Re
  } = g4({
    onSubmit: async (w) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), N(!0);
      const _ = w.settings.map(
        (R) => typeof R.value == "boolean" ? { ...R, value: R.value.toString() } : R
      ), $ = pb(_) && f;
      let G = [];
      if ($) {
        const R = await d().catch(
          (z) => {
            N(!1), console.warn("API-Token (creation) error resonse", z), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        R?.data && (G = d4({
          token: R.data,
          settings: _
        }));
      }
      const J = {
        ...w,
        settings: [
          ...G.length > 0 ? G : _
        ]
      };
      ($ && G.length > 1 || !$ && G.length === 0) && (Pe({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...J
        }
      }), _.forEach(
        (R) => R.secret && me(!1, R.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: hb({
          settingsFromBackend: O,
          settingsConfiguration: pe,
          creating: !0
        })
      }
    }
  });
  qe(() => {
    if (U) {
      const w = hb({
        settingsFromBackend: U.settings,
        settingsConfiguration: pe
      });
      Re({
        enabled: !!U.enabled,
        name: U.name,
        settings: w
      }), U.misconfigured ? D(
        U?.misconfigurationCause ?? yb
      ) : D(null);
    }
  }, [U]);
  const ln = qn(() => o ? !o.isCoupled : !0, [o]);
  return K || Ue || v ? /* @__PURE__ */ ze.jsx(
    Fn,
    {
      error: K || v,
      retry: K ? Me : void 0
    }
  ) : S || Be ? /* @__PURE__ */ ze.jsx(sn, { "data-testid": "widget-settings-loading" }) : H ? /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ ze.jsx(An, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ ze.jsxs("form", { children: [
    E && /* @__PURE__ */ ze.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ze.jsx(
      to,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ ze.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ ze.jsx(A.Paragraph, { children: E }),
          /* @__PURE__ */ ze.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ ze.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ ze.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ ze.jsxs(
      Et,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          be.map(
            ({ key: w, label: _, ...$ }) => /* @__PURE__ */ ze.jsx(
              fb,
              {
                widgetSettingsKey: w,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Le,
                isSecret: !1,
                label: _,
                placeholder: "",
                required: !1,
                errors: tn,
                type: "custom",
                isCreationMode: f,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: pe,
                otherProps: $
              },
              w
            )
          ),
          !ge && /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
            /* @__PURE__ */ ze.jsx(Qe, { children: /* @__PURE__ */ ze.jsx(Pn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ze.jsx(
              Cb,
              {
                input: {
                  name: "enabled",
                  checked: Ae.enabled,
                  value: "dummy",
                  onChange: (w) => $e(w.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ ze.jsx(Qe, { span: 3, children: /* @__PURE__ */ ze.jsx(
              lr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ja,
                  value: Ae.name,
                  onChange: he
                },
                meta: {
                  error: tn[Ja]
                }
              }
            ) }),
            /* @__PURE__ */ ze.jsx(Qe, { span: 3 })
          ] }),
          Fe?.map(
            ({
              key: w,
              secret: _,
              label: $,
              placeholder: G = "",
              required: J = !1,
              type: R,
              prefix: z,
              readOnly: re,
              ...fe
            }) => {
              const { settings: _e } = Ae, en = _e.find(
                (un) => un.key === w
              );
              return /* @__PURE__ */ ze.jsx(i0, { children: /* @__PURE__ */ ze.jsx(
                fb,
                {
                  widgetSettingsKey: w,
                  isEditingField: !!en?.isEditing,
                  handleEditSecret: me,
                  handleChangeText: Ce,
                  handleChangeBoolean: He,
                  handleChangeSelect: Ze,
                  getValueByKey: Le,
                  isSecret: _,
                  label: $,
                  placeholder: G,
                  required: J,
                  errors: tn,
                  type: R,
                  isCreationMode: f,
                  prefix: z,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: re,
                  settings: pe,
                  otherProps: fe
                }
              ) }, w);
            }
          )
        ]
      }
    ),
    !ge && /* @__PURE__ */ ze.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ ze.jsx(Kn, { onClick: Ee, children: ie }),
      !f && /* @__PURE__ */ ze.jsx(
        Ke,
        {
          content: "The widget is used in automations",
          disabled: ln,
          children: /* @__PURE__ */ ze.jsx(
            Kn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), y(!0);
              },
              disabled: !ln,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ ze.jsx(
      Nb,
      {
        isOpen: C,
        setIsOpen: y,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), pb(Ae.settings)) {
            const w = Ae.settings.find(
              ({ key: _ }) => _ === Wp
            )?.value;
            w && l(w).catch((_) => {
              console.warn("API-Token (deletion) error response", _), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          we({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ ze.jsx(b, { children: h ? /* @__PURE__ */ ze.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ ze.jsx(
            ue,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ ze.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ ze.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ae.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ae.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, eB = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ ze.jsx(
  wb.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ ze.jsx(
      o_,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ ze.jsx(
          k4,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
), gb = "__PairingContext__", TS = globalThis[gb] ?? (() => {
  const e = jb({});
  return globalThis[gb] = e, e;
})(), nB = () => Em(TS), tB = ({
  value: e,
  children: n
}) => /* @__PURE__ */ ze.jsx(TS.Provider, { value: e, children: n });
var Wo = { exports: {} }, vb;
function _4() {
  if (vb) return Wo.exports;
  vb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(E, D, U) {
    return Function.prototype.apply.call(E, D, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : r = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function i(T) {
    console && console.warn && console.warn(T);
  }
  var a = Number.isNaN || function(E) {
    return E !== E;
  };
  function o() {
    o.init.call(this);
  }
  Wo.exports = o, Wo.exports.once = C, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(T) {
      if (typeof T != "number" || T < 0 || a(T))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
      s = T;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || a(E))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function d(T) {
    return T._maxListeners === void 0 ? o.defaultMaxListeners : T._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(E) {
    for (var D = [], U = 1; U < arguments.length; U++) D.push(arguments[U]);
    var Z = E === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ie;
      if (D.length > 0 && (ie = D[0]), ie instanceof Error)
        throw ie;
      var Y = new Error("Unhandled error." + (ie ? " (" + ie.message + ")" : ""));
      throw Y.context = ie, Y;
    }
    var M = Q[E];
    if (M === void 0)
      return !1;
    if (typeof M == "function")
      n(M, this, D);
    else
      for (var O = M.length, q = F(M, O), U = 0; U < O; ++U)
        n(q[U], this, D);
    return !0;
  };
  function m(T, E, D, U) {
    var Z, Q, ie;
    if (l(D), Q = T._events, Q === void 0 ? (Q = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (Q.newListener !== void 0 && (T.emit(
      "newListener",
      E,
      D.listener ? D.listener : D
    ), Q = T._events), ie = Q[E]), ie === void 0)
      ie = Q[E] = D, ++T._eventsCount;
    else if (typeof ie == "function" ? ie = Q[E] = U ? [D, ie] : [ie, D] : U ? ie.unshift(D) : ie.push(D), Z = d(T), Z > 0 && ie.length > Z && !ie.warned) {
      ie.warned = !0;
      var Y = new Error("Possible EventEmitter memory leak detected. " + ie.length + " " + String(E) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Y.name = "MaxListenersExceededWarning", Y.emitter = T, Y.type = E, Y.count = ie.length, i(Y);
    }
    return T;
  }
  o.prototype.addListener = function(E, D) {
    return m(this, E, D, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(E, D) {
    return m(this, E, D, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(T, E, D) {
    var U = { fired: !1, wrapFn: void 0, target: T, type: E, listener: D }, Z = u.bind(U);
    return Z.listener = D, U.wrapFn = Z, Z;
  }
  o.prototype.once = function(E, D) {
    return l(D), this.on(E, f(this, E, D)), this;
  }, o.prototype.prependOnceListener = function(E, D) {
    return l(D), this.prependListener(E, f(this, E, D)), this;
  }, o.prototype.removeListener = function(E, D) {
    var U, Z, Q, ie, Y;
    if (l(D), Z = this._events, Z === void 0)
      return this;
    if (U = Z[E], U === void 0)
      return this;
    if (U === D || U.listener === D)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[E], Z.removeListener && this.emit("removeListener", E, U.listener || D));
    else if (typeof U != "function") {
      for (Q = -1, ie = U.length - 1; ie >= 0; ie--)
        if (U[ie] === D || U[ie].listener === D) {
          Y = U[ie].listener, Q = ie;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? U.shift() : S(U, Q), U.length === 1 && (Z[E] = U[0]), Z.removeListener !== void 0 && this.emit("removeListener", E, Y || D);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(E) {
    var D, U, Z;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[E]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(U), ie;
      for (Z = 0; Z < Q.length; ++Z)
        ie = Q[Z], ie !== "removeListener" && this.removeAllListeners(ie);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (D = U[E], typeof D == "function")
      this.removeListener(E, D);
    else if (D !== void 0)
      for (Z = D.length - 1; Z >= 0; Z--)
        this.removeListener(E, D[Z]);
    return this;
  };
  function h(T, E, D) {
    var U = T._events;
    if (U === void 0)
      return [];
    var Z = U[E];
    return Z === void 0 ? [] : typeof Z == "function" ? D ? [Z.listener || Z] : [Z] : D ? N(Z) : F(Z, Z.length);
  }
  o.prototype.listeners = function(E) {
    return h(this, E, !0);
  }, o.prototype.rawListeners = function(E) {
    return h(this, E, !1);
  }, o.listenerCount = function(T, E) {
    return typeof T.listenerCount == "function" ? T.listenerCount(E) : v.call(T, E);
  }, o.prototype.listenerCount = v;
  function v(T) {
    var E = this._events;
    if (E !== void 0) {
      var D = E[T];
      if (typeof D == "function")
        return 1;
      if (D !== void 0)
        return D.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function F(T, E) {
    for (var D = new Array(E), U = 0; U < E; ++U)
      D[U] = T[U];
    return D;
  }
  function S(T, E) {
    for (; E + 1 < T.length; E++)
      T[E] = T[E + 1];
    T.pop();
  }
  function N(T) {
    for (var E = new Array(T.length), D = 0; D < E.length; ++D)
      E[D] = T[D].listener || T[D];
    return E;
  }
  function C(T, E) {
    return new Promise(function(D, U) {
      function Z(ie) {
        T.removeListener(E, Q), U(ie);
      }
      function Q() {
        typeof T.removeListener == "function" && T.removeListener("error", Z), D([].slice.call(arguments));
      }
      H(T, E, Q, { once: !0 }), E !== "error" && y(T, Z, { once: !0 });
    });
  }
  function y(T, E, D) {
    typeof T.on == "function" && H(T, "error", E, D);
  }
  function H(T, E, D, U) {
    if (typeof T.on == "function")
      U.once ? T.once(E, D) : T.on(E, D);
    else if (typeof T.addEventListener == "function")
      T.addEventListener(E, function Z(Q) {
        U.once && T.removeEventListener(E, Z), D(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
  }
  return Wo.exports;
}
var x4 = _4();
function rB() {
  const e = new x4.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  Kj as GraphQLClientProvider,
  TS as PairingContext,
  tB as PairingProvider,
  X4 as PartnerIntegrations,
  eB as PartnerIntegrationsSettings,
  Hp as getWidgetDefinitions,
  rB as initializePartnerEventEmitter,
  nB as usePairing,
  Z4 as usePartnerIntegrationWidgetConfigurations,
  a4 as useShopifyConfiguration
};
